// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "/api";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }
  // need to use the urlBase as the base to handle multiple
  // loopback servers behind a proxy/gateway where the host
  // would be the same.
  var urlBaseHost = getHost(urlBase) ? urlBase : location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.SegaUser
 * @header lbServices.SegaUser
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `SegaUser` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "SegaUser",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/SegaUsers/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__findById__accessTokens
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Find a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "prototype$__findById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SegaUsers/:id/accessTokens/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__destroyById__accessTokens
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Delete a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SegaUsers/:id/accessTokens/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__updateById__accessTokens
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Update a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "prototype$__updateById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SegaUsers/:id/accessTokens/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__findById__roles
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Find a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "prototype$__findById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SegaUsers/:id/roles/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__destroyById__roles
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Delete a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SegaUsers/:id/roles/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__updateById__roles
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Update a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "prototype$__updateById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SegaUsers/:id/roles/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__link__roles
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Add a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "prototype$__link__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SegaUsers/:id/roles/rel/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__unlink__roles
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Remove the roles relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__unlink__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SegaUsers/:id/roles/rel/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__exists__roles
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Check the existence of roles relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "prototype$__exists__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SegaUsers/:id/roles/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use SegaUser.employee() instead.
            "prototype$__get__employee": {
              url: urlBase + "/SegaUsers/:id/employee",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__get__accessTokens
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Queries accessTokens of SegaUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "prototype$__get__accessTokens": {
              isArray: true,
              url: urlBase + "/SegaUsers/:id/accessTokens",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__create__accessTokens
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Creates a new instance in accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "prototype$__create__accessTokens": {
              url: urlBase + "/SegaUsers/:id/accessTokens",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__delete__accessTokens
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Deletes all accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__accessTokens": {
              url: urlBase + "/SegaUsers/:id/accessTokens",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__count__accessTokens
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Counts accessTokens of SegaUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__accessTokens": {
              url: urlBase + "/SegaUsers/:id/accessTokens/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__get__roles
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Queries roles of SegaUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "prototype$__get__roles": {
              isArray: true,
              url: urlBase + "/SegaUsers/:id/roles",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__create__roles
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Creates a new instance in roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "prototype$__create__roles": {
              url: urlBase + "/SegaUsers/:id/roles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__delete__roles
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Deletes all roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__roles": {
              url: urlBase + "/SegaUsers/:id/roles",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$__count__roles
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Counts roles of SegaUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__roles": {
              url: urlBase + "/SegaUsers/:id/roles/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#create
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/SegaUsers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#patchOrCreate
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/SegaUsers",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#replaceOrCreate
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/SegaUsers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#upsertWithWhere
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/SegaUsers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#exists
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/SegaUsers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#findById
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/SegaUsers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#replaceById
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/SegaUsers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#find
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/SegaUsers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#findOne
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/SegaUsers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#updateAll
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/SegaUsers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#deleteById
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/SegaUsers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#count
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/SegaUsers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$patchAttributes
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/SegaUsers/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#createChangeStream
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/SegaUsers/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#login
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `U+007BUserU+007D` - Data of the currently logged in user. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/SegaUsers/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#logout
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/SegaUsers/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$verify
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Trigger user's identity verification with configured verifyOptions
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `verifyOptions` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$verify": {
              url: urlBase + "/SegaUsers/:id/verify",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#confirm
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Confirm a user registration with identity verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/SegaUsers/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#resetPassword
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/SegaUsers/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#changePassword
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Change a user's password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `oldPassword` – `{string}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePassword": {
              url: urlBase + "/SegaUsers/change-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#setPassword
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Reset user's password via a password-reset token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "setPassword": {
              url: urlBase + "/SegaUsers/reset-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#invite
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Creates an invite for a new user
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` - User email
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "invite": {
              url: urlBase + "/SegaUsers/invite",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#isInviteValid
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Checks whether invite token is valid.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `token` – `{string}` - Invite token
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Invite instance
             */
            "isInviteValid": {
              url: urlBase + "/SegaUsers/isInviteValid",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#signup
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Sign ups a new user
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `password` – `{string}` - Password
             *
             *  - `inviteId` – `{number}` - Invite id
             *
             *  - `token` – `{string}` - Invite token
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * User just created
             */
            "signup": {
              url: urlBase + "/SegaUsers/signup",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#updatePassword
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Update password (when lost or forgotten)
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `newPassword` – `{string}` - New password to be set
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "updatePassword": {
              url: urlBase + "/SegaUsers/updatePassword",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#getAllRoles
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Returns all roles
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Roles
             */
            "getAllRoles": {
              isArray: true,
              url: urlBase + "/SegaUsers/getAllRoles",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#addRole
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Add role to user
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userId` – `{number}` - User id
             *
             *  - `roleId` – `{number}` - Role id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "addRole": {
              url: urlBase + "/SegaUsers/addRole",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#removeRole
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Remove role from user
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userId` – `{number}` - User id
             *
             *  - `roleId` – `{number}` - Role id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "removeRole": {
              url: urlBase + "/SegaUsers/removeRole",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#createMany
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/SegaUsers",
              method: "POST",
            },

            // INTERNAL. Use Client.createdByUser() instead.
            "::get::Client::createdByUser": {
              url: urlBase + "/Clients/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Client.createManydByUser() instead.
            "::get::Client::createManydByUser": {
              isArray: true,
              url: urlBase + "/Clients/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Client.updatedByUser() instead.
            "::get::Client::updatedByUser": {
              url: urlBase + "/Clients/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use Employee.segaUser() instead.
            "::get::Employee::segaUser": {
              url: urlBase + "/Employees/:id/segaUser",
              method: "GET",
            },

            // INTERNAL. Use Employee.segaUser.create() instead.
            "::create::Employee::segaUser": {
              url: urlBase + "/Employees/:id/segaUser",
              method: "POST",
            },

            // INTERNAL. Use Employee.segaUser.createMany() instead.
            "::createMany::Employee::segaUser": {
              isArray: true,
              url: urlBase + "/Employees/:id/segaUser",
              method: "POST",
            },

            // INTERNAL. Use Employee.segaUser.update() instead.
            "::update::Employee::segaUser": {
              url: urlBase + "/Employees/:id/segaUser",
              method: "PUT",
            },

            // INTERNAL. Use Employee.segaUser.destroy() instead.
            "::destroy::Employee::segaUser": {
              url: urlBase + "/Employees/:id/segaUser",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.createdByUser() instead.
            "::get::Receipt::createdByUser": {
              url: urlBase + "/Receipts/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Receipt.createManydByUser() instead.
            "::get::Receipt::createManydByUser": {
              isArray: true,
              url: urlBase + "/Receipts/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Receipt.updatedByUser() instead.
            "::get::Receipt::updatedByUser": {
              url: urlBase + "/Receipts/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.createdByUser() instead.
            "::get::Vehicle::createdByUser": {
              url: urlBase + "/Vehicles/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.createManydByUser() instead.
            "::get::Vehicle::createManydByUser": {
              isArray: true,
              url: urlBase + "/Vehicles/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.updatedByUser() instead.
            "::get::Vehicle::updatedByUser": {
              url: urlBase + "/Vehicles/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use Quote.createdByUser() instead.
            "::get::Quote::createdByUser": {
              url: urlBase + "/Quotes/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Quote.createManydByUser() instead.
            "::get::Quote::createManydByUser": {
              isArray: true,
              url: urlBase + "/Quotes/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Quote.updatedByUser() instead.
            "::get::Quote::updatedByUser": {
              url: urlBase + "/Quotes/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.createdByUser() instead.
            "::get::OperativeSpending::createdByUser": {
              url: urlBase + "/OperativeSpendings/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.createManydByUser() instead.
            "::get::OperativeSpending::createManydByUser": {
              isArray: true,
              url: urlBase + "/OperativeSpendings/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.updatedByUser() instead.
            "::get::OperativeSpending::updatedByUser": {
              url: urlBase + "/OperativeSpendings/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use Voucher.createdByUser() instead.
            "::get::Voucher::createdByUser": {
              url: urlBase + "/Vouchers/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Voucher.createManydByUser() instead.
            "::get::Voucher::createManydByUser": {
              isArray: true,
              url: urlBase + "/Vouchers/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Voucher.updatedByUser() instead.
            "::get::Voucher::updatedByUser": {
              url: urlBase + "/Vouchers/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedureHistory.updatedByUser() instead.
            "::get::OperationProcedureHistory::updatedByUser": {
              url: urlBase + "/OperationProcedureHistories/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedureHistory.createdByUser() instead.
            "::get::OperationProcedureHistory::createdByUser": {
              url: urlBase + "/OperationProcedureHistories/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedureHistory.createManydByUser() instead.
            "::get::OperationProcedureHistory::createManydByUser": {
              isArray: true,
              url: urlBase + "/OperationProcedureHistories/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Operation.createdByUser() instead.
            "::get::Operation::createdByUser": {
              url: urlBase + "/Operations/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Operation.createManydByUser() instead.
            "::get::Operation::createManydByUser": {
              isArray: true,
              url: urlBase + "/Operations/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Operation.updatedByUser() instead.
            "::get::Operation::updatedByUser": {
              url: urlBase + "/Operations/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use OperationComment.createdByUser() instead.
            "::get::OperationComment::createdByUser": {
              url: urlBase + "/OperationComments/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use OperationComment.createManydByUser() instead.
            "::get::OperationComment::createManydByUser": {
              isArray: true,
              url: urlBase + "/OperationComments/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use OperationComment.updatedByUser() instead.
            "::get::OperationComment::updatedByUser": {
              url: urlBase + "/OperationComments/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use Assignation.createdByUser() instead.
            "::get::Assignation::createdByUser": {
              url: urlBase + "/Assignations/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Assignation.createManydByUser() instead.
            "::get::Assignation::createManydByUser": {
              isArray: true,
              url: urlBase + "/Assignations/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Assignation.updatedByUser() instead.
            "::get::Assignation::updatedByUser": {
              url: urlBase + "/Assignations/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use Cronology.createdByUser() instead.
            "::get::Cronology::createdByUser": {
              url: urlBase + "/Cronologies/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Cronology.createManydByUser() instead.
            "::get::Cronology::createManydByUser": {
              isArray: true,
              url: urlBase + "/Cronologies/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Task.createdByUser() instead.
            "::get::Task::createdByUser": {
              url: urlBase + "/Tasks/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Task.createManydByUser() instead.
            "::get::Task::createManydByUser": {
              isArray: true,
              url: urlBase + "/Tasks/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Task.updatedByUser() instead.
            "::get::Task::updatedByUser": {
              url: urlBase + "/Tasks/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use Task.completedByUser() instead.
            "::get::Task::completedByUser": {
              url: urlBase + "/Tasks/:id/completedByUser",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#getCurrent
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/SegaUsers" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.SegaUser#upsert
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#updateOrCreate
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#patchOrCreateWithWhere
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#update
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#destroyById
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#removeById
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SegaUser#prototype$updateAttributes
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.SegaUser#getCachedCurrent
         * @methodOf lbServices.SegaUser
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.SegaUser#login} or
         * {@link lbServices.SegaUser#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A SegaUser instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.SegaUser#isAuthenticated
         * @methodOf lbServices.SegaUser
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.SegaUser#getCurrentId
         * @methodOf lbServices.SegaUser
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.SegaUser#modelName
        * @propertyOf lbServices.SegaUser
        * @description
        * The name of the model represented by this $resource,
        * i.e. `SegaUser`.
        */
        R.modelName = "SegaUser";


            /**
             * @ngdoc method
             * @name lbServices.SegaUser#employee
             * @methodOf lbServices.SegaUser
             *
             * @description
             *
             * Fetches belongsTo relation employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SegaUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R.employee = function() {
          var TargetResource = $injector.get("Employee");
          var action = TargetResource["::get::SegaUser::employee"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Client
 * @header lbServices.Client
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Client` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Client",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Clients/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Client.createdByUser() instead.
            "prototype$__get__createdByUser": {
              url: urlBase + "/Clients/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Client.updatedByUser() instead.
            "prototype$__get__updatedByUser": {
              url: urlBase + "/Clients/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use Client.bankTxes.findById() instead.
            "prototype$__findById__bankTxes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/bankTxes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Client.bankTxes.destroyById() instead.
            "prototype$__destroyById__bankTxes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/bankTxes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Client.bankTxes.updateById() instead.
            "prototype$__updateById__bankTxes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/bankTxes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Client.procedures.findById() instead.
            "prototype$__findById__procedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/procedures/:fk",
              method: "GET",
            },

            // INTERNAL. Use Client.procedures.destroyById() instead.
            "prototype$__destroyById__procedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/procedures/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Client.procedures.updateById() instead.
            "prototype$__updateById__procedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/procedures/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Client.quotes.findById() instead.
            "prototype$__findById__quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/quotes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Client.quotes.destroyById() instead.
            "prototype$__destroyById__quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/quotes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Client.quotes.updateById() instead.
            "prototype$__updateById__quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/quotes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Client.holderQuotes.findById() instead.
            "prototype$__findById__holderQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/holderQuotes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Client.holderQuotes.destroyById() instead.
            "prototype$__destroyById__holderQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/holderQuotes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Client.holderQuotes.updateById() instead.
            "prototype$__updateById__holderQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/holderQuotes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Client.cityModel() instead.
            "prototype$__get__cityModel": {
              url: urlBase + "/Clients/:id/cityModel",
              method: "GET",
            },

            // INTERNAL. Use Client.bankTxes() instead.
            "prototype$__get__bankTxes": {
              isArray: true,
              url: urlBase + "/Clients/:id/bankTxes",
              method: "GET",
            },

            // INTERNAL. Use Client.bankTxes.create() instead.
            "prototype$__create__bankTxes": {
              url: urlBase + "/Clients/:id/bankTxes",
              method: "POST",
            },

            // INTERNAL. Use Client.bankTxes.destroyAll() instead.
            "prototype$__delete__bankTxes": {
              url: urlBase + "/Clients/:id/bankTxes",
              method: "DELETE",
            },

            // INTERNAL. Use Client.bankTxes.count() instead.
            "prototype$__count__bankTxes": {
              url: urlBase + "/Clients/:id/bankTxes/count",
              method: "GET",
            },

            // INTERNAL. Use Client.procedures() instead.
            "prototype$__get__procedures": {
              isArray: true,
              url: urlBase + "/Clients/:id/procedures",
              method: "GET",
            },

            // INTERNAL. Use Client.procedures.create() instead.
            "prototype$__create__procedures": {
              url: urlBase + "/Clients/:id/procedures",
              method: "POST",
            },

            // INTERNAL. Use Client.procedures.destroyAll() instead.
            "prototype$__delete__procedures": {
              url: urlBase + "/Clients/:id/procedures",
              method: "DELETE",
            },

            // INTERNAL. Use Client.procedures.count() instead.
            "prototype$__count__procedures": {
              url: urlBase + "/Clients/:id/procedures/count",
              method: "GET",
            },

            // INTERNAL. Use Client.quotes() instead.
            "prototype$__get__quotes": {
              isArray: true,
              url: urlBase + "/Clients/:id/quotes",
              method: "GET",
            },

            // INTERNAL. Use Client.quotes.create() instead.
            "prototype$__create__quotes": {
              url: urlBase + "/Clients/:id/quotes",
              method: "POST",
            },

            // INTERNAL. Use Client.quotes.destroyAll() instead.
            "prototype$__delete__quotes": {
              url: urlBase + "/Clients/:id/quotes",
              method: "DELETE",
            },

            // INTERNAL. Use Client.quotes.count() instead.
            "prototype$__count__quotes": {
              url: urlBase + "/Clients/:id/quotes/count",
              method: "GET",
            },

            // INTERNAL. Use Client.holderQuotes() instead.
            "prototype$__get__holderQuotes": {
              isArray: true,
              url: urlBase + "/Clients/:id/holderQuotes",
              method: "GET",
            },

            // INTERNAL. Use Client.holderQuotes.create() instead.
            "prototype$__create__holderQuotes": {
              url: urlBase + "/Clients/:id/holderQuotes",
              method: "POST",
            },

            // INTERNAL. Use Client.holderQuotes.destroyAll() instead.
            "prototype$__delete__holderQuotes": {
              url: urlBase + "/Clients/:id/holderQuotes",
              method: "DELETE",
            },

            // INTERNAL. Use Client.holderQuotes.count() instead.
            "prototype$__count__holderQuotes": {
              url: urlBase + "/Clients/:id/holderQuotes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#create
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Clients",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#patchOrCreate
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Clients",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#replaceOrCreate
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Clients/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#upsertWithWhere
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Clients/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#exists
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Clients/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#findById
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Clients/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#replaceById
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Clients/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#find
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Clients",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#findOne
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Clients/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#updateAll
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Clients/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#deleteById
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Clients/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#count
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Clients/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#prototype$patchAttributes
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Clients/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#createChangeStream
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Clients/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#createMany
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Clients",
              method: "POST",
            },

            // INTERNAL. Use BankTx.client() instead.
            "::get::BankTx::client": {
              url: urlBase + "/BankTxs/:id/client",
              method: "GET",
            },

            // INTERNAL. Use Receipt.client() instead.
            "::get::Receipt::client": {
              url: urlBase + "/Receipts/:id/client",
              method: "GET",
            },

            // INTERNAL. Use Check.client() instead.
            "::get::Check::client": {
              url: urlBase + "/Checks/:id/client",
              method: "GET",
            },

            // INTERNAL. Use Procedure.client() instead.
            "::get::Procedure::client": {
              url: urlBase + "/Procedures/:id/client",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.holder() instead.
            "::get::Vehicle::holder": {
              url: urlBase + "/Vehicles/:id/holder",
              method: "GET",
            },

            // INTERNAL. Use Quote.client() instead.
            "::get::Quote::client": {
              url: urlBase + "/Quotes/:id/client",
              method: "GET",
            },

            // INTERNAL. Use Quote.holder() instead.
            "::get::Quote::holder": {
              url: urlBase + "/Quotes/:id/holder",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.holder() instead.
            "::get::OperativeSpending::holder": {
              url: urlBase + "/OperativeSpendings/:id/holder",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.client() instead.
            "::get::GroupInvoice::client": {
              url: urlBase + "/GroupInvoices/:id/client",
              method: "GET",
            },

            // INTERNAL. Use Operation.client() instead.
            "::get::Operation::client": {
              url: urlBase + "/Operations/:id/client",
              method: "GET",
            },

            // INTERNAL. Use Operation.holder() instead.
            "::get::Operation::holder": {
              url: urlBase + "/Operations/:id/holder",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Client#upsert
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Client#updateOrCreate
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Client#patchOrCreateWithWhere
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Client#update
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Client#destroyById
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Client#removeById
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Client#prototype$updateAttributes
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Client#modelName
        * @propertyOf lbServices.Client
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Client`.
        */
        R.modelName = "Client";

    /**
     * @ngdoc object
     * @name lbServices.Client.createdByUser
     * @header lbServices.Client.createdByUser
     * @object
     * @description
     *
     * The object `Client.createdByUser` groups methods
     * manipulating `SegaUser` instances related to `Client`.
     *
     * Call {@link lbServices.Client#createdByUser Client.createdByUser()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Client#createManydByUser
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createManydByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Client::createManydByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client#createdByUser
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createdByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Client::createdByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client#updatedByUser
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Fetches belongsTo relation updatedByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.updatedByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Client::updatedByUser"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Client.bankTxes
     * @header lbServices.Client.bankTxes
     * @object
     * @description
     *
     * The object `Client.bankTxes` groups methods
     * manipulating `BankTx` instances related to `Client`.
     *
     * Call {@link lbServices.Client#bankTxes Client.bankTxes()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Client#bankTxes
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Queries bankTxes of Client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R.bankTxes = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::get::Client::bankTxes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.bankTxes#count
             * @methodOf lbServices.Client.bankTxes
             *
             * @description
             *
             * Counts bankTxes of Client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.bankTxes.count = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::count::Client::bankTxes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.bankTxes#create
             * @methodOf lbServices.Client.bankTxes
             *
             * @description
             *
             * Creates a new instance in bankTxes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R.bankTxes.create = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::create::Client::bankTxes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.bankTxes#createMany
             * @methodOf lbServices.Client.bankTxes
             *
             * @description
             *
             * Creates a new instance in bankTxes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R.bankTxes.createMany = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::createMany::Client::bankTxes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.bankTxes#destroyAll
             * @methodOf lbServices.Client.bankTxes
             *
             * @description
             *
             * Deletes all bankTxes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bankTxes.destroyAll = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::delete::Client::bankTxes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.bankTxes#destroyById
             * @methodOf lbServices.Client.bankTxes
             *
             * @description
             *
             * Delete a related item by id for bankTxes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bankTxes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bankTxes.destroyById = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::destroyById::Client::bankTxes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.bankTxes#findById
             * @methodOf lbServices.Client.bankTxes
             *
             * @description
             *
             * Find a related item by id for bankTxes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bankTxes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R.bankTxes.findById = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::findById::Client::bankTxes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.bankTxes#updateById
             * @methodOf lbServices.Client.bankTxes
             *
             * @description
             *
             * Update a related item by id for bankTxes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `fk` – `{*}` - Foreign key for bankTxes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R.bankTxes.updateById = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::updateById::Client::bankTxes"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Client.procedures
     * @header lbServices.Client.procedures
     * @object
     * @description
     *
     * The object `Client.procedures` groups methods
     * manipulating `Procedure` instances related to `Client`.
     *
     * Call {@link lbServices.Client#procedures Client.procedures()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Client#procedures
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Queries procedures of Client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R.procedures = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::get::Client::procedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.procedures#count
             * @methodOf lbServices.Client.procedures
             *
             * @description
             *
             * Counts procedures of Client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.procedures.count = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::count::Client::procedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.procedures#create
             * @methodOf lbServices.Client.procedures
             *
             * @description
             *
             * Creates a new instance in procedures of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R.procedures.create = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::create::Client::procedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.procedures#createMany
             * @methodOf lbServices.Client.procedures
             *
             * @description
             *
             * Creates a new instance in procedures of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R.procedures.createMany = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::createMany::Client::procedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.procedures#destroyAll
             * @methodOf lbServices.Client.procedures
             *
             * @description
             *
             * Deletes all procedures of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.procedures.destroyAll = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::delete::Client::procedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.procedures#destroyById
             * @methodOf lbServices.Client.procedures
             *
             * @description
             *
             * Delete a related item by id for procedures.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedures
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.procedures.destroyById = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::destroyById::Client::procedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.procedures#findById
             * @methodOf lbServices.Client.procedures
             *
             * @description
             *
             * Find a related item by id for procedures.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedures
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R.procedures.findById = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::findById::Client::procedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.procedures#updateById
             * @methodOf lbServices.Client.procedures
             *
             * @description
             *
             * Update a related item by id for procedures.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `fk` – `{*}` - Foreign key for procedures
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R.procedures.updateById = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::updateById::Client::procedures"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Client.quotes
     * @header lbServices.Client.quotes
     * @object
     * @description
     *
     * The object `Client.quotes` groups methods
     * manipulating `Quote` instances related to `Client`.
     *
     * Call {@link lbServices.Client#quotes Client.quotes()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Client#quotes
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Queries quotes of Client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::get::Client::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.quotes#count
             * @methodOf lbServices.Client.quotes
             *
             * @description
             *
             * Counts quotes of Client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.quotes.count = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::count::Client::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.quotes#create
             * @methodOf lbServices.Client.quotes
             *
             * @description
             *
             * Creates a new instance in quotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.create = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::create::Client::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.quotes#createMany
             * @methodOf lbServices.Client.quotes
             *
             * @description
             *
             * Creates a new instance in quotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.createMany = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::createMany::Client::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.quotes#destroyAll
             * @methodOf lbServices.Client.quotes
             *
             * @description
             *
             * Deletes all quotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.quotes.destroyAll = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::delete::Client::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.quotes#destroyById
             * @methodOf lbServices.Client.quotes
             *
             * @description
             *
             * Delete a related item by id for quotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for quotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.quotes.destroyById = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::destroyById::Client::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.quotes#findById
             * @methodOf lbServices.Client.quotes
             *
             * @description
             *
             * Find a related item by id for quotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for quotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.findById = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::findById::Client::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.quotes#updateById
             * @methodOf lbServices.Client.quotes
             *
             * @description
             *
             * Update a related item by id for quotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `fk` – `{*}` - Foreign key for quotes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.updateById = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::updateById::Client::quotes"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Client.holderQuotes
     * @header lbServices.Client.holderQuotes
     * @object
     * @description
     *
     * The object `Client.holderQuotes` groups methods
     * manipulating `Quote` instances related to `Client`.
     *
     * Call {@link lbServices.Client#holderQuotes Client.holderQuotes()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Client#holderQuotes
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Queries holderQuotes of Client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.holderQuotes = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::get::Client::holderQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.holderQuotes#count
             * @methodOf lbServices.Client.holderQuotes
             *
             * @description
             *
             * Counts holderQuotes of Client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.holderQuotes.count = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::count::Client::holderQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.holderQuotes#create
             * @methodOf lbServices.Client.holderQuotes
             *
             * @description
             *
             * Creates a new instance in holderQuotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.holderQuotes.create = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::create::Client::holderQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.holderQuotes#createMany
             * @methodOf lbServices.Client.holderQuotes
             *
             * @description
             *
             * Creates a new instance in holderQuotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.holderQuotes.createMany = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::createMany::Client::holderQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.holderQuotes#destroyAll
             * @methodOf lbServices.Client.holderQuotes
             *
             * @description
             *
             * Deletes all holderQuotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.holderQuotes.destroyAll = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::delete::Client::holderQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.holderQuotes#destroyById
             * @methodOf lbServices.Client.holderQuotes
             *
             * @description
             *
             * Delete a related item by id for holderQuotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for holderQuotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.holderQuotes.destroyById = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::destroyById::Client::holderQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.holderQuotes#findById
             * @methodOf lbServices.Client.holderQuotes
             *
             * @description
             *
             * Find a related item by id for holderQuotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for holderQuotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.holderQuotes.findById = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::findById::Client::holderQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.holderQuotes#updateById
             * @methodOf lbServices.Client.holderQuotes
             *
             * @description
             *
             * Update a related item by id for holderQuotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `fk` – `{*}` - Foreign key for holderQuotes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.holderQuotes.updateById = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::updateById::Client::holderQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client#cityModel
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Fetches belongsTo relation cityModel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
        R.cityModel = function() {
          var TargetResource = $injector.get("City");
          var action = TargetResource["::get::Client::cityModel"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.BankTx
 * @header lbServices.BankTx
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `BankTx` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "BankTx",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/BankTxs/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use BankTx.client() instead.
            "prototype$__get__client": {
              url: urlBase + "/BankTxs/:id/client",
              method: "GET",
            },

            // INTERNAL. Use BankTx.employee() instead.
            "prototype$__get__employee": {
              url: urlBase + "/BankTxs/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use BankTx.paymentItem() instead.
            "prototype$__get__paymentItem": {
              url: urlBase + "/BankTxs/:id/paymentItem",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#create
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/BankTxs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#patchOrCreate
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/BankTxs",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#replaceOrCreate
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/BankTxs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#upsertWithWhere
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/BankTxs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#exists
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/BankTxs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#findById
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/BankTxs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#replaceById
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/BankTxs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#find
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/BankTxs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#findOne
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/BankTxs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#updateAll
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/BankTxs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#deleteById
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/BankTxs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#count
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/BankTxs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#prototype$patchAttributes
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTx id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/BankTxs/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#createChangeStream
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/BankTxs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#prototype$approve
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTx id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$approve": {
              url: urlBase + "/BankTxs/:id/approve",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTx#createMany
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/BankTxs",
              method: "POST",
            },

            // INTERNAL. Use Client.bankTxes.findById() instead.
            "::findById::Client::bankTxes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/bankTxes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Client.bankTxes.destroyById() instead.
            "::destroyById::Client::bankTxes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/bankTxes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Client.bankTxes.updateById() instead.
            "::updateById::Client::bankTxes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/bankTxes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Client.bankTxes() instead.
            "::get::Client::bankTxes": {
              isArray: true,
              url: urlBase + "/Clients/:id/bankTxes",
              method: "GET",
            },

            // INTERNAL. Use Client.bankTxes.create() instead.
            "::create::Client::bankTxes": {
              url: urlBase + "/Clients/:id/bankTxes",
              method: "POST",
            },

            // INTERNAL. Use Client.bankTxes.createMany() instead.
            "::createMany::Client::bankTxes": {
              isArray: true,
              url: urlBase + "/Clients/:id/bankTxes",
              method: "POST",
            },

            // INTERNAL. Use Client.bankTxes.destroyAll() instead.
            "::delete::Client::bankTxes": {
              url: urlBase + "/Clients/:id/bankTxes",
              method: "DELETE",
            },

            // INTERNAL. Use Client.bankTxes.count() instead.
            "::count::Client::bankTxes": {
              url: urlBase + "/Clients/:id/bankTxes/count",
              method: "GET",
            },

            // INTERNAL. Use Employee.bankTxes.findById() instead.
            "::findById::Employee::bankTxes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/bankTxes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Employee.bankTxes.destroyById() instead.
            "::destroyById::Employee::bankTxes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/bankTxes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Employee.bankTxes.updateById() instead.
            "::updateById::Employee::bankTxes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/bankTxes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Employee.bankTxes() instead.
            "::get::Employee::bankTxes": {
              isArray: true,
              url: urlBase + "/Employees/:id/bankTxes",
              method: "GET",
            },

            // INTERNAL. Use Employee.bankTxes.create() instead.
            "::create::Employee::bankTxes": {
              url: urlBase + "/Employees/:id/bankTxes",
              method: "POST",
            },

            // INTERNAL. Use Employee.bankTxes.createMany() instead.
            "::createMany::Employee::bankTxes": {
              isArray: true,
              url: urlBase + "/Employees/:id/bankTxes",
              method: "POST",
            },

            // INTERNAL. Use Employee.bankTxes.destroyAll() instead.
            "::delete::Employee::bankTxes": {
              url: urlBase + "/Employees/:id/bankTxes",
              method: "DELETE",
            },

            // INTERNAL. Use Employee.bankTxes.count() instead.
            "::count::Employee::bankTxes": {
              url: urlBase + "/Employees/:id/bankTxes/count",
              method: "GET",
            },

            // INTERNAL. Use PaymentItem.bankTx() instead.
            "::get::PaymentItem::bankTx": {
              url: urlBase + "/PaymentItems/:id/bankTx",
              method: "GET",
            },

            // INTERNAL. Use PaymentItem.bankTx.create() instead.
            "::create::PaymentItem::bankTx": {
              url: urlBase + "/PaymentItems/:id/bankTx",
              method: "POST",
            },

            // INTERNAL. Use PaymentItem.bankTx.createMany() instead.
            "::createMany::PaymentItem::bankTx": {
              isArray: true,
              url: urlBase + "/PaymentItems/:id/bankTx",
              method: "POST",
            },

            // INTERNAL. Use PaymentItem.bankTx.update() instead.
            "::update::PaymentItem::bankTx": {
              url: urlBase + "/PaymentItems/:id/bankTx",
              method: "PUT",
            },

            // INTERNAL. Use PaymentItem.bankTx.destroy() instead.
            "::destroy::PaymentItem::bankTx": {
              url: urlBase + "/PaymentItems/:id/bankTx",
              method: "DELETE",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.BankTx#upsert
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.BankTx#updateOrCreate
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.BankTx#patchOrCreateWithWhere
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.BankTx#update
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.BankTx#destroyById
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BankTx#removeById
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BankTx#prototype$updateAttributes
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTx id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.BankTx#modelName
        * @propertyOf lbServices.BankTx
        * @description
        * The name of the model represented by this $resource,
        * i.e. `BankTx`.
        */
        R.modelName = "BankTx";


            /**
             * @ngdoc method
             * @name lbServices.BankTx#client
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Fetches belongsTo relation client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTx id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.client = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::BankTx::client"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTx#employee
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Fetches belongsTo relation employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTx id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R.employee = function() {
          var TargetResource = $injector.get("Employee");
          var action = TargetResource["::get::BankTx::employee"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTx#paymentItem
             * @methodOf lbServices.BankTx
             *
             * @description
             *
             * Fetches belongsTo relation paymentItem.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTx id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
        R.paymentItem = function() {
          var TargetResource = $injector.get("PaymentItem");
          var action = TargetResource["::get::BankTx::paymentItem"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Employee
 * @header lbServices.Employee
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Employee` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Employee",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Employees/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Employee.bankTxes.findById() instead.
            "prototype$__findById__bankTxes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/bankTxes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Employee.bankTxes.destroyById() instead.
            "prototype$__destroyById__bankTxes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/bankTxes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Employee.bankTxes.updateById() instead.
            "prototype$__updateById__bankTxes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/bankTxes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Employee.segaUser() instead.
            "prototype$__get__segaUser": {
              url: urlBase + "/Employees/:id/segaUser",
              method: "GET",
            },

            // INTERNAL. Use Employee.segaUser.create() instead.
            "prototype$__create__segaUser": {
              url: urlBase + "/Employees/:id/segaUser",
              method: "POST",
            },

            // INTERNAL. Use Employee.segaUser.update() instead.
            "prototype$__update__segaUser": {
              url: urlBase + "/Employees/:id/segaUser",
              method: "PUT",
            },

            // INTERNAL. Use Employee.segaUser.destroy() instead.
            "prototype$__destroy__segaUser": {
              url: urlBase + "/Employees/:id/segaUser",
              method: "DELETE",
            },

            // INTERNAL. Use Employee.collections.findById() instead.
            "prototype$__findById__collections": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/collections/:fk",
              method: "GET",
            },

            // INTERNAL. Use Employee.collections.destroyById() instead.
            "prototype$__destroyById__collections": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/collections/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Employee.collections.updateById() instead.
            "prototype$__updateById__collections": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/collections/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Employee.collectionSpendings.findById() instead.
            "prototype$__findById__collectionSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/collectionSpendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Employee.collectionSpendings.destroyById() instead.
            "prototype$__destroyById__collectionSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/collectionSpendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Employee.collectionSpendings.updateById() instead.
            "prototype$__updateById__collectionSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/collectionSpendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Employee.cashbox() instead.
            "prototype$__get__cashbox": {
              url: urlBase + "/Employees/:id/cashbox",
              method: "GET",
            },

            // INTERNAL. Use Employee.cashbox.create() instead.
            "prototype$__create__cashbox": {
              url: urlBase + "/Employees/:id/cashbox",
              method: "POST",
            },

            // INTERNAL. Use Employee.cashbox.update() instead.
            "prototype$__update__cashbox": {
              url: urlBase + "/Employees/:id/cashbox",
              method: "PUT",
            },

            // INTERNAL. Use Employee.cashbox.destroy() instead.
            "prototype$__destroy__cashbox": {
              url: urlBase + "/Employees/:id/cashbox",
              method: "DELETE",
            },

            // INTERNAL. Use Employee.bankTxes() instead.
            "prototype$__get__bankTxes": {
              isArray: true,
              url: urlBase + "/Employees/:id/bankTxes",
              method: "GET",
            },

            // INTERNAL. Use Employee.bankTxes.create() instead.
            "prototype$__create__bankTxes": {
              url: urlBase + "/Employees/:id/bankTxes",
              method: "POST",
            },

            // INTERNAL. Use Employee.bankTxes.destroyAll() instead.
            "prototype$__delete__bankTxes": {
              url: urlBase + "/Employees/:id/bankTxes",
              method: "DELETE",
            },

            // INTERNAL. Use Employee.bankTxes.count() instead.
            "prototype$__count__bankTxes": {
              url: urlBase + "/Employees/:id/bankTxes/count",
              method: "GET",
            },

            // INTERNAL. Use Employee.collections() instead.
            "prototype$__get__collections": {
              isArray: true,
              url: urlBase + "/Employees/:id/collections",
              method: "GET",
            },

            // INTERNAL. Use Employee.collections.create() instead.
            "prototype$__create__collections": {
              url: urlBase + "/Employees/:id/collections",
              method: "POST",
            },

            // INTERNAL. Use Employee.collections.destroyAll() instead.
            "prototype$__delete__collections": {
              url: urlBase + "/Employees/:id/collections",
              method: "DELETE",
            },

            // INTERNAL. Use Employee.collections.count() instead.
            "prototype$__count__collections": {
              url: urlBase + "/Employees/:id/collections/count",
              method: "GET",
            },

            // INTERNAL. Use Employee.collectionSpendings() instead.
            "prototype$__get__collectionSpendings": {
              isArray: true,
              url: urlBase + "/Employees/:id/collectionSpendings",
              method: "GET",
            },

            // INTERNAL. Use Employee.collectionSpendings.create() instead.
            "prototype$__create__collectionSpendings": {
              url: urlBase + "/Employees/:id/collectionSpendings",
              method: "POST",
            },

            // INTERNAL. Use Employee.collectionSpendings.destroyAll() instead.
            "prototype$__delete__collectionSpendings": {
              url: urlBase + "/Employees/:id/collectionSpendings",
              method: "DELETE",
            },

            // INTERNAL. Use Employee.collectionSpendings.count() instead.
            "prototype$__count__collectionSpendings": {
              url: urlBase + "/Employees/:id/collectionSpendings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#create
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Employees",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#patchOrCreate
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Employees",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#replaceOrCreate
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Employees/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#upsertWithWhere
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Employees/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#exists
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Employees/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#findById
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Employees/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#replaceById
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Employees/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#find
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Employees",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#findOne
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Employees/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#updateAll
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Employees/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#deleteById
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Employees/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#count
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Employees/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#prototype$patchAttributes
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Employees/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#createChangeStream
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Employees/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#getDraftCollection
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Returns the current draft collection
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - Employee id
             *
             *  - `reset` – `{boolean=}` - Destroy and create a new draft collection
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `collection` – `{object=}` - Current draft collection
             */
            "getDraftCollection": {
              url: urlBase + "/Employees/getDraftCollection",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Employee#createMany
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Employees",
              method: "POST",
            },

            // INTERNAL. Use SegaUser.employee() instead.
            "::get::SegaUser::employee": {
              url: urlBase + "/SegaUsers/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use BankTx.employee() instead.
            "::get::BankTx::employee": {
              url: urlBase + "/BankTxs/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use Receipt.employee() instead.
            "::get::Receipt::employee": {
              url: urlBase + "/Receipts/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use Collection.employee() instead.
            "::get::Collection::employee": {
              url: urlBase + "/Collections/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use CollectionSpending.employee() instead.
            "::get::CollectionSpending::employee": {
              url: urlBase + "/CollectionSpendings/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use Cashbox.employee() instead.
            "::get::Cashbox::employee": {
              url: urlBase + "/Cashboxes/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use Spending.employee() instead.
            "::get::Spending::employee": {
              url: urlBase + "/Spendings/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.employee() instead.
            "::get::OperativeSpending::employee": {
              url: urlBase + "/OperativeSpendings/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use Voucher.employee() instead.
            "::get::Voucher::employee": {
              url: urlBase + "/Vouchers/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use Voucher.assignedEmployee() instead.
            "::get::Voucher::assignedEmployee": {
              url: urlBase + "/Vouchers/:id/assignedEmployee",
              method: "GET",
            },

            // INTERNAL. Use Task.employee() instead.
            "::get::Task::employee": {
              url: urlBase + "/Tasks/:id/employee",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Employee#upsert
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Employee#updateOrCreate
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Employee#patchOrCreateWithWhere
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Employee#update
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Employee#destroyById
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Employee#removeById
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Employee#prototype$updateAttributes
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Employee#modelName
        * @propertyOf lbServices.Employee
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Employee`.
        */
        R.modelName = "Employee";

    /**
     * @ngdoc object
     * @name lbServices.Employee.bankTxes
     * @header lbServices.Employee.bankTxes
     * @object
     * @description
     *
     * The object `Employee.bankTxes` groups methods
     * manipulating `BankTx` instances related to `Employee`.
     *
     * Call {@link lbServices.Employee#bankTxes Employee.bankTxes()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Employee#bankTxes
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Queries bankTxes of Employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R.bankTxes = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::get::Employee::bankTxes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.bankTxes#count
             * @methodOf lbServices.Employee.bankTxes
             *
             * @description
             *
             * Counts bankTxes of Employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.bankTxes.count = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::count::Employee::bankTxes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.bankTxes#create
             * @methodOf lbServices.Employee.bankTxes
             *
             * @description
             *
             * Creates a new instance in bankTxes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R.bankTxes.create = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::create::Employee::bankTxes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.bankTxes#createMany
             * @methodOf lbServices.Employee.bankTxes
             *
             * @description
             *
             * Creates a new instance in bankTxes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R.bankTxes.createMany = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::createMany::Employee::bankTxes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.bankTxes#destroyAll
             * @methodOf lbServices.Employee.bankTxes
             *
             * @description
             *
             * Deletes all bankTxes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bankTxes.destroyAll = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::delete::Employee::bankTxes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.bankTxes#destroyById
             * @methodOf lbServices.Employee.bankTxes
             *
             * @description
             *
             * Delete a related item by id for bankTxes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bankTxes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bankTxes.destroyById = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::destroyById::Employee::bankTxes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.bankTxes#findById
             * @methodOf lbServices.Employee.bankTxes
             *
             * @description
             *
             * Find a related item by id for bankTxes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bankTxes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R.bankTxes.findById = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::findById::Employee::bankTxes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.bankTxes#updateById
             * @methodOf lbServices.Employee.bankTxes
             *
             * @description
             *
             * Update a related item by id for bankTxes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `fk` – `{*}` - Foreign key for bankTxes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R.bankTxes.updateById = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::updateById::Employee::bankTxes"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Employee.segaUser
     * @header lbServices.Employee.segaUser
     * @object
     * @description
     *
     * The object `Employee.segaUser` groups methods
     * manipulating `SegaUser` instances related to `Employee`.
     *
     * Call {@link lbServices.Employee#segaUser Employee.segaUser()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Employee#segaUser
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Fetches hasOne relation segaUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.segaUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Employee::segaUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.segaUser#create
             * @methodOf lbServices.Employee.segaUser
             *
             * @description
             *
             * Creates a new instance in segaUser of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.segaUser.create = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::create::Employee::segaUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.segaUser#createMany
             * @methodOf lbServices.Employee.segaUser
             *
             * @description
             *
             * Creates a new instance in segaUser of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.segaUser.createMany = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::createMany::Employee::segaUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.segaUser#destroy
             * @methodOf lbServices.Employee.segaUser
             *
             * @description
             *
             * Deletes segaUser of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.segaUser.destroy = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::destroy::Employee::segaUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.segaUser#update
             * @methodOf lbServices.Employee.segaUser
             *
             * @description
             *
             * Update segaUser of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.segaUser.update = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::update::Employee::segaUser"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Employee.collections
     * @header lbServices.Employee.collections
     * @object
     * @description
     *
     * The object `Employee.collections` groups methods
     * manipulating `Collection` instances related to `Employee`.
     *
     * Call {@link lbServices.Employee#collections Employee.collections()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Employee#collections
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Queries collections of Employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
        R.collections = function() {
          var TargetResource = $injector.get("Collection");
          var action = TargetResource["::get::Employee::collections"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.collections#count
             * @methodOf lbServices.Employee.collections
             *
             * @description
             *
             * Counts collections of Employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.collections.count = function() {
          var TargetResource = $injector.get("Collection");
          var action = TargetResource["::count::Employee::collections"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.collections#create
             * @methodOf lbServices.Employee.collections
             *
             * @description
             *
             * Creates a new instance in collections of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
        R.collections.create = function() {
          var TargetResource = $injector.get("Collection");
          var action = TargetResource["::create::Employee::collections"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.collections#createMany
             * @methodOf lbServices.Employee.collections
             *
             * @description
             *
             * Creates a new instance in collections of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
        R.collections.createMany = function() {
          var TargetResource = $injector.get("Collection");
          var action = TargetResource["::createMany::Employee::collections"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.collections#destroyAll
             * @methodOf lbServices.Employee.collections
             *
             * @description
             *
             * Deletes all collections of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.collections.destroyAll = function() {
          var TargetResource = $injector.get("Collection");
          var action = TargetResource["::delete::Employee::collections"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.collections#destroyById
             * @methodOf lbServices.Employee.collections
             *
             * @description
             *
             * Delete a related item by id for collections.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for collections
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.collections.destroyById = function() {
          var TargetResource = $injector.get("Collection");
          var action = TargetResource["::destroyById::Employee::collections"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.collections#findById
             * @methodOf lbServices.Employee.collections
             *
             * @description
             *
             * Find a related item by id for collections.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for collections
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
        R.collections.findById = function() {
          var TargetResource = $injector.get("Collection");
          var action = TargetResource["::findById::Employee::collections"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.collections#updateById
             * @methodOf lbServices.Employee.collections
             *
             * @description
             *
             * Update a related item by id for collections.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `fk` – `{*}` - Foreign key for collections
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
        R.collections.updateById = function() {
          var TargetResource = $injector.get("Collection");
          var action = TargetResource["::updateById::Employee::collections"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Employee.collectionSpendings
     * @header lbServices.Employee.collectionSpendings
     * @object
     * @description
     *
     * The object `Employee.collectionSpendings` groups methods
     * manipulating `CollectionSpending` instances related to `Employee`.
     *
     * Call {@link lbServices.Employee#collectionSpendings Employee.collectionSpendings()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Employee#collectionSpendings
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Queries collectionSpendings of Employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R.collectionSpendings = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::get::Employee::collectionSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.collectionSpendings#count
             * @methodOf lbServices.Employee.collectionSpendings
             *
             * @description
             *
             * Counts collectionSpendings of Employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.collectionSpendings.count = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::count::Employee::collectionSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.collectionSpendings#create
             * @methodOf lbServices.Employee.collectionSpendings
             *
             * @description
             *
             * Creates a new instance in collectionSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R.collectionSpendings.create = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::create::Employee::collectionSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.collectionSpendings#createMany
             * @methodOf lbServices.Employee.collectionSpendings
             *
             * @description
             *
             * Creates a new instance in collectionSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R.collectionSpendings.createMany = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::createMany::Employee::collectionSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.collectionSpendings#destroyAll
             * @methodOf lbServices.Employee.collectionSpendings
             *
             * @description
             *
             * Deletes all collectionSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.collectionSpendings.destroyAll = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::delete::Employee::collectionSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.collectionSpendings#destroyById
             * @methodOf lbServices.Employee.collectionSpendings
             *
             * @description
             *
             * Delete a related item by id for collectionSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for collectionSpendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.collectionSpendings.destroyById = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::destroyById::Employee::collectionSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.collectionSpendings#findById
             * @methodOf lbServices.Employee.collectionSpendings
             *
             * @description
             *
             * Find a related item by id for collectionSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for collectionSpendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R.collectionSpendings.findById = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::findById::Employee::collectionSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.collectionSpendings#updateById
             * @methodOf lbServices.Employee.collectionSpendings
             *
             * @description
             *
             * Update a related item by id for collectionSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `fk` – `{*}` - Foreign key for collectionSpendings
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R.collectionSpendings.updateById = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::updateById::Employee::collectionSpendings"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Employee.cashbox
     * @header lbServices.Employee.cashbox
     * @object
     * @description
     *
     * The object `Employee.cashbox` groups methods
     * manipulating `Cashbox` instances related to `Employee`.
     *
     * Call {@link lbServices.Employee#cashbox Employee.cashbox()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Employee#cashbox
             * @methodOf lbServices.Employee
             *
             * @description
             *
             * Fetches hasOne relation cashbox.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
        R.cashbox = function() {
          var TargetResource = $injector.get("Cashbox");
          var action = TargetResource["::get::Employee::cashbox"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.cashbox#create
             * @methodOf lbServices.Employee.cashbox
             *
             * @description
             *
             * Creates a new instance in cashbox of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
        R.cashbox.create = function() {
          var TargetResource = $injector.get("Cashbox");
          var action = TargetResource["::create::Employee::cashbox"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.cashbox#createMany
             * @methodOf lbServices.Employee.cashbox
             *
             * @description
             *
             * Creates a new instance in cashbox of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
        R.cashbox.createMany = function() {
          var TargetResource = $injector.get("Cashbox");
          var action = TargetResource["::createMany::Employee::cashbox"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.cashbox#destroy
             * @methodOf lbServices.Employee.cashbox
             *
             * @description
             *
             * Deletes cashbox of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.cashbox.destroy = function() {
          var TargetResource = $injector.get("Cashbox");
          var action = TargetResource["::destroy::Employee::cashbox"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Employee.cashbox#update
             * @methodOf lbServices.Employee.cashbox
             *
             * @description
             *
             * Update cashbox of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Employee id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
        R.cashbox.update = function() {
          var TargetResource = $injector.get("Cashbox");
          var action = TargetResource["::update::Employee::cashbox"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Receipt
 * @header lbServices.Receipt
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Receipt` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Receipt",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Receipts/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Receipt.client() instead.
            "prototype$__get__client": {
              url: urlBase + "/Receipts/:id/client",
              method: "GET",
            },

            // INTERNAL. Use Receipt.employee() instead.
            "prototype$__get__employee": {
              url: urlBase + "/Receipts/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use Receipt.createdByUser() instead.
            "prototype$__get__createdByUser": {
              url: urlBase + "/Receipts/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Receipt.updatedByUser() instead.
            "prototype$__get__updatedByUser": {
              url: urlBase + "/Receipts/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use Receipt.collection() instead.
            "prototype$__get__collection": {
              url: urlBase + "/Receipts/:id/collection",
              method: "GET",
            },

            // INTERNAL. Use Receipt.paymentItems.findById() instead.
            "prototype$__findById__paymentItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/paymentItems/:fk",
              method: "GET",
            },

            // INTERNAL. Use Receipt.paymentItems.destroyById() instead.
            "prototype$__destroyById__paymentItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/paymentItems/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.paymentItems.updateById() instead.
            "prototype$__updateById__paymentItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/paymentItems/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Receipt.quotes.findById() instead.
            "prototype$__findById__quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/quotes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Receipt.quotes.destroyById() instead.
            "prototype$__destroyById__quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/quotes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.quotes.updateById() instead.
            "prototype$__updateById__quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/quotes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Receipt.quotes.link() instead.
            "prototype$__link__quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/quotes/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Receipt.quotes.unlink() instead.
            "prototype$__unlink__quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/quotes/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.quotes.exists() instead.
            "prototype$__exists__quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/quotes/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Receipt.receiptQuotes.findById() instead.
            "prototype$__findById__receiptQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/receiptQuotes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Receipt.receiptQuotes.destroyById() instead.
            "prototype$__destroyById__receiptQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/receiptQuotes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.receiptQuotes.updateById() instead.
            "prototype$__updateById__receiptQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/receiptQuotes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Receipt.groupInvoice() instead.
            "prototype$__get__groupInvoice": {
              url: urlBase + "/Receipts/:id/groupInvoice",
              method: "GET",
            },

            // INTERNAL. Use Receipt.groupInvoices.findById() instead.
            "prototype$__findById__groupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/groupInvoices/:fk",
              method: "GET",
            },

            // INTERNAL. Use Receipt.groupInvoices.destroyById() instead.
            "prototype$__destroyById__groupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/groupInvoices/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.groupInvoices.updateById() instead.
            "prototype$__updateById__groupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/groupInvoices/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Receipt.groupInvoices.link() instead.
            "prototype$__link__groupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/groupInvoices/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Receipt.groupInvoices.unlink() instead.
            "prototype$__unlink__groupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/groupInvoices/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.groupInvoices.exists() instead.
            "prototype$__exists__groupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/groupInvoices/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Receipt.receiptGroupInvoices.findById() instead.
            "prototype$__findById__receiptGroupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/receiptGroupInvoices/:fk",
              method: "GET",
            },

            // INTERNAL. Use Receipt.receiptGroupInvoices.destroyById() instead.
            "prototype$__destroyById__receiptGroupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/receiptGroupInvoices/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.receiptGroupInvoices.updateById() instead.
            "prototype$__updateById__receiptGroupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/receiptGroupInvoices/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Receipt.paymentItems() instead.
            "prototype$__get__paymentItems": {
              isArray: true,
              url: urlBase + "/Receipts/:id/paymentItems",
              method: "GET",
            },

            // INTERNAL. Use Receipt.paymentItems.create() instead.
            "prototype$__create__paymentItems": {
              url: urlBase + "/Receipts/:id/paymentItems",
              method: "POST",
            },

            // INTERNAL. Use Receipt.paymentItems.destroyAll() instead.
            "prototype$__delete__paymentItems": {
              url: urlBase + "/Receipts/:id/paymentItems",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.paymentItems.count() instead.
            "prototype$__count__paymentItems": {
              url: urlBase + "/Receipts/:id/paymentItems/count",
              method: "GET",
            },

            // INTERNAL. Use Receipt.quotes() instead.
            "prototype$__get__quotes": {
              isArray: true,
              url: urlBase + "/Receipts/:id/quotes",
              method: "GET",
            },

            // INTERNAL. Use Receipt.quotes.create() instead.
            "prototype$__create__quotes": {
              url: urlBase + "/Receipts/:id/quotes",
              method: "POST",
            },

            // INTERNAL. Use Receipt.quotes.destroyAll() instead.
            "prototype$__delete__quotes": {
              url: urlBase + "/Receipts/:id/quotes",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.quotes.count() instead.
            "prototype$__count__quotes": {
              url: urlBase + "/Receipts/:id/quotes/count",
              method: "GET",
            },

            // INTERNAL. Use Receipt.receiptQuotes() instead.
            "prototype$__get__receiptQuotes": {
              isArray: true,
              url: urlBase + "/Receipts/:id/receiptQuotes",
              method: "GET",
            },

            // INTERNAL. Use Receipt.receiptQuotes.create() instead.
            "prototype$__create__receiptQuotes": {
              url: urlBase + "/Receipts/:id/receiptQuotes",
              method: "POST",
            },

            // INTERNAL. Use Receipt.receiptQuotes.destroyAll() instead.
            "prototype$__delete__receiptQuotes": {
              url: urlBase + "/Receipts/:id/receiptQuotes",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.receiptQuotes.count() instead.
            "prototype$__count__receiptQuotes": {
              url: urlBase + "/Receipts/:id/receiptQuotes/count",
              method: "GET",
            },

            // INTERNAL. Use Receipt.groupInvoices() instead.
            "prototype$__get__groupInvoices": {
              isArray: true,
              url: urlBase + "/Receipts/:id/groupInvoices",
              method: "GET",
            },

            // INTERNAL. Use Receipt.groupInvoices.create() instead.
            "prototype$__create__groupInvoices": {
              url: urlBase + "/Receipts/:id/groupInvoices",
              method: "POST",
            },

            // INTERNAL. Use Receipt.groupInvoices.destroyAll() instead.
            "prototype$__delete__groupInvoices": {
              url: urlBase + "/Receipts/:id/groupInvoices",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.groupInvoices.count() instead.
            "prototype$__count__groupInvoices": {
              url: urlBase + "/Receipts/:id/groupInvoices/count",
              method: "GET",
            },

            // INTERNAL. Use Receipt.receiptGroupInvoices() instead.
            "prototype$__get__receiptGroupInvoices": {
              isArray: true,
              url: urlBase + "/Receipts/:id/receiptGroupInvoices",
              method: "GET",
            },

            // INTERNAL. Use Receipt.receiptGroupInvoices.create() instead.
            "prototype$__create__receiptGroupInvoices": {
              url: urlBase + "/Receipts/:id/receiptGroupInvoices",
              method: "POST",
            },

            // INTERNAL. Use Receipt.receiptGroupInvoices.destroyAll() instead.
            "prototype$__delete__receiptGroupInvoices": {
              url: urlBase + "/Receipts/:id/receiptGroupInvoices",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.receiptGroupInvoices.count() instead.
            "prototype$__count__receiptGroupInvoices": {
              url: urlBase + "/Receipts/:id/receiptGroupInvoices/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#create
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Receipts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#patchOrCreate
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Receipts",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#replaceOrCreate
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Receipts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#upsertWithWhere
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Receipts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#exists
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Receipts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#findById
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Receipts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#replaceById
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Receipts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#find
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Receipts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#findOne
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Receipts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#updateAll
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Receipts/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#deleteById
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Receipts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#count
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Receipts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#prototype$patchAttributes
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Receipts/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#createChangeStream
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Receipts/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#pdf
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Returns the pdf representation of the receipt
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{integer}` - Receipt id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
            "pdf": {
              url: urlBase + "/Receipts/pdf",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#fromSaga
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Parse rows from Saga
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `rows` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
            "fromSaga": {
              url: urlBase + "/Receipts/fromSaga",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#prototype$void
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Voids a receipt along with payment items, checks and bank txes
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `reason` – `{string}` - Voiding reason
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$void": {
              url: urlBase + "/Receipts/:id/void",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#html
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Returns the html representation of the receipt
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{integer}` - Receipt id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
            "html": {
              url: urlBase + "/Receipts/html",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#createNew
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Creates a new receipt alongside payment items and quotes assignment
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `receipt` – `{object}` - Receipt data
             *
             *  - `quotes` – `{*}` - Quotes to which the receipt is to be assigned
             *
             *  - `paymentItems` – `{*}` - Payment items for receipt
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `receipt` – `{object=}` - Receipt recently created
             */
            "createNew": {
              url: urlBase + "/Receipts/createNew",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#updateInvoiceNumber
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Updates invoice number
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             *  - `invoiceNumber` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `receipt` – `{object=}` - Receipt
             */
            "updateInvoiceNumber": {
              url: urlBase + "/Receipts/updateInvoiceNumber",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#createForGroupInvoice
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Creates a new receipt for a group invoice
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `groupInvoiceData` – `{*}` -
             *
             *  - `receipt` – `{object}` - Receipt data
             *
             *  - `paymentItems` – `{*}` - Payment items for receipt
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `receipt` – `{object=}` - Receipt recently created
             */
            "createForGroupInvoice": {
              url: urlBase + "/Receipts/createForGroupInvoice",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Receipt#createMany
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Receipts",
              method: "POST",
            },

            // INTERNAL. Use Collection.receipts.findById() instead.
            "::findById::Collection::receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/receipts/:fk",
              method: "GET",
            },

            // INTERNAL. Use Collection.receipts.destroyById() instead.
            "::destroyById::Collection::receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/receipts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.receipts.updateById() instead.
            "::updateById::Collection::receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/receipts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Collection.receipts() instead.
            "::get::Collection::receipts": {
              isArray: true,
              url: urlBase + "/Collections/:id/receipts",
              method: "GET",
            },

            // INTERNAL. Use Collection.receipts.create() instead.
            "::create::Collection::receipts": {
              url: urlBase + "/Collections/:id/receipts",
              method: "POST",
            },

            // INTERNAL. Use Collection.receipts.createMany() instead.
            "::createMany::Collection::receipts": {
              isArray: true,
              url: urlBase + "/Collections/:id/receipts",
              method: "POST",
            },

            // INTERNAL. Use Collection.receipts.destroyAll() instead.
            "::delete::Collection::receipts": {
              url: urlBase + "/Collections/:id/receipts",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.receipts.count() instead.
            "::count::Collection::receipts": {
              url: urlBase + "/Collections/:id/receipts/count",
              method: "GET",
            },

            // INTERNAL. Use PaymentItem.receipt() instead.
            "::get::PaymentItem::receipt": {
              url: urlBase + "/PaymentItems/:id/receipt",
              method: "GET",
            },

            // INTERNAL. Use Quote.receipts.findById() instead.
            "::findById::Quote::receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receipts/:fk",
              method: "GET",
            },

            // INTERNAL. Use Quote.receipts.destroyById() instead.
            "::destroyById::Quote::receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receipts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.receipts.updateById() instead.
            "::updateById::Quote::receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receipts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Quote.receipts.link() instead.
            "::link::Quote::receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receipts/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Quote.receipts.unlink() instead.
            "::unlink::Quote::receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receipts/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.receipts.exists() instead.
            "::exists::Quote::receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receipts/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Quote.receipts() instead.
            "::get::Quote::receipts": {
              isArray: true,
              url: urlBase + "/Quotes/:id/receipts",
              method: "GET",
            },

            // INTERNAL. Use Quote.receipts.create() instead.
            "::create::Quote::receipts": {
              url: urlBase + "/Quotes/:id/receipts",
              method: "POST",
            },

            // INTERNAL. Use Quote.receipts.createMany() instead.
            "::createMany::Quote::receipts": {
              isArray: true,
              url: urlBase + "/Quotes/:id/receipts",
              method: "POST",
            },

            // INTERNAL. Use Quote.receipts.destroyAll() instead.
            "::delete::Quote::receipts": {
              url: urlBase + "/Quotes/:id/receipts",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.receipts.count() instead.
            "::count::Quote::receipts": {
              url: urlBase + "/Quotes/:id/receipts/count",
              method: "GET",
            },

            // INTERNAL. Use ReceiptQuote.receipt() instead.
            "::get::ReceiptQuote::receipt": {
              url: urlBase + "/ReceiptQuotes/:id/receipt",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.receipts.findById() instead.
            "::findById::GroupInvoice::receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receipts/:fk",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.receipts.destroyById() instead.
            "::destroyById::GroupInvoice::receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receipts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use GroupInvoice.receipts.updateById() instead.
            "::updateById::GroupInvoice::receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receipts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use GroupInvoice.receipts.link() instead.
            "::link::GroupInvoice::receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receipts/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use GroupInvoice.receipts.unlink() instead.
            "::unlink::GroupInvoice::receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receipts/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use GroupInvoice.receipts.exists() instead.
            "::exists::GroupInvoice::receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receipts/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use GroupInvoice.receipts() instead.
            "::get::GroupInvoice::receipts": {
              isArray: true,
              url: urlBase + "/GroupInvoices/:id/receipts",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.receipts.create() instead.
            "::create::GroupInvoice::receipts": {
              url: urlBase + "/GroupInvoices/:id/receipts",
              method: "POST",
            },

            // INTERNAL. Use GroupInvoice.receipts.createMany() instead.
            "::createMany::GroupInvoice::receipts": {
              isArray: true,
              url: urlBase + "/GroupInvoices/:id/receipts",
              method: "POST",
            },

            // INTERNAL. Use GroupInvoice.receipts.destroyAll() instead.
            "::delete::GroupInvoice::receipts": {
              url: urlBase + "/GroupInvoices/:id/receipts",
              method: "DELETE",
            },

            // INTERNAL. Use GroupInvoice.receipts.count() instead.
            "::count::GroupInvoice::receipts": {
              url: urlBase + "/GroupInvoices/:id/receipts/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Receipt#upsert
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Receipt#updateOrCreate
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Receipt#patchOrCreateWithWhere
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Receipt#update
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Receipt#destroyById
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Receipt#removeById
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Receipt#prototype$updateAttributes
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Receipt#modelName
        * @propertyOf lbServices.Receipt
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Receipt`.
        */
        R.modelName = "Receipt";


            /**
             * @ngdoc method
             * @name lbServices.Receipt#client
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Fetches belongsTo relation client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.client = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::Receipt::client"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt#employee
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Fetches belongsTo relation employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R.employee = function() {
          var TargetResource = $injector.get("Employee");
          var action = TargetResource["::get::Receipt::employee"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Receipt.createdByUser
     * @header lbServices.Receipt.createdByUser
     * @object
     * @description
     *
     * The object `Receipt.createdByUser` groups methods
     * manipulating `SegaUser` instances related to `Receipt`.
     *
     * Call {@link lbServices.Receipt#createdByUser Receipt.createdByUser()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Receipt#createManydByUser
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createManydByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Receipt::createManydByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt#createdByUser
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createdByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Receipt::createdByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt#updatedByUser
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Fetches belongsTo relation updatedByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.updatedByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Receipt::updatedByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt#collection
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Fetches belongsTo relation collection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
        R.collection = function() {
          var TargetResource = $injector.get("Collection");
          var action = TargetResource["::get::Receipt::collection"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Receipt.paymentItems
     * @header lbServices.Receipt.paymentItems
     * @object
     * @description
     *
     * The object `Receipt.paymentItems` groups methods
     * manipulating `PaymentItem` instances related to `Receipt`.
     *
     * Call {@link lbServices.Receipt#paymentItems Receipt.paymentItems()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Receipt#paymentItems
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Queries paymentItems of Receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
        R.paymentItems = function() {
          var TargetResource = $injector.get("PaymentItem");
          var action = TargetResource["::get::Receipt::paymentItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.paymentItems#count
             * @methodOf lbServices.Receipt.paymentItems
             *
             * @description
             *
             * Counts paymentItems of Receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.paymentItems.count = function() {
          var TargetResource = $injector.get("PaymentItem");
          var action = TargetResource["::count::Receipt::paymentItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.paymentItems#create
             * @methodOf lbServices.Receipt.paymentItems
             *
             * @description
             *
             * Creates a new instance in paymentItems of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
        R.paymentItems.create = function() {
          var TargetResource = $injector.get("PaymentItem");
          var action = TargetResource["::create::Receipt::paymentItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.paymentItems#createMany
             * @methodOf lbServices.Receipt.paymentItems
             *
             * @description
             *
             * Creates a new instance in paymentItems of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
        R.paymentItems.createMany = function() {
          var TargetResource = $injector.get("PaymentItem");
          var action = TargetResource["::createMany::Receipt::paymentItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.paymentItems#destroyAll
             * @methodOf lbServices.Receipt.paymentItems
             *
             * @description
             *
             * Deletes all paymentItems of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.paymentItems.destroyAll = function() {
          var TargetResource = $injector.get("PaymentItem");
          var action = TargetResource["::delete::Receipt::paymentItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.paymentItems#destroyById
             * @methodOf lbServices.Receipt.paymentItems
             *
             * @description
             *
             * Delete a related item by id for paymentItems.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for paymentItems
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.paymentItems.destroyById = function() {
          var TargetResource = $injector.get("PaymentItem");
          var action = TargetResource["::destroyById::Receipt::paymentItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.paymentItems#findById
             * @methodOf lbServices.Receipt.paymentItems
             *
             * @description
             *
             * Find a related item by id for paymentItems.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for paymentItems
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
        R.paymentItems.findById = function() {
          var TargetResource = $injector.get("PaymentItem");
          var action = TargetResource["::findById::Receipt::paymentItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.paymentItems#updateById
             * @methodOf lbServices.Receipt.paymentItems
             *
             * @description
             *
             * Update a related item by id for paymentItems.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `fk` – `{*}` - Foreign key for paymentItems
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
        R.paymentItems.updateById = function() {
          var TargetResource = $injector.get("PaymentItem");
          var action = TargetResource["::updateById::Receipt::paymentItems"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Receipt.quotes
     * @header lbServices.Receipt.quotes
     * @object
     * @description
     *
     * The object `Receipt.quotes` groups methods
     * manipulating `Quote` instances related to `Receipt`.
     *
     * Call {@link lbServices.Receipt#quotes Receipt.quotes()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Receipt#quotes
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Queries quotes of Receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::get::Receipt::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.quotes#count
             * @methodOf lbServices.Receipt.quotes
             *
             * @description
             *
             * Counts quotes of Receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.quotes.count = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::count::Receipt::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.quotes#create
             * @methodOf lbServices.Receipt.quotes
             *
             * @description
             *
             * Creates a new instance in quotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.create = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::create::Receipt::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.quotes#createMany
             * @methodOf lbServices.Receipt.quotes
             *
             * @description
             *
             * Creates a new instance in quotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.createMany = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::createMany::Receipt::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.quotes#destroyAll
             * @methodOf lbServices.Receipt.quotes
             *
             * @description
             *
             * Deletes all quotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.quotes.destroyAll = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::delete::Receipt::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.quotes#destroyById
             * @methodOf lbServices.Receipt.quotes
             *
             * @description
             *
             * Delete a related item by id for quotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for quotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.quotes.destroyById = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::destroyById::Receipt::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.quotes#exists
             * @methodOf lbServices.Receipt.quotes
             *
             * @description
             *
             * Check the existence of quotes relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for quotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.exists = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::exists::Receipt::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.quotes#findById
             * @methodOf lbServices.Receipt.quotes
             *
             * @description
             *
             * Find a related item by id for quotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for quotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.findById = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::findById::Receipt::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.quotes#link
             * @methodOf lbServices.Receipt.quotes
             *
             * @description
             *
             * Add a related item by id for quotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `fk` – `{*}` - Foreign key for quotes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.link = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::link::Receipt::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.quotes#unlink
             * @methodOf lbServices.Receipt.quotes
             *
             * @description
             *
             * Remove the quotes relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for quotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.quotes.unlink = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::unlink::Receipt::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.quotes#updateById
             * @methodOf lbServices.Receipt.quotes
             *
             * @description
             *
             * Update a related item by id for quotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `fk` – `{*}` - Foreign key for quotes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.updateById = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::updateById::Receipt::quotes"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Receipt.receiptQuotes
     * @header lbServices.Receipt.receiptQuotes
     * @object
     * @description
     *
     * The object `Receipt.receiptQuotes` groups methods
     * manipulating `ReceiptQuote` instances related to `Receipt`.
     *
     * Call {@link lbServices.Receipt#receiptQuotes Receipt.receiptQuotes()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Receipt#receiptQuotes
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Queries receiptQuotes of Receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R.receiptQuotes = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::get::Receipt::receiptQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.receiptQuotes#count
             * @methodOf lbServices.Receipt.receiptQuotes
             *
             * @description
             *
             * Counts receiptQuotes of Receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.receiptQuotes.count = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::count::Receipt::receiptQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.receiptQuotes#create
             * @methodOf lbServices.Receipt.receiptQuotes
             *
             * @description
             *
             * Creates a new instance in receiptQuotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R.receiptQuotes.create = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::create::Receipt::receiptQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.receiptQuotes#createMany
             * @methodOf lbServices.Receipt.receiptQuotes
             *
             * @description
             *
             * Creates a new instance in receiptQuotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R.receiptQuotes.createMany = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::createMany::Receipt::receiptQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.receiptQuotes#destroyAll
             * @methodOf lbServices.Receipt.receiptQuotes
             *
             * @description
             *
             * Deletes all receiptQuotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receiptQuotes.destroyAll = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::delete::Receipt::receiptQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.receiptQuotes#destroyById
             * @methodOf lbServices.Receipt.receiptQuotes
             *
             * @description
             *
             * Delete a related item by id for receiptQuotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receiptQuotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receiptQuotes.destroyById = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::destroyById::Receipt::receiptQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.receiptQuotes#findById
             * @methodOf lbServices.Receipt.receiptQuotes
             *
             * @description
             *
             * Find a related item by id for receiptQuotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receiptQuotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R.receiptQuotes.findById = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::findById::Receipt::receiptQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.receiptQuotes#updateById
             * @methodOf lbServices.Receipt.receiptQuotes
             *
             * @description
             *
             * Update a related item by id for receiptQuotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `fk` – `{*}` - Foreign key for receiptQuotes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R.receiptQuotes.updateById = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::updateById::Receipt::receiptQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt#groupInvoice
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Fetches belongsTo relation groupInvoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
        R.groupInvoice = function() {
          var TargetResource = $injector.get("GroupInvoice");
          var action = TargetResource["::get::Receipt::groupInvoice"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Receipt.groupInvoices
     * @header lbServices.Receipt.groupInvoices
     * @object
     * @description
     *
     * The object `Receipt.groupInvoices` groups methods
     * manipulating `GroupInvoice` instances related to `Receipt`.
     *
     * Call {@link lbServices.Receipt#groupInvoices Receipt.groupInvoices()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Receipt#groupInvoices
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Queries groupInvoices of Receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
        R.groupInvoices = function() {
          var TargetResource = $injector.get("GroupInvoice");
          var action = TargetResource["::get::Receipt::groupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.groupInvoices#count
             * @methodOf lbServices.Receipt.groupInvoices
             *
             * @description
             *
             * Counts groupInvoices of Receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.groupInvoices.count = function() {
          var TargetResource = $injector.get("GroupInvoice");
          var action = TargetResource["::count::Receipt::groupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.groupInvoices#create
             * @methodOf lbServices.Receipt.groupInvoices
             *
             * @description
             *
             * Creates a new instance in groupInvoices of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
        R.groupInvoices.create = function() {
          var TargetResource = $injector.get("GroupInvoice");
          var action = TargetResource["::create::Receipt::groupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.groupInvoices#createMany
             * @methodOf lbServices.Receipt.groupInvoices
             *
             * @description
             *
             * Creates a new instance in groupInvoices of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
        R.groupInvoices.createMany = function() {
          var TargetResource = $injector.get("GroupInvoice");
          var action = TargetResource["::createMany::Receipt::groupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.groupInvoices#destroyAll
             * @methodOf lbServices.Receipt.groupInvoices
             *
             * @description
             *
             * Deletes all groupInvoices of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.groupInvoices.destroyAll = function() {
          var TargetResource = $injector.get("GroupInvoice");
          var action = TargetResource["::delete::Receipt::groupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.groupInvoices#destroyById
             * @methodOf lbServices.Receipt.groupInvoices
             *
             * @description
             *
             * Delete a related item by id for groupInvoices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for groupInvoices
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.groupInvoices.destroyById = function() {
          var TargetResource = $injector.get("GroupInvoice");
          var action = TargetResource["::destroyById::Receipt::groupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.groupInvoices#exists
             * @methodOf lbServices.Receipt.groupInvoices
             *
             * @description
             *
             * Check the existence of groupInvoices relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for groupInvoices
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
        R.groupInvoices.exists = function() {
          var TargetResource = $injector.get("GroupInvoice");
          var action = TargetResource["::exists::Receipt::groupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.groupInvoices#findById
             * @methodOf lbServices.Receipt.groupInvoices
             *
             * @description
             *
             * Find a related item by id for groupInvoices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for groupInvoices
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
        R.groupInvoices.findById = function() {
          var TargetResource = $injector.get("GroupInvoice");
          var action = TargetResource["::findById::Receipt::groupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.groupInvoices#link
             * @methodOf lbServices.Receipt.groupInvoices
             *
             * @description
             *
             * Add a related item by id for groupInvoices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `fk` – `{*}` - Foreign key for groupInvoices
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
        R.groupInvoices.link = function() {
          var TargetResource = $injector.get("GroupInvoice");
          var action = TargetResource["::link::Receipt::groupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.groupInvoices#unlink
             * @methodOf lbServices.Receipt.groupInvoices
             *
             * @description
             *
             * Remove the groupInvoices relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for groupInvoices
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.groupInvoices.unlink = function() {
          var TargetResource = $injector.get("GroupInvoice");
          var action = TargetResource["::unlink::Receipt::groupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.groupInvoices#updateById
             * @methodOf lbServices.Receipt.groupInvoices
             *
             * @description
             *
             * Update a related item by id for groupInvoices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `fk` – `{*}` - Foreign key for groupInvoices
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
        R.groupInvoices.updateById = function() {
          var TargetResource = $injector.get("GroupInvoice");
          var action = TargetResource["::updateById::Receipt::groupInvoices"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Receipt.receiptGroupInvoices
     * @header lbServices.Receipt.receiptGroupInvoices
     * @object
     * @description
     *
     * The object `Receipt.receiptGroupInvoices` groups methods
     * manipulating `ReceiptGroupInvoice` instances related to `Receipt`.
     *
     * Call {@link lbServices.Receipt#receiptGroupInvoices Receipt.receiptGroupInvoices()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Receipt#receiptGroupInvoices
             * @methodOf lbServices.Receipt
             *
             * @description
             *
             * Queries receiptGroupInvoices of Receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R.receiptGroupInvoices = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::get::Receipt::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.receiptGroupInvoices#count
             * @methodOf lbServices.Receipt.receiptGroupInvoices
             *
             * @description
             *
             * Counts receiptGroupInvoices of Receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.receiptGroupInvoices.count = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::count::Receipt::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.receiptGroupInvoices#create
             * @methodOf lbServices.Receipt.receiptGroupInvoices
             *
             * @description
             *
             * Creates a new instance in receiptGroupInvoices of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R.receiptGroupInvoices.create = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::create::Receipt::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.receiptGroupInvoices#createMany
             * @methodOf lbServices.Receipt.receiptGroupInvoices
             *
             * @description
             *
             * Creates a new instance in receiptGroupInvoices of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R.receiptGroupInvoices.createMany = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::createMany::Receipt::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.receiptGroupInvoices#destroyAll
             * @methodOf lbServices.Receipt.receiptGroupInvoices
             *
             * @description
             *
             * Deletes all receiptGroupInvoices of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receiptGroupInvoices.destroyAll = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::delete::Receipt::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.receiptGroupInvoices#destroyById
             * @methodOf lbServices.Receipt.receiptGroupInvoices
             *
             * @description
             *
             * Delete a related item by id for receiptGroupInvoices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receiptGroupInvoices
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receiptGroupInvoices.destroyById = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::destroyById::Receipt::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.receiptGroupInvoices#findById
             * @methodOf lbServices.Receipt.receiptGroupInvoices
             *
             * @description
             *
             * Find a related item by id for receiptGroupInvoices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receiptGroupInvoices
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R.receiptGroupInvoices.findById = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::findById::Receipt::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Receipt.receiptGroupInvoices#updateById
             * @methodOf lbServices.Receipt.receiptGroupInvoices
             *
             * @description
             *
             * Update a related item by id for receiptGroupInvoices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Receipt id
             *
             *  - `fk` – `{*}` - Foreign key for receiptGroupInvoices
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R.receiptGroupInvoices.updateById = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::updateById::Receipt::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Collection
 * @header lbServices.Collection
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Collection` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Collection",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Collections/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Collection.employee() instead.
            "prototype$__get__employee": {
              url: urlBase + "/Collections/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use Collection.receipts.findById() instead.
            "prototype$__findById__receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/receipts/:fk",
              method: "GET",
            },

            // INTERNAL. Use Collection.receipts.destroyById() instead.
            "prototype$__destroyById__receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/receipts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.receipts.updateById() instead.
            "prototype$__updateById__receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/receipts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Collection.collectionSpendings.findById() instead.
            "prototype$__findById__collectionSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/collectionSpendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Collection.collectionSpendings.destroyById() instead.
            "prototype$__destroyById__collectionSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/collectionSpendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.collectionSpendings.updateById() instead.
            "prototype$__updateById__collectionSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/collectionSpendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Collection.spendings.findById() instead.
            "prototype$__findById__spendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/spendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Collection.spendings.destroyById() instead.
            "prototype$__destroyById__spendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/spendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.spendings.updateById() instead.
            "prototype$__updateById__spendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/spendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Collection.operativeSpendings.findById() instead.
            "prototype$__findById__operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/operativeSpendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Collection.operativeSpendings.destroyById() instead.
            "prototype$__destroyById__operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/operativeSpendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.operativeSpendings.updateById() instead.
            "prototype$__updateById__operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/operativeSpendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Collection.cashboxTransfers.findById() instead.
            "prototype$__findById__cashboxTransfers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/cashboxTransfers/:fk",
              method: "GET",
            },

            // INTERNAL. Use Collection.cashboxTransfers.destroyById() instead.
            "prototype$__destroyById__cashboxTransfers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/cashboxTransfers/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.cashboxTransfers.updateById() instead.
            "prototype$__updateById__cashboxTransfers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/cashboxTransfers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Collection.receipts() instead.
            "prototype$__get__receipts": {
              isArray: true,
              url: urlBase + "/Collections/:id/receipts",
              method: "GET",
            },

            // INTERNAL. Use Collection.receipts.create() instead.
            "prototype$__create__receipts": {
              url: urlBase + "/Collections/:id/receipts",
              method: "POST",
            },

            // INTERNAL. Use Collection.receipts.destroyAll() instead.
            "prototype$__delete__receipts": {
              url: urlBase + "/Collections/:id/receipts",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.receipts.count() instead.
            "prototype$__count__receipts": {
              url: urlBase + "/Collections/:id/receipts/count",
              method: "GET",
            },

            // INTERNAL. Use Collection.collectionSpendings() instead.
            "prototype$__get__collectionSpendings": {
              isArray: true,
              url: urlBase + "/Collections/:id/collectionSpendings",
              method: "GET",
            },

            // INTERNAL. Use Collection.collectionSpendings.create() instead.
            "prototype$__create__collectionSpendings": {
              url: urlBase + "/Collections/:id/collectionSpendings",
              method: "POST",
            },

            // INTERNAL. Use Collection.collectionSpendings.destroyAll() instead.
            "prototype$__delete__collectionSpendings": {
              url: urlBase + "/Collections/:id/collectionSpendings",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.collectionSpendings.count() instead.
            "prototype$__count__collectionSpendings": {
              url: urlBase + "/Collections/:id/collectionSpendings/count",
              method: "GET",
            },

            // INTERNAL. Use Collection.spendings() instead.
            "prototype$__get__spendings": {
              isArray: true,
              url: urlBase + "/Collections/:id/spendings",
              method: "GET",
            },

            // INTERNAL. Use Collection.spendings.create() instead.
            "prototype$__create__spendings": {
              url: urlBase + "/Collections/:id/spendings",
              method: "POST",
            },

            // INTERNAL. Use Collection.spendings.destroyAll() instead.
            "prototype$__delete__spendings": {
              url: urlBase + "/Collections/:id/spendings",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.spendings.count() instead.
            "prototype$__count__spendings": {
              url: urlBase + "/Collections/:id/spendings/count",
              method: "GET",
            },

            // INTERNAL. Use Collection.operativeSpendings() instead.
            "prototype$__get__operativeSpendings": {
              isArray: true,
              url: urlBase + "/Collections/:id/operativeSpendings",
              method: "GET",
            },

            // INTERNAL. Use Collection.operativeSpendings.create() instead.
            "prototype$__create__operativeSpendings": {
              url: urlBase + "/Collections/:id/operativeSpendings",
              method: "POST",
            },

            // INTERNAL. Use Collection.operativeSpendings.destroyAll() instead.
            "prototype$__delete__operativeSpendings": {
              url: urlBase + "/Collections/:id/operativeSpendings",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.operativeSpendings.count() instead.
            "prototype$__count__operativeSpendings": {
              url: urlBase + "/Collections/:id/operativeSpendings/count",
              method: "GET",
            },

            // INTERNAL. Use Collection.cashboxTransfers() instead.
            "prototype$__get__cashboxTransfers": {
              isArray: true,
              url: urlBase + "/Collections/:id/cashboxTransfers",
              method: "GET",
            },

            // INTERNAL. Use Collection.cashboxTransfers.create() instead.
            "prototype$__create__cashboxTransfers": {
              url: urlBase + "/Collections/:id/cashboxTransfers",
              method: "POST",
            },

            // INTERNAL. Use Collection.cashboxTransfers.destroyAll() instead.
            "prototype$__delete__cashboxTransfers": {
              url: urlBase + "/Collections/:id/cashboxTransfers",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.cashboxTransfers.count() instead.
            "prototype$__count__cashboxTransfers": {
              url: urlBase + "/Collections/:id/cashboxTransfers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#create
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Collections",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#patchOrCreate
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Collections",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#replaceOrCreate
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Collections/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#upsertWithWhere
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Collections/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#exists
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Collections/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#findById
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Collections/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#replaceById
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Collections/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#find
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Collections",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#findOne
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Collections/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#updateAll
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Collections/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#deleteById
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Collections/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#count
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Collections/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#prototype$patchAttributes
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Collections/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#createChangeStream
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Collections/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#pdf
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Returns the pdf representation of the collection
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{integer}` - Collection id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
            "pdf": {
              url: urlBase + "/Collections/pdf",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#approve
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Approves a collection in state 'draft'
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `cashboxTransaction` – `{object=}` -
             */
            "approve": {
              url: urlBase + "/Collections/approve",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#getDraftCollection
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Gets current draft collection
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `employeeId` – `{number}` - Employee id
             *
             *  - `reset` – `{boolean=}` - Recreate draft collection
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `collection` – `{object=}` -
             */
            "getDraftCollection": {
              url: urlBase + "/Collections/getDraftCollection",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#removeReceipt
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Removes receipt from collection
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `collectionId` – `{number}` - Collection id
             *
             *  - `receiptId` – `{number}` - Receipt id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `collection` – `{object=}` -
             */
            "removeReceipt": {
              url: urlBase + "/Collections/removeReceipt",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#disapprove
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Disapproves collection, returning it to draft state
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `cashboxTransaction` – `{object=}` -
             */
            "disapprove": {
              url: urlBase + "/Collections/disapprove",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#removeOperativeSpending
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Removes operative spending from collection
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `collectionId` – `{number}` - Collection id
             *
             *  - `oSpendingId` – `{number}` - Operative Spending id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `collection` – `{object=}` -
             */
            "removeOperativeSpending": {
              url: urlBase + "/Collections/removeOperativeSpending",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#removeSpending
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Removes spending from collection
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `collectionId` – `{number}` - Collection id
             *
             *  - `spendingId` – `{number}` - Spending id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `collection` – `{object=}` -
             */
            "removeSpending": {
              url: urlBase + "/Collections/removeSpending",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#sendToMain
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Sends collections to main cashbox
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `collectionIds` – `{*}` - Collection ids
             *
             *  - `amount` – `{number}` - True amount to be sent
             *
             *  - `comments` – `{string=}` - Comments to be appended
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `transactions` – `{*=}` -
             */
            "sendToMain": {
              url: urlBase + "/Collections/sendToMain",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#sendToTreasury
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Sends a Collection to treasury (state=sent)
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - Collection id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `collection` – `{object=}` -
             */
            "sendToTreasury": {
              url: urlBase + "/Collections/sendToTreasury",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#reject
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Rejects a Collection back to draft state
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - Collection id
             *
             *  - `reason` – `{string}` - Rejection reason
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `collection` – `{object=}` -
             */
            "reject": {
              url: urlBase + "/Collections/reject",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#removeCashboxTransfer
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Removes CT from collection
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `collectionId` – `{number}` - Collection id
             *
             *  - `cashboxTransferId` – `{number}` - CT id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `collection` – `{object=}` -
             */
            "removeCashboxTransfer": {
              url: urlBase + "/Collections/removeCashboxTranfer",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collection#createMany
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Collections",
              method: "POST",
            },

            // INTERNAL. Use Employee.collections.findById() instead.
            "::findById::Employee::collections": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/collections/:fk",
              method: "GET",
            },

            // INTERNAL. Use Employee.collections.destroyById() instead.
            "::destroyById::Employee::collections": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/collections/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Employee.collections.updateById() instead.
            "::updateById::Employee::collections": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/collections/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Employee.collections() instead.
            "::get::Employee::collections": {
              isArray: true,
              url: urlBase + "/Employees/:id/collections",
              method: "GET",
            },

            // INTERNAL. Use Employee.collections.create() instead.
            "::create::Employee::collections": {
              url: urlBase + "/Employees/:id/collections",
              method: "POST",
            },

            // INTERNAL. Use Employee.collections.createMany() instead.
            "::createMany::Employee::collections": {
              isArray: true,
              url: urlBase + "/Employees/:id/collections",
              method: "POST",
            },

            // INTERNAL. Use Employee.collections.destroyAll() instead.
            "::delete::Employee::collections": {
              url: urlBase + "/Employees/:id/collections",
              method: "DELETE",
            },

            // INTERNAL. Use Employee.collections.count() instead.
            "::count::Employee::collections": {
              url: urlBase + "/Employees/:id/collections/count",
              method: "GET",
            },

            // INTERNAL. Use Receipt.collection() instead.
            "::get::Receipt::collection": {
              url: urlBase + "/Receipts/:id/collection",
              method: "GET",
            },

            // INTERNAL. Use CollectionSpending.collection() instead.
            "::get::CollectionSpending::collection": {
              url: urlBase + "/CollectionSpendings/:id/collection",
              method: "GET",
            },

            // INTERNAL. Use Spending.collection() instead.
            "::get::Spending::collection": {
              url: urlBase + "/Spendings/:id/collection",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.collection() instead.
            "::get::OperativeSpending::collection": {
              url: urlBase + "/OperativeSpendings/:id/collection",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Collection#upsert
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Collection#updateOrCreate
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Collection#patchOrCreateWithWhere
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Collection#update
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Collection#destroyById
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Collection#removeById
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Collection#prototype$updateAttributes
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Collection#modelName
        * @propertyOf lbServices.Collection
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Collection`.
        */
        R.modelName = "Collection";


            /**
             * @ngdoc method
             * @name lbServices.Collection#employee
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Fetches belongsTo relation employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R.employee = function() {
          var TargetResource = $injector.get("Employee");
          var action = TargetResource["::get::Collection::employee"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Collection.receipts
     * @header lbServices.Collection.receipts
     * @object
     * @description
     *
     * The object `Collection.receipts` groups methods
     * manipulating `Receipt` instances related to `Collection`.
     *
     * Call {@link lbServices.Collection#receipts Collection.receipts()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Collection#receipts
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Queries receipts of Collection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::get::Collection::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.receipts#count
             * @methodOf lbServices.Collection.receipts
             *
             * @description
             *
             * Counts receipts of Collection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.receipts.count = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::count::Collection::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.receipts#create
             * @methodOf lbServices.Collection.receipts
             *
             * @description
             *
             * Creates a new instance in receipts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.create = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::create::Collection::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.receipts#createMany
             * @methodOf lbServices.Collection.receipts
             *
             * @description
             *
             * Creates a new instance in receipts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.createMany = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::createMany::Collection::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.receipts#destroyAll
             * @methodOf lbServices.Collection.receipts
             *
             * @description
             *
             * Deletes all receipts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receipts.destroyAll = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::delete::Collection::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.receipts#destroyById
             * @methodOf lbServices.Collection.receipts
             *
             * @description
             *
             * Delete a related item by id for receipts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receipts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receipts.destroyById = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::destroyById::Collection::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.receipts#findById
             * @methodOf lbServices.Collection.receipts
             *
             * @description
             *
             * Find a related item by id for receipts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receipts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.findById = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::findById::Collection::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.receipts#updateById
             * @methodOf lbServices.Collection.receipts
             *
             * @description
             *
             * Update a related item by id for receipts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `fk` – `{*}` - Foreign key for receipts
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.updateById = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::updateById::Collection::receipts"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Collection.collectionSpendings
     * @header lbServices.Collection.collectionSpendings
     * @object
     * @description
     *
     * The object `Collection.collectionSpendings` groups methods
     * manipulating `CollectionSpending` instances related to `Collection`.
     *
     * Call {@link lbServices.Collection#collectionSpendings Collection.collectionSpendings()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Collection#collectionSpendings
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Queries collectionSpendings of Collection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R.collectionSpendings = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::get::Collection::collectionSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.collectionSpendings#count
             * @methodOf lbServices.Collection.collectionSpendings
             *
             * @description
             *
             * Counts collectionSpendings of Collection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.collectionSpendings.count = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::count::Collection::collectionSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.collectionSpendings#create
             * @methodOf lbServices.Collection.collectionSpendings
             *
             * @description
             *
             * Creates a new instance in collectionSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R.collectionSpendings.create = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::create::Collection::collectionSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.collectionSpendings#createMany
             * @methodOf lbServices.Collection.collectionSpendings
             *
             * @description
             *
             * Creates a new instance in collectionSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R.collectionSpendings.createMany = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::createMany::Collection::collectionSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.collectionSpendings#destroyAll
             * @methodOf lbServices.Collection.collectionSpendings
             *
             * @description
             *
             * Deletes all collectionSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.collectionSpendings.destroyAll = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::delete::Collection::collectionSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.collectionSpendings#destroyById
             * @methodOf lbServices.Collection.collectionSpendings
             *
             * @description
             *
             * Delete a related item by id for collectionSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for collectionSpendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.collectionSpendings.destroyById = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::destroyById::Collection::collectionSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.collectionSpendings#findById
             * @methodOf lbServices.Collection.collectionSpendings
             *
             * @description
             *
             * Find a related item by id for collectionSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for collectionSpendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R.collectionSpendings.findById = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::findById::Collection::collectionSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.collectionSpendings#updateById
             * @methodOf lbServices.Collection.collectionSpendings
             *
             * @description
             *
             * Update a related item by id for collectionSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `fk` – `{*}` - Foreign key for collectionSpendings
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R.collectionSpendings.updateById = function() {
          var TargetResource = $injector.get("CollectionSpending");
          var action = TargetResource["::updateById::Collection::collectionSpendings"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Collection.spendings
     * @header lbServices.Collection.spendings
     * @object
     * @description
     *
     * The object `Collection.spendings` groups methods
     * manipulating `Spending` instances related to `Collection`.
     *
     * Call {@link lbServices.Collection#spendings Collection.spendings()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Collection#spendings
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Queries spendings of Collection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R.spendings = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::get::Collection::spendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.spendings#count
             * @methodOf lbServices.Collection.spendings
             *
             * @description
             *
             * Counts spendings of Collection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.spendings.count = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::count::Collection::spendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.spendings#create
             * @methodOf lbServices.Collection.spendings
             *
             * @description
             *
             * Creates a new instance in spendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R.spendings.create = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::create::Collection::spendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.spendings#createMany
             * @methodOf lbServices.Collection.spendings
             *
             * @description
             *
             * Creates a new instance in spendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R.spendings.createMany = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::createMany::Collection::spendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.spendings#destroyAll
             * @methodOf lbServices.Collection.spendings
             *
             * @description
             *
             * Deletes all spendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.spendings.destroyAll = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::delete::Collection::spendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.spendings#destroyById
             * @methodOf lbServices.Collection.spendings
             *
             * @description
             *
             * Delete a related item by id for spendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for spendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.spendings.destroyById = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::destroyById::Collection::spendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.spendings#findById
             * @methodOf lbServices.Collection.spendings
             *
             * @description
             *
             * Find a related item by id for spendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for spendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R.spendings.findById = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::findById::Collection::spendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.spendings#updateById
             * @methodOf lbServices.Collection.spendings
             *
             * @description
             *
             * Update a related item by id for spendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `fk` – `{*}` - Foreign key for spendings
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R.spendings.updateById = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::updateById::Collection::spendings"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Collection.operativeSpendings
     * @header lbServices.Collection.operativeSpendings
     * @object
     * @description
     *
     * The object `Collection.operativeSpendings` groups methods
     * manipulating `OperativeSpending` instances related to `Collection`.
     *
     * Call {@link lbServices.Collection#operativeSpendings Collection.operativeSpendings()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Collection#operativeSpendings
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Queries operativeSpendings of Collection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpendings = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::get::Collection::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.operativeSpendings#count
             * @methodOf lbServices.Collection.operativeSpendings
             *
             * @description
             *
             * Counts operativeSpendings of Collection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.operativeSpendings.count = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::count::Collection::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.operativeSpendings#create
             * @methodOf lbServices.Collection.operativeSpendings
             *
             * @description
             *
             * Creates a new instance in operativeSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpendings.create = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::create::Collection::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.operativeSpendings#createMany
             * @methodOf lbServices.Collection.operativeSpendings
             *
             * @description
             *
             * Creates a new instance in operativeSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpendings.createMany = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::createMany::Collection::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.operativeSpendings#destroyAll
             * @methodOf lbServices.Collection.operativeSpendings
             *
             * @description
             *
             * Deletes all operativeSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.operativeSpendings.destroyAll = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::delete::Collection::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.operativeSpendings#destroyById
             * @methodOf lbServices.Collection.operativeSpendings
             *
             * @description
             *
             * Delete a related item by id for operativeSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operativeSpendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.operativeSpendings.destroyById = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::destroyById::Collection::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.operativeSpendings#findById
             * @methodOf lbServices.Collection.operativeSpendings
             *
             * @description
             *
             * Find a related item by id for operativeSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operativeSpendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpendings.findById = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::findById::Collection::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.operativeSpendings#updateById
             * @methodOf lbServices.Collection.operativeSpendings
             *
             * @description
             *
             * Update a related item by id for operativeSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `fk` – `{*}` - Foreign key for operativeSpendings
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpendings.updateById = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::updateById::Collection::operativeSpendings"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Collection.cashboxTransfers
     * @header lbServices.Collection.cashboxTransfers
     * @object
     * @description
     *
     * The object `Collection.cashboxTransfers` groups methods
     * manipulating `CashboxTransfer` instances related to `Collection`.
     *
     * Call {@link lbServices.Collection#cashboxTransfers Collection.cashboxTransfers()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Collection#cashboxTransfers
             * @methodOf lbServices.Collection
             *
             * @description
             *
             * Queries cashboxTransfers of Collection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransfer` object.)
             * </em>
             */
        R.cashboxTransfers = function() {
          var TargetResource = $injector.get("CashboxTransfer");
          var action = TargetResource["::get::Collection::cashboxTransfers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.cashboxTransfers#count
             * @methodOf lbServices.Collection.cashboxTransfers
             *
             * @description
             *
             * Counts cashboxTransfers of Collection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.cashboxTransfers.count = function() {
          var TargetResource = $injector.get("CashboxTransfer");
          var action = TargetResource["::count::Collection::cashboxTransfers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.cashboxTransfers#create
             * @methodOf lbServices.Collection.cashboxTransfers
             *
             * @description
             *
             * Creates a new instance in cashboxTransfers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransfer` object.)
             * </em>
             */
        R.cashboxTransfers.create = function() {
          var TargetResource = $injector.get("CashboxTransfer");
          var action = TargetResource["::create::Collection::cashboxTransfers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.cashboxTransfers#createMany
             * @methodOf lbServices.Collection.cashboxTransfers
             *
             * @description
             *
             * Creates a new instance in cashboxTransfers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransfer` object.)
             * </em>
             */
        R.cashboxTransfers.createMany = function() {
          var TargetResource = $injector.get("CashboxTransfer");
          var action = TargetResource["::createMany::Collection::cashboxTransfers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.cashboxTransfers#destroyAll
             * @methodOf lbServices.Collection.cashboxTransfers
             *
             * @description
             *
             * Deletes all cashboxTransfers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.cashboxTransfers.destroyAll = function() {
          var TargetResource = $injector.get("CashboxTransfer");
          var action = TargetResource["::delete::Collection::cashboxTransfers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.cashboxTransfers#destroyById
             * @methodOf lbServices.Collection.cashboxTransfers
             *
             * @description
             *
             * Delete a related item by id for cashboxTransfers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for cashboxTransfers
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.cashboxTransfers.destroyById = function() {
          var TargetResource = $injector.get("CashboxTransfer");
          var action = TargetResource["::destroyById::Collection::cashboxTransfers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.cashboxTransfers#findById
             * @methodOf lbServices.Collection.cashboxTransfers
             *
             * @description
             *
             * Find a related item by id for cashboxTransfers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for cashboxTransfers
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransfer` object.)
             * </em>
             */
        R.cashboxTransfers.findById = function() {
          var TargetResource = $injector.get("CashboxTransfer");
          var action = TargetResource["::findById::Collection::cashboxTransfers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Collection.cashboxTransfers#updateById
             * @methodOf lbServices.Collection.cashboxTransfers
             *
             * @description
             *
             * Update a related item by id for cashboxTransfers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collection id
             *
             *  - `fk` – `{*}` - Foreign key for cashboxTransfers
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransfer` object.)
             * </em>
             */
        R.cashboxTransfers.updateById = function() {
          var TargetResource = $injector.get("CashboxTransfer");
          var action = TargetResource["::updateById::Collection::cashboxTransfers"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Check
 * @header lbServices.Check
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Check` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Check",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Checks/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Check.client() instead.
            "prototype$__get__client": {
              url: urlBase + "/Checks/:id/client",
              method: "GET",
            },

            // INTERNAL. Use Check.paymentItem() instead.
            "prototype$__get__paymentItem": {
              url: urlBase + "/Checks/:id/paymentItem",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Check#create
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Checks",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Check#patchOrCreate
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Checks",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Check#replaceOrCreate
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Checks/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Check#upsertWithWhere
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Checks/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Check#exists
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Checks/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Check#findById
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Checks/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Check#replaceById
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Checks/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Check#find
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Checks",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Check#findOne
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Checks/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Check#updateAll
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Checks/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Check#deleteById
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Checks/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Check#count
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Checks/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Check#prototype$patchAttributes
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Check id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Checks/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Check#createChangeStream
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Checks/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Check#createMany
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Checks",
              method: "POST",
            },

            // INTERNAL. Use PaymentItem.check() instead.
            "::get::PaymentItem::check": {
              url: urlBase + "/PaymentItems/:id/check",
              method: "GET",
            },

            // INTERNAL. Use PaymentItem.check.create() instead.
            "::create::PaymentItem::check": {
              url: urlBase + "/PaymentItems/:id/check",
              method: "POST",
            },

            // INTERNAL. Use PaymentItem.check.createMany() instead.
            "::createMany::PaymentItem::check": {
              isArray: true,
              url: urlBase + "/PaymentItems/:id/check",
              method: "POST",
            },

            // INTERNAL. Use PaymentItem.check.update() instead.
            "::update::PaymentItem::check": {
              url: urlBase + "/PaymentItems/:id/check",
              method: "PUT",
            },

            // INTERNAL. Use PaymentItem.check.destroy() instead.
            "::destroy::PaymentItem::check": {
              url: urlBase + "/PaymentItems/:id/check",
              method: "DELETE",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Check#upsert
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Check#updateOrCreate
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Check#patchOrCreateWithWhere
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Check#update
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Check#destroyById
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Check#removeById
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Check#prototype$updateAttributes
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Check id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Check#modelName
        * @propertyOf lbServices.Check
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Check`.
        */
        R.modelName = "Check";


            /**
             * @ngdoc method
             * @name lbServices.Check#client
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Fetches belongsTo relation client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Check id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.client = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::Check::client"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Check#paymentItem
             * @methodOf lbServices.Check
             *
             * @description
             *
             * Fetches belongsTo relation paymentItem.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Check id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
        R.paymentItem = function() {
          var TargetResource = $injector.get("PaymentItem");
          var action = TargetResource["::get::Check::paymentItem"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Procedure
 * @header lbServices.Procedure
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Procedure` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Procedure",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Procedures/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Procedure.client() instead.
            "prototype$__get__client": {
              url: urlBase + "/Procedures/:id/client",
              method: "GET",
            },

            // INTERNAL. Use Procedure.quote() instead.
            "prototype$__get__quote": {
              url: urlBase + "/Procedures/:id/quote",
              method: "GET",
            },

            // INTERNAL. Use Procedure.items.findById() instead.
            "prototype$__findById__items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Procedures/:id/items/:fk",
              method: "GET",
            },

            // INTERNAL. Use Procedure.items.destroyById() instead.
            "prototype$__destroyById__items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Procedures/:id/items/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Procedure.items.updateById() instead.
            "prototype$__updateById__items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Procedures/:id/items/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Procedure.items() instead.
            "prototype$__get__items": {
              isArray: true,
              url: urlBase + "/Procedures/:id/items",
              method: "GET",
            },

            // INTERNAL. Use Procedure.items.create() instead.
            "prototype$__create__items": {
              url: urlBase + "/Procedures/:id/items",
              method: "POST",
            },

            // INTERNAL. Use Procedure.items.destroyAll() instead.
            "prototype$__delete__items": {
              url: urlBase + "/Procedures/:id/items",
              method: "DELETE",
            },

            // INTERNAL. Use Procedure.items.count() instead.
            "prototype$__count__items": {
              url: urlBase + "/Procedures/:id/items/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Procedure#create
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Procedures",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Procedure#patchOrCreate
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Procedures",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Procedure#replaceOrCreate
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Procedures/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Procedure#upsertWithWhere
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Procedures/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Procedure#exists
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Procedures/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Procedure#findById
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Procedures/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Procedure#replaceById
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Procedures/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Procedure#find
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Procedures",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Procedure#findOne
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Procedures/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Procedure#updateAll
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Procedures/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Procedure#deleteById
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Procedures/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Procedure#count
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Procedures/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Procedure#prototype$patchAttributes
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Procedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Procedures/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Procedure#createChangeStream
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Procedures/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Procedure#createMany
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Procedures",
              method: "POST",
            },

            // INTERNAL. Use Client.procedures.findById() instead.
            "::findById::Client::procedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/procedures/:fk",
              method: "GET",
            },

            // INTERNAL. Use Client.procedures.destroyById() instead.
            "::destroyById::Client::procedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/procedures/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Client.procedures.updateById() instead.
            "::updateById::Client::procedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/procedures/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Client.procedures() instead.
            "::get::Client::procedures": {
              isArray: true,
              url: urlBase + "/Clients/:id/procedures",
              method: "GET",
            },

            // INTERNAL. Use Client.procedures.create() instead.
            "::create::Client::procedures": {
              url: urlBase + "/Clients/:id/procedures",
              method: "POST",
            },

            // INTERNAL. Use Client.procedures.createMany() instead.
            "::createMany::Client::procedures": {
              isArray: true,
              url: urlBase + "/Clients/:id/procedures",
              method: "POST",
            },

            // INTERNAL. Use Client.procedures.destroyAll() instead.
            "::delete::Client::procedures": {
              url: urlBase + "/Clients/:id/procedures",
              method: "DELETE",
            },

            // INTERNAL. Use Client.procedures.count() instead.
            "::count::Client::procedures": {
              url: urlBase + "/Clients/:id/procedures/count",
              method: "GET",
            },

            // INTERNAL. Use Quote.procedures.findById() instead.
            "::findById::Quote::procedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/procedures/:fk",
              method: "GET",
            },

            // INTERNAL. Use Quote.procedures.destroyById() instead.
            "::destroyById::Quote::procedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/procedures/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.procedures.updateById() instead.
            "::updateById::Quote::procedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/procedures/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Quote.procedures() instead.
            "::get::Quote::procedures": {
              isArray: true,
              url: urlBase + "/Quotes/:id/procedures",
              method: "GET",
            },

            // INTERNAL. Use Quote.procedures.create() instead.
            "::create::Quote::procedures": {
              url: urlBase + "/Quotes/:id/procedures",
              method: "POST",
            },

            // INTERNAL. Use Quote.procedures.createMany() instead.
            "::createMany::Quote::procedures": {
              isArray: true,
              url: urlBase + "/Quotes/:id/procedures",
              method: "POST",
            },

            // INTERNAL. Use Quote.procedures.destroyAll() instead.
            "::delete::Quote::procedures": {
              url: urlBase + "/Quotes/:id/procedures",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.procedures.count() instead.
            "::count::Quote::procedures": {
              url: urlBase + "/Quotes/:id/procedures/count",
              method: "GET",
            },

            // INTERNAL. Use Item.procedure() instead.
            "::get::Item::procedure": {
              url: urlBase + "/Items/:id/procedure",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Procedure#upsert
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Procedure#updateOrCreate
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Procedure#patchOrCreateWithWhere
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Procedure#update
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Procedure#destroyById
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Procedure#removeById
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Procedure#prototype$updateAttributes
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Procedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Procedure#modelName
        * @propertyOf lbServices.Procedure
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Procedure`.
        */
        R.modelName = "Procedure";


            /**
             * @ngdoc method
             * @name lbServices.Procedure#client
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Fetches belongsTo relation client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Procedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.client = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::Procedure::client"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Procedure#quote
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Fetches belongsTo relation quote.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Procedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quote = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::get::Procedure::quote"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Procedure.items
     * @header lbServices.Procedure.items
     * @object
     * @description
     *
     * The object `Procedure.items` groups methods
     * manipulating `Item` instances related to `Procedure`.
     *
     * Call {@link lbServices.Procedure#items Procedure.items()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Procedure#items
             * @methodOf lbServices.Procedure
             *
             * @description
             *
             * Queries items of Procedure.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Procedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
        R.items = function() {
          var TargetResource = $injector.get("Item");
          var action = TargetResource["::get::Procedure::items"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Procedure.items#count
             * @methodOf lbServices.Procedure.items
             *
             * @description
             *
             * Counts items of Procedure.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Procedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.items.count = function() {
          var TargetResource = $injector.get("Item");
          var action = TargetResource["::count::Procedure::items"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Procedure.items#create
             * @methodOf lbServices.Procedure.items
             *
             * @description
             *
             * Creates a new instance in items of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Procedure id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
        R.items.create = function() {
          var TargetResource = $injector.get("Item");
          var action = TargetResource["::create::Procedure::items"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Procedure.items#createMany
             * @methodOf lbServices.Procedure.items
             *
             * @description
             *
             * Creates a new instance in items of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Procedure id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
        R.items.createMany = function() {
          var TargetResource = $injector.get("Item");
          var action = TargetResource["::createMany::Procedure::items"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Procedure.items#destroyAll
             * @methodOf lbServices.Procedure.items
             *
             * @description
             *
             * Deletes all items of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Procedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.items.destroyAll = function() {
          var TargetResource = $injector.get("Item");
          var action = TargetResource["::delete::Procedure::items"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Procedure.items#destroyById
             * @methodOf lbServices.Procedure.items
             *
             * @description
             *
             * Delete a related item by id for items.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Procedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for items
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.items.destroyById = function() {
          var TargetResource = $injector.get("Item");
          var action = TargetResource["::destroyById::Procedure::items"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Procedure.items#findById
             * @methodOf lbServices.Procedure.items
             *
             * @description
             *
             * Find a related item by id for items.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Procedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for items
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
        R.items.findById = function() {
          var TargetResource = $injector.get("Item");
          var action = TargetResource["::findById::Procedure::items"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Procedure.items#updateById
             * @methodOf lbServices.Procedure.items
             *
             * @description
             *
             * Update a related item by id for items.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Procedure id
             *
             *  - `fk` – `{*}` - Foreign key for items
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
        R.items.updateById = function() {
          var TargetResource = $injector.get("Item");
          var action = TargetResource["::updateById::Procedure::items"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PaymentItem
 * @header lbServices.PaymentItem
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PaymentItem` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PaymentItem",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/PaymentItems/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PaymentItem.bankTx() instead.
            "prototype$__get__bankTx": {
              url: urlBase + "/PaymentItems/:id/bankTx",
              method: "GET",
            },

            // INTERNAL. Use PaymentItem.bankTx.create() instead.
            "prototype$__create__bankTx": {
              url: urlBase + "/PaymentItems/:id/bankTx",
              method: "POST",
            },

            // INTERNAL. Use PaymentItem.bankTx.update() instead.
            "prototype$__update__bankTx": {
              url: urlBase + "/PaymentItems/:id/bankTx",
              method: "PUT",
            },

            // INTERNAL. Use PaymentItem.bankTx.destroy() instead.
            "prototype$__destroy__bankTx": {
              url: urlBase + "/PaymentItems/:id/bankTx",
              method: "DELETE",
            },

            // INTERNAL. Use PaymentItem.check() instead.
            "prototype$__get__check": {
              url: urlBase + "/PaymentItems/:id/check",
              method: "GET",
            },

            // INTERNAL. Use PaymentItem.check.create() instead.
            "prototype$__create__check": {
              url: urlBase + "/PaymentItems/:id/check",
              method: "POST",
            },

            // INTERNAL. Use PaymentItem.check.update() instead.
            "prototype$__update__check": {
              url: urlBase + "/PaymentItems/:id/check",
              method: "PUT",
            },

            // INTERNAL. Use PaymentItem.check.destroy() instead.
            "prototype$__destroy__check": {
              url: urlBase + "/PaymentItems/:id/check",
              method: "DELETE",
            },

            // INTERNAL. Use PaymentItem.receipt() instead.
            "prototype$__get__receipt": {
              url: urlBase + "/PaymentItems/:id/receipt",
              method: "GET",
            },

            // INTERNAL. Use PaymentItem.taxWithholding() instead.
            "prototype$__get__taxWithholding": {
              url: urlBase + "/PaymentItems/:id/taxWithholding",
              method: "GET",
            },

            // INTERNAL. Use PaymentItem.taxWithholding.create() instead.
            "prototype$__create__taxWithholding": {
              url: urlBase + "/PaymentItems/:id/taxWithholding",
              method: "POST",
            },

            // INTERNAL. Use PaymentItem.taxWithholding.update() instead.
            "prototype$__update__taxWithholding": {
              url: urlBase + "/PaymentItems/:id/taxWithholding",
              method: "PUT",
            },

            // INTERNAL. Use PaymentItem.taxWithholding.destroy() instead.
            "prototype$__destroy__taxWithholding": {
              url: urlBase + "/PaymentItems/:id/taxWithholding",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#create
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/PaymentItems",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#patchOrCreate
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/PaymentItems",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#replaceOrCreate
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/PaymentItems/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#upsertWithWhere
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/PaymentItems/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#exists
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/PaymentItems/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#findById
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/PaymentItems/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#replaceById
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/PaymentItems/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#find
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/PaymentItems",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#findOne
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/PaymentItems/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#updateAll
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/PaymentItems/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#deleteById
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/PaymentItems/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#count
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/PaymentItems/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#prototype$patchAttributes
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/PaymentItems/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#createChangeStream
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/PaymentItems/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#createMany
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/PaymentItems",
              method: "POST",
            },

            // INTERNAL. Use BankTx.paymentItem() instead.
            "::get::BankTx::paymentItem": {
              url: urlBase + "/BankTxs/:id/paymentItem",
              method: "GET",
            },

            // INTERNAL. Use Receipt.paymentItems.findById() instead.
            "::findById::Receipt::paymentItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/paymentItems/:fk",
              method: "GET",
            },

            // INTERNAL. Use Receipt.paymentItems.destroyById() instead.
            "::destroyById::Receipt::paymentItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/paymentItems/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.paymentItems.updateById() instead.
            "::updateById::Receipt::paymentItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/paymentItems/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Receipt.paymentItems() instead.
            "::get::Receipt::paymentItems": {
              isArray: true,
              url: urlBase + "/Receipts/:id/paymentItems",
              method: "GET",
            },

            // INTERNAL. Use Receipt.paymentItems.create() instead.
            "::create::Receipt::paymentItems": {
              url: urlBase + "/Receipts/:id/paymentItems",
              method: "POST",
            },

            // INTERNAL. Use Receipt.paymentItems.createMany() instead.
            "::createMany::Receipt::paymentItems": {
              isArray: true,
              url: urlBase + "/Receipts/:id/paymentItems",
              method: "POST",
            },

            // INTERNAL. Use Receipt.paymentItems.destroyAll() instead.
            "::delete::Receipt::paymentItems": {
              url: urlBase + "/Receipts/:id/paymentItems",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.paymentItems.count() instead.
            "::count::Receipt::paymentItems": {
              url: urlBase + "/Receipts/:id/paymentItems/count",
              method: "GET",
            },

            // INTERNAL. Use Check.paymentItem() instead.
            "::get::Check::paymentItem": {
              url: urlBase + "/Checks/:id/paymentItem",
              method: "GET",
            },

            // INTERNAL. Use TaxWithholding.paymentItem() instead.
            "::get::TaxWithholding::paymentItem": {
              url: urlBase + "/TaxWithholdings/:id/paymentItem",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#upsert
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#updateOrCreate
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#patchOrCreateWithWhere
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#update
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#destroyById
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#removeById
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#prototype$updateAttributes
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PaymentItem#modelName
        * @propertyOf lbServices.PaymentItem
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PaymentItem`.
        */
        R.modelName = "PaymentItem";

    /**
     * @ngdoc object
     * @name lbServices.PaymentItem.bankTx
     * @header lbServices.PaymentItem.bankTx
     * @object
     * @description
     *
     * The object `PaymentItem.bankTx` groups methods
     * manipulating `BankTx` instances related to `PaymentItem`.
     *
     * Call {@link lbServices.PaymentItem#bankTx PaymentItem.bankTx()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#bankTx
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Fetches hasOne relation bankTx.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R.bankTx = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::get::PaymentItem::bankTx"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem.bankTx#create
             * @methodOf lbServices.PaymentItem.bankTx
             *
             * @description
             *
             * Creates a new instance in bankTx of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R.bankTx.create = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::create::PaymentItem::bankTx"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem.bankTx#createMany
             * @methodOf lbServices.PaymentItem.bankTx
             *
             * @description
             *
             * Creates a new instance in bankTx of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R.bankTx.createMany = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::createMany::PaymentItem::bankTx"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem.bankTx#destroy
             * @methodOf lbServices.PaymentItem.bankTx
             *
             * @description
             *
             * Deletes bankTx of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bankTx.destroy = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::destroy::PaymentItem::bankTx"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem.bankTx#update
             * @methodOf lbServices.PaymentItem.bankTx
             *
             * @description
             *
             * Update bankTx of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTx` object.)
             * </em>
             */
        R.bankTx.update = function() {
          var TargetResource = $injector.get("BankTx");
          var action = TargetResource["::update::PaymentItem::bankTx"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.PaymentItem.check
     * @header lbServices.PaymentItem.check
     * @object
     * @description
     *
     * The object `PaymentItem.check` groups methods
     * manipulating `Check` instances related to `PaymentItem`.
     *
     * Call {@link lbServices.PaymentItem#check PaymentItem.check()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#check
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Fetches hasOne relation check.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
        R.check = function() {
          var TargetResource = $injector.get("Check");
          var action = TargetResource["::get::PaymentItem::check"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem.check#create
             * @methodOf lbServices.PaymentItem.check
             *
             * @description
             *
             * Creates a new instance in check of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
        R.check.create = function() {
          var TargetResource = $injector.get("Check");
          var action = TargetResource["::create::PaymentItem::check"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem.check#createMany
             * @methodOf lbServices.PaymentItem.check
             *
             * @description
             *
             * Creates a new instance in check of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
        R.check.createMany = function() {
          var TargetResource = $injector.get("Check");
          var action = TargetResource["::createMany::PaymentItem::check"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem.check#destroy
             * @methodOf lbServices.PaymentItem.check
             *
             * @description
             *
             * Deletes check of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.check.destroy = function() {
          var TargetResource = $injector.get("Check");
          var action = TargetResource["::destroy::PaymentItem::check"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem.check#update
             * @methodOf lbServices.PaymentItem.check
             *
             * @description
             *
             * Update check of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Check` object.)
             * </em>
             */
        R.check.update = function() {
          var TargetResource = $injector.get("Check");
          var action = TargetResource["::update::PaymentItem::check"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#receipt
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Fetches belongsTo relation receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipt = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::get::PaymentItem::receipt"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.PaymentItem.taxWithholding
     * @header lbServices.PaymentItem.taxWithholding
     * @object
     * @description
     *
     * The object `PaymentItem.taxWithholding` groups methods
     * manipulating `TaxWithholding` instances related to `PaymentItem`.
     *
     * Call {@link lbServices.PaymentItem#taxWithholding PaymentItem.taxWithholding()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.PaymentItem#taxWithholding
             * @methodOf lbServices.PaymentItem
             *
             * @description
             *
             * Fetches hasOne relation taxWithholding.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
        R.taxWithholding = function() {
          var TargetResource = $injector.get("TaxWithholding");
          var action = TargetResource["::get::PaymentItem::taxWithholding"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem.taxWithholding#create
             * @methodOf lbServices.PaymentItem.taxWithholding
             *
             * @description
             *
             * Creates a new instance in taxWithholding of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
        R.taxWithholding.create = function() {
          var TargetResource = $injector.get("TaxWithholding");
          var action = TargetResource["::create::PaymentItem::taxWithholding"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem.taxWithholding#createMany
             * @methodOf lbServices.PaymentItem.taxWithholding
             *
             * @description
             *
             * Creates a new instance in taxWithholding of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
        R.taxWithholding.createMany = function() {
          var TargetResource = $injector.get("TaxWithholding");
          var action = TargetResource["::createMany::PaymentItem::taxWithholding"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem.taxWithholding#destroy
             * @methodOf lbServices.PaymentItem.taxWithholding
             *
             * @description
             *
             * Deletes taxWithholding of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.taxWithholding.destroy = function() {
          var TargetResource = $injector.get("TaxWithholding");
          var action = TargetResource["::destroy::PaymentItem::taxWithholding"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PaymentItem.taxWithholding#update
             * @methodOf lbServices.PaymentItem.taxWithholding
             *
             * @description
             *
             * Update taxWithholding of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PaymentItem id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
        R.taxWithholding.update = function() {
          var TargetResource = $injector.get("TaxWithholding");
          var action = TargetResource["::update::PaymentItem::taxWithholding"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ItemTemplate
 * @header lbServices.ItemTemplate
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ItemTemplate` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ItemTemplate",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ItemTemplates/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ItemTemplate.procedureTemplates.findById() instead.
            "prototype$__findById__procedureTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplates/:fk",
              method: "GET",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.destroyById() instead.
            "prototype$__destroyById__procedureTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplates/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.updateById() instead.
            "prototype$__updateById__procedureTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplates/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.link() instead.
            "prototype$__link__procedureTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplates/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.unlink() instead.
            "prototype$__unlink__procedureTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplates/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.exists() instead.
            "prototype$__exists__procedureTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplates/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#prototype$__findById__procedureTemplateItemTemplates
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Find a related item by id for procedureTemplateItemTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplateItemTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "prototype$__findById__procedureTemplateItemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplateItemTemplates/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#prototype$__destroyById__procedureTemplateItemTemplates
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Delete a related item by id for procedureTemplateItemTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplateItemTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__procedureTemplateItemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplateItemTemplates/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#prototype$__updateById__procedureTemplateItemTemplates
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Update a related item by id for procedureTemplateItemTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplateItemTemplates
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "prototype$__updateById__procedureTemplateItemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplateItemTemplates/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#prototype$__link__procedureTemplateItemTemplates
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Add a related item by id for procedureTemplateItemTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplateItemTemplates
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "prototype$__link__procedureTemplateItemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplateItemTemplates/rel/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#prototype$__unlink__procedureTemplateItemTemplates
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Remove the procedureTemplateItemTemplates relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplateItemTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__unlink__procedureTemplateItemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplateItemTemplates/rel/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#prototype$__exists__procedureTemplateItemTemplates
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Check the existence of procedureTemplateItemTemplates relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplateItemTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "prototype$__exists__procedureTemplateItemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplateItemTemplates/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates() instead.
            "prototype$__get__procedureTemplates": {
              isArray: true,
              url: urlBase + "/ItemTemplates/:id/procedureTemplates",
              method: "GET",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.create() instead.
            "prototype$__create__procedureTemplates": {
              url: urlBase + "/ItemTemplates/:id/procedureTemplates",
              method: "POST",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.destroyAll() instead.
            "prototype$__delete__procedureTemplates": {
              url: urlBase + "/ItemTemplates/:id/procedureTemplates",
              method: "DELETE",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.count() instead.
            "prototype$__count__procedureTemplates": {
              url: urlBase + "/ItemTemplates/:id/procedureTemplates/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#prototype$__get__procedureTemplateItemTemplates
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Queries procedureTemplateItemTemplates of ItemTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "prototype$__get__procedureTemplateItemTemplates": {
              isArray: true,
              url: urlBase + "/ItemTemplates/:id/procedureTemplateItemTemplates",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#prototype$__create__procedureTemplateItemTemplates
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Creates a new instance in procedureTemplateItemTemplates of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "prototype$__create__procedureTemplateItemTemplates": {
              url: urlBase + "/ItemTemplates/:id/procedureTemplateItemTemplates",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#prototype$__delete__procedureTemplateItemTemplates
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Deletes all procedureTemplateItemTemplates of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__procedureTemplateItemTemplates": {
              url: urlBase + "/ItemTemplates/:id/procedureTemplateItemTemplates",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#prototype$__count__procedureTemplateItemTemplates
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Counts procedureTemplateItemTemplates of ItemTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__procedureTemplateItemTemplates": {
              url: urlBase + "/ItemTemplates/:id/procedureTemplateItemTemplates/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#create
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/ItemTemplates",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#patchOrCreate
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/ItemTemplates",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#replaceOrCreate
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/ItemTemplates/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#upsertWithWhere
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/ItemTemplates/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#exists
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/ItemTemplates/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#findById
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/ItemTemplates/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#replaceById
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/ItemTemplates/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#find
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/ItemTemplates",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#findOne
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/ItemTemplates/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#updateAll
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/ItemTemplates/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#deleteById
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/ItemTemplates/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#count
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/ItemTemplates/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#prototype$patchAttributes
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/ItemTemplates/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#createChangeStream
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/ItemTemplates/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#hide
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * softdelete
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - item template id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "hide": {
              url: urlBase + "/ItemTemplates/hide",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#unhide
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * unsoftdelete
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - item template id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "unhide": {
              url: urlBase + "/ItemTemplates/unhide",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#createMany
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/ItemTemplates",
              method: "POST",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.findById() instead.
            "::findById::ProcedureTemplate::itemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates/:fk",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.destroyById() instead.
            "::destroyById::ProcedureTemplate::itemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.updateById() instead.
            "::updateById::ProcedureTemplate::itemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.link() instead.
            "::link::ProcedureTemplate::itemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.unlink() instead.
            "::unlink::ProcedureTemplate::itemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.exists() instead.
            "::exists::ProcedureTemplate::itemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates() instead.
            "::get::ProcedureTemplate::itemTemplates": {
              isArray: true,
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.create() instead.
            "::create::ProcedureTemplate::itemTemplates": {
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates",
              method: "POST",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.createMany() instead.
            "::createMany::ProcedureTemplate::itemTemplates": {
              isArray: true,
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates",
              method: "POST",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.destroyAll() instead.
            "::delete::ProcedureTemplate::itemTemplates": {
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.count() instead.
            "::count::ProcedureTemplate::itemTemplates": {
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#upsert
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#updateOrCreate
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#patchOrCreateWithWhere
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#update
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#destroyById
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#removeById
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#prototype$updateAttributes
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ItemTemplate#modelName
        * @propertyOf lbServices.ItemTemplate
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ItemTemplate`.
        */
        R.modelName = "ItemTemplate";

    /**
     * @ngdoc object
     * @name lbServices.ItemTemplate.procedureTemplates
     * @header lbServices.ItemTemplate.procedureTemplates
     * @object
     * @description
     *
     * The object `ItemTemplate.procedureTemplates` groups methods
     * manipulating `ProcedureTemplate` instances related to `ItemTemplate`.
     *
     * Call {@link lbServices.ItemTemplate#procedureTemplates ItemTemplate.procedureTemplates()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate#procedureTemplates
             * @methodOf lbServices.ItemTemplate
             *
             * @description
             *
             * Queries procedureTemplates of ItemTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.procedureTemplates = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::get::ItemTemplate::procedureTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate.procedureTemplates#count
             * @methodOf lbServices.ItemTemplate.procedureTemplates
             *
             * @description
             *
             * Counts procedureTemplates of ItemTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.procedureTemplates.count = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::count::ItemTemplate::procedureTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate.procedureTemplates#create
             * @methodOf lbServices.ItemTemplate.procedureTemplates
             *
             * @description
             *
             * Creates a new instance in procedureTemplates of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.procedureTemplates.create = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::create::ItemTemplate::procedureTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate.procedureTemplates#createMany
             * @methodOf lbServices.ItemTemplate.procedureTemplates
             *
             * @description
             *
             * Creates a new instance in procedureTemplates of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.procedureTemplates.createMany = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::createMany::ItemTemplate::procedureTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate.procedureTemplates#destroyAll
             * @methodOf lbServices.ItemTemplate.procedureTemplates
             *
             * @description
             *
             * Deletes all procedureTemplates of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.procedureTemplates.destroyAll = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::delete::ItemTemplate::procedureTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate.procedureTemplates#destroyById
             * @methodOf lbServices.ItemTemplate.procedureTemplates
             *
             * @description
             *
             * Delete a related item by id for procedureTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.procedureTemplates.destroyById = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::destroyById::ItemTemplate::procedureTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate.procedureTemplates#exists
             * @methodOf lbServices.ItemTemplate.procedureTemplates
             *
             * @description
             *
             * Check the existence of procedureTemplates relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.procedureTemplates.exists = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::exists::ItemTemplate::procedureTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate.procedureTemplates#findById
             * @methodOf lbServices.ItemTemplate.procedureTemplates
             *
             * @description
             *
             * Find a related item by id for procedureTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.procedureTemplates.findById = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::findById::ItemTemplate::procedureTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate.procedureTemplates#link
             * @methodOf lbServices.ItemTemplate.procedureTemplates
             *
             * @description
             *
             * Add a related item by id for procedureTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplates
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.procedureTemplates.link = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::link::ItemTemplate::procedureTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate.procedureTemplates#unlink
             * @methodOf lbServices.ItemTemplate.procedureTemplates
             *
             * @description
             *
             * Remove the procedureTemplates relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.procedureTemplates.unlink = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::unlink::ItemTemplate::procedureTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ItemTemplate.procedureTemplates#updateById
             * @methodOf lbServices.ItemTemplate.procedureTemplates
             *
             * @description
             *
             * Update a related item by id for procedureTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ItemTemplate id
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplates
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.procedureTemplates.updateById = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::updateById::ItemTemplate::procedureTemplates"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ProcedureTemplate
 * @header lbServices.ProcedureTemplate
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ProcedureTemplate` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ProcedureTemplate",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ProcedureTemplates/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ProcedureTemplate.itemTemplates.findById() instead.
            "prototype$__findById__itemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates/:fk",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.destroyById() instead.
            "prototype$__destroyById__itemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.updateById() instead.
            "prototype$__updateById__itemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.link() instead.
            "prototype$__link__itemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.unlink() instead.
            "prototype$__unlink__itemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.exists() instead.
            "prototype$__exists__itemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__findById__procedureTemplateItemTemplates
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Find a related item by id for procedureTemplateItemTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplateItemTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "prototype$__findById__procedureTemplateItemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateItemTemplates/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__destroyById__procedureTemplateItemTemplates
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Delete a related item by id for procedureTemplateItemTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplateItemTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__procedureTemplateItemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateItemTemplates/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__updateById__procedureTemplateItemTemplates
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Update a related item by id for procedureTemplateItemTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplateItemTemplates
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "prototype$__updateById__procedureTemplateItemTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateItemTemplates/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProcedureTemplate.children.findById() instead.
            "prototype$__findById__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/children/:fk",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.children.destroyById() instead.
            "prototype$__destroyById__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/children/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.children.updateById() instead.
            "prototype$__updateById__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/children/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProcedureTemplate.children.link() instead.
            "prototype$__link__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/children/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProcedureTemplate.children.unlink() instead.
            "prototype$__unlink__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/children/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.children.exists() instead.
            "prototype$__exists__children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/children/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use ProcedureTemplate.parents.findById() instead.
            "prototype$__findById__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/parents/:fk",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.parents.destroyById() instead.
            "prototype$__destroyById__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/parents/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.parents.updateById() instead.
            "prototype$__updateById__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/parents/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProcedureTemplate.parents.link() instead.
            "prototype$__link__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/parents/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProcedureTemplate.parents.unlink() instead.
            "prototype$__unlink__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/parents/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.parents.exists() instead.
            "prototype$__exists__parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/parents/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__findById__procedureTemplateChildren
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Find a related item by id for procedureTemplateChildren.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplateChildren
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "prototype$__findById__procedureTemplateChildren": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateChildren/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__destroyById__procedureTemplateChildren
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Delete a related item by id for procedureTemplateChildren.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplateChildren
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__procedureTemplateChildren": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateChildren/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__updateById__procedureTemplateChildren
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Update a related item by id for procedureTemplateChildren.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplateChildren
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "prototype$__updateById__procedureTemplateChildren": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateChildren/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__findById__procedureTemplateParents
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Find a related item by id for procedureTemplateParents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplateParents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "prototype$__findById__procedureTemplateParents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateParents/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__destroyById__procedureTemplateParents
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Delete a related item by id for procedureTemplateParents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplateParents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__procedureTemplateParents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateParents/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__updateById__procedureTemplateParents
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Update a related item by id for procedureTemplateParents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `fk` – `{*}` - Foreign key for procedureTemplateParents
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "prototype$__updateById__procedureTemplateParents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateParents/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates() instead.
            "prototype$__get__itemTemplates": {
              isArray: true,
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.create() instead.
            "prototype$__create__itemTemplates": {
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates",
              method: "POST",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.destroyAll() instead.
            "prototype$__delete__itemTemplates": {
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.itemTemplates.count() instead.
            "prototype$__count__itemTemplates": {
              url: urlBase + "/ProcedureTemplates/:id/itemTemplates/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__get__procedureTemplateItemTemplates
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Queries procedureTemplateItemTemplates of ProcedureTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "prototype$__get__procedureTemplateItemTemplates": {
              isArray: true,
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateItemTemplates",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__create__procedureTemplateItemTemplates
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Creates a new instance in procedureTemplateItemTemplates of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "prototype$__create__procedureTemplateItemTemplates": {
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateItemTemplates",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__delete__procedureTemplateItemTemplates
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Deletes all procedureTemplateItemTemplates of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__procedureTemplateItemTemplates": {
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateItemTemplates",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__count__procedureTemplateItemTemplates
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Counts procedureTemplateItemTemplates of ProcedureTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__procedureTemplateItemTemplates": {
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateItemTemplates/count",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.children() instead.
            "prototype$__get__children": {
              isArray: true,
              url: urlBase + "/ProcedureTemplates/:id/children",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.children.create() instead.
            "prototype$__create__children": {
              url: urlBase + "/ProcedureTemplates/:id/children",
              method: "POST",
            },

            // INTERNAL. Use ProcedureTemplate.children.destroyAll() instead.
            "prototype$__delete__children": {
              url: urlBase + "/ProcedureTemplates/:id/children",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.children.count() instead.
            "prototype$__count__children": {
              url: urlBase + "/ProcedureTemplates/:id/children/count",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.parents() instead.
            "prototype$__get__parents": {
              isArray: true,
              url: urlBase + "/ProcedureTemplates/:id/parents",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.parents.create() instead.
            "prototype$__create__parents": {
              url: urlBase + "/ProcedureTemplates/:id/parents",
              method: "POST",
            },

            // INTERNAL. Use ProcedureTemplate.parents.destroyAll() instead.
            "prototype$__delete__parents": {
              url: urlBase + "/ProcedureTemplates/:id/parents",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.parents.count() instead.
            "prototype$__count__parents": {
              url: urlBase + "/ProcedureTemplates/:id/parents/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__get__procedureTemplateChildren
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Queries procedureTemplateChildren of ProcedureTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "prototype$__get__procedureTemplateChildren": {
              isArray: true,
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateChildren",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__create__procedureTemplateChildren
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Creates a new instance in procedureTemplateChildren of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "prototype$__create__procedureTemplateChildren": {
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateChildren",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__delete__procedureTemplateChildren
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Deletes all procedureTemplateChildren of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__procedureTemplateChildren": {
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateChildren",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__count__procedureTemplateChildren
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Counts procedureTemplateChildren of ProcedureTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__procedureTemplateChildren": {
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateChildren/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__get__procedureTemplateParents
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Queries procedureTemplateParents of ProcedureTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "prototype$__get__procedureTemplateParents": {
              isArray: true,
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateParents",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__create__procedureTemplateParents
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Creates a new instance in procedureTemplateParents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "prototype$__create__procedureTemplateParents": {
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateParents",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__delete__procedureTemplateParents
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Deletes all procedureTemplateParents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__procedureTemplateParents": {
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateParents",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$__count__procedureTemplateParents
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Counts procedureTemplateParents of ProcedureTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__procedureTemplateParents": {
              url: urlBase + "/ProcedureTemplates/:id/procedureTemplateParents/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#create
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/ProcedureTemplates",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#patchOrCreate
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/ProcedureTemplates",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#replaceOrCreate
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/ProcedureTemplates/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#upsertWithWhere
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/ProcedureTemplates/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#exists
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/ProcedureTemplates/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#findById
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/ProcedureTemplates/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#replaceById
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/ProcedureTemplates/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#find
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/ProcedureTemplates",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#findOne
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/ProcedureTemplates/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#updateAll
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/ProcedureTemplates/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#deleteById
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/ProcedureTemplates/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#count
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/ProcedureTemplates/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$patchAttributes
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/ProcedureTemplates/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#createChangeStream
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/ProcedureTemplates/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#addItemTemplate
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `procedureTemplateId` – `{number}` -
             *
             *  - `itemTemplateId` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "addItemTemplate": {
              url: urlBase + "/ProcedureTemplates/addItemTemplate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#removeItemTemplate
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `procedureTemplateId` – `{number}` -
             *
             *  - `itemTemplateId` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "removeItemTemplate": {
              url: urlBase + "/ProcedureTemplates/removeItemTemplate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#createMany
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/ProcedureTemplates",
              method: "POST",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.findById() instead.
            "::findById::ItemTemplate::procedureTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplates/:fk",
              method: "GET",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.destroyById() instead.
            "::destroyById::ItemTemplate::procedureTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplates/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.updateById() instead.
            "::updateById::ItemTemplate::procedureTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplates/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.link() instead.
            "::link::ItemTemplate::procedureTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplates/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.unlink() instead.
            "::unlink::ItemTemplate::procedureTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplates/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.exists() instead.
            "::exists::ItemTemplate::procedureTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ItemTemplates/:id/procedureTemplates/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates() instead.
            "::get::ItemTemplate::procedureTemplates": {
              isArray: true,
              url: urlBase + "/ItemTemplates/:id/procedureTemplates",
              method: "GET",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.create() instead.
            "::create::ItemTemplate::procedureTemplates": {
              url: urlBase + "/ItemTemplates/:id/procedureTemplates",
              method: "POST",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.createMany() instead.
            "::createMany::ItemTemplate::procedureTemplates": {
              isArray: true,
              url: urlBase + "/ItemTemplates/:id/procedureTemplates",
              method: "POST",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.destroyAll() instead.
            "::delete::ItemTemplate::procedureTemplates": {
              url: urlBase + "/ItemTemplates/:id/procedureTemplates",
              method: "DELETE",
            },

            // INTERNAL. Use ItemTemplate.procedureTemplates.count() instead.
            "::count::ItemTemplate::procedureTemplates": {
              url: urlBase + "/ItemTemplates/:id/procedureTemplates/count",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.children.findById() instead.
            "::findById::ProcedureTemplate::children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/children/:fk",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.children.destroyById() instead.
            "::destroyById::ProcedureTemplate::children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/children/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.children.updateById() instead.
            "::updateById::ProcedureTemplate::children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/children/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProcedureTemplate.children.link() instead.
            "::link::ProcedureTemplate::children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/children/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProcedureTemplate.children.unlink() instead.
            "::unlink::ProcedureTemplate::children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/children/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.children.exists() instead.
            "::exists::ProcedureTemplate::children": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/children/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use ProcedureTemplate.parents.findById() instead.
            "::findById::ProcedureTemplate::parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/parents/:fk",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.parents.destroyById() instead.
            "::destroyById::ProcedureTemplate::parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/parents/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.parents.updateById() instead.
            "::updateById::ProcedureTemplate::parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/parents/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProcedureTemplate.parents.link() instead.
            "::link::ProcedureTemplate::parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/parents/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProcedureTemplate.parents.unlink() instead.
            "::unlink::ProcedureTemplate::parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/parents/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.parents.exists() instead.
            "::exists::ProcedureTemplate::parents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/ProcedureTemplates/:id/parents/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use ProcedureTemplate.children() instead.
            "::get::ProcedureTemplate::children": {
              isArray: true,
              url: urlBase + "/ProcedureTemplates/:id/children",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.children.create() instead.
            "::create::ProcedureTemplate::children": {
              url: urlBase + "/ProcedureTemplates/:id/children",
              method: "POST",
            },

            // INTERNAL. Use ProcedureTemplate.children.createMany() instead.
            "::createMany::ProcedureTemplate::children": {
              isArray: true,
              url: urlBase + "/ProcedureTemplates/:id/children",
              method: "POST",
            },

            // INTERNAL. Use ProcedureTemplate.children.destroyAll() instead.
            "::delete::ProcedureTemplate::children": {
              url: urlBase + "/ProcedureTemplates/:id/children",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.children.count() instead.
            "::count::ProcedureTemplate::children": {
              url: urlBase + "/ProcedureTemplates/:id/children/count",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.parents() instead.
            "::get::ProcedureTemplate::parents": {
              isArray: true,
              url: urlBase + "/ProcedureTemplates/:id/parents",
              method: "GET",
            },

            // INTERNAL. Use ProcedureTemplate.parents.create() instead.
            "::create::ProcedureTemplate::parents": {
              url: urlBase + "/ProcedureTemplates/:id/parents",
              method: "POST",
            },

            // INTERNAL. Use ProcedureTemplate.parents.createMany() instead.
            "::createMany::ProcedureTemplate::parents": {
              isArray: true,
              url: urlBase + "/ProcedureTemplates/:id/parents",
              method: "POST",
            },

            // INTERNAL. Use ProcedureTemplate.parents.destroyAll() instead.
            "::delete::ProcedureTemplate::parents": {
              url: urlBase + "/ProcedureTemplates/:id/parents",
              method: "DELETE",
            },

            // INTERNAL. Use ProcedureTemplate.parents.count() instead.
            "::count::ProcedureTemplate::parents": {
              url: urlBase + "/ProcedureTemplates/:id/parents/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#upsert
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#updateOrCreate
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#patchOrCreateWithWhere
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#update
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#destroyById
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#removeById
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#prototype$updateAttributes
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ProcedureTemplate#modelName
        * @propertyOf lbServices.ProcedureTemplate
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ProcedureTemplate`.
        */
        R.modelName = "ProcedureTemplate";

    /**
     * @ngdoc object
     * @name lbServices.ProcedureTemplate.itemTemplates
     * @header lbServices.ProcedureTemplate.itemTemplates
     * @object
     * @description
     *
     * The object `ProcedureTemplate.itemTemplates` groups methods
     * manipulating `ItemTemplate` instances related to `ProcedureTemplate`.
     *
     * Call {@link lbServices.ProcedureTemplate#itemTemplates ProcedureTemplate.itemTemplates()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#itemTemplates
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Queries itemTemplates of ProcedureTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
        R.itemTemplates = function() {
          var TargetResource = $injector.get("ItemTemplate");
          var action = TargetResource["::get::ProcedureTemplate::itemTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.itemTemplates#count
             * @methodOf lbServices.ProcedureTemplate.itemTemplates
             *
             * @description
             *
             * Counts itemTemplates of ProcedureTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.itemTemplates.count = function() {
          var TargetResource = $injector.get("ItemTemplate");
          var action = TargetResource["::count::ProcedureTemplate::itemTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.itemTemplates#create
             * @methodOf lbServices.ProcedureTemplate.itemTemplates
             *
             * @description
             *
             * Creates a new instance in itemTemplates of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
        R.itemTemplates.create = function() {
          var TargetResource = $injector.get("ItemTemplate");
          var action = TargetResource["::create::ProcedureTemplate::itemTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.itemTemplates#createMany
             * @methodOf lbServices.ProcedureTemplate.itemTemplates
             *
             * @description
             *
             * Creates a new instance in itemTemplates of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
        R.itemTemplates.createMany = function() {
          var TargetResource = $injector.get("ItemTemplate");
          var action = TargetResource["::createMany::ProcedureTemplate::itemTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.itemTemplates#destroyAll
             * @methodOf lbServices.ProcedureTemplate.itemTemplates
             *
             * @description
             *
             * Deletes all itemTemplates of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.itemTemplates.destroyAll = function() {
          var TargetResource = $injector.get("ItemTemplate");
          var action = TargetResource["::delete::ProcedureTemplate::itemTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.itemTemplates#destroyById
             * @methodOf lbServices.ProcedureTemplate.itemTemplates
             *
             * @description
             *
             * Delete a related item by id for itemTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for itemTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.itemTemplates.destroyById = function() {
          var TargetResource = $injector.get("ItemTemplate");
          var action = TargetResource["::destroyById::ProcedureTemplate::itemTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.itemTemplates#exists
             * @methodOf lbServices.ProcedureTemplate.itemTemplates
             *
             * @description
             *
             * Check the existence of itemTemplates relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for itemTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
        R.itemTemplates.exists = function() {
          var TargetResource = $injector.get("ItemTemplate");
          var action = TargetResource["::exists::ProcedureTemplate::itemTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.itemTemplates#findById
             * @methodOf lbServices.ProcedureTemplate.itemTemplates
             *
             * @description
             *
             * Find a related item by id for itemTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for itemTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
        R.itemTemplates.findById = function() {
          var TargetResource = $injector.get("ItemTemplate");
          var action = TargetResource["::findById::ProcedureTemplate::itemTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.itemTemplates#link
             * @methodOf lbServices.ProcedureTemplate.itemTemplates
             *
             * @description
             *
             * Add a related item by id for itemTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `fk` – `{*}` - Foreign key for itemTemplates
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
        R.itemTemplates.link = function() {
          var TargetResource = $injector.get("ItemTemplate");
          var action = TargetResource["::link::ProcedureTemplate::itemTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.itemTemplates#unlink
             * @methodOf lbServices.ProcedureTemplate.itemTemplates
             *
             * @description
             *
             * Remove the itemTemplates relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for itemTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.itemTemplates.unlink = function() {
          var TargetResource = $injector.get("ItemTemplate");
          var action = TargetResource["::unlink::ProcedureTemplate::itemTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.itemTemplates#updateById
             * @methodOf lbServices.ProcedureTemplate.itemTemplates
             *
             * @description
             *
             * Update a related item by id for itemTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `fk` – `{*}` - Foreign key for itemTemplates
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ItemTemplate` object.)
             * </em>
             */
        R.itemTemplates.updateById = function() {
          var TargetResource = $injector.get("ItemTemplate");
          var action = TargetResource["::updateById::ProcedureTemplate::itemTemplates"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.ProcedureTemplate.children
     * @header lbServices.ProcedureTemplate.children
     * @object
     * @description
     *
     * The object `ProcedureTemplate.children` groups methods
     * manipulating `ProcedureTemplate` instances related to `ProcedureTemplate`.
     *
     * Call {@link lbServices.ProcedureTemplate#children ProcedureTemplate.children()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#children
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Queries children of ProcedureTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.children = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::get::ProcedureTemplate::children"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.children#count
             * @methodOf lbServices.ProcedureTemplate.children
             *
             * @description
             *
             * Counts children of ProcedureTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.children.count = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::count::ProcedureTemplate::children"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.children#create
             * @methodOf lbServices.ProcedureTemplate.children
             *
             * @description
             *
             * Creates a new instance in children of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.children.create = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::create::ProcedureTemplate::children"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.children#createMany
             * @methodOf lbServices.ProcedureTemplate.children
             *
             * @description
             *
             * Creates a new instance in children of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.children.createMany = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::createMany::ProcedureTemplate::children"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.children#destroyAll
             * @methodOf lbServices.ProcedureTemplate.children
             *
             * @description
             *
             * Deletes all children of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.children.destroyAll = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::delete::ProcedureTemplate::children"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.children#destroyById
             * @methodOf lbServices.ProcedureTemplate.children
             *
             * @description
             *
             * Delete a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.children.destroyById = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::destroyById::ProcedureTemplate::children"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.children#exists
             * @methodOf lbServices.ProcedureTemplate.children
             *
             * @description
             *
             * Check the existence of children relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.children.exists = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::exists::ProcedureTemplate::children"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.children#findById
             * @methodOf lbServices.ProcedureTemplate.children
             *
             * @description
             *
             * Find a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.children.findById = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::findById::ProcedureTemplate::children"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.children#link
             * @methodOf lbServices.ProcedureTemplate.children
             *
             * @description
             *
             * Add a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.children.link = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::link::ProcedureTemplate::children"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.children#unlink
             * @methodOf lbServices.ProcedureTemplate.children
             *
             * @description
             *
             * Remove the children relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.children.unlink = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::unlink::ProcedureTemplate::children"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.children#updateById
             * @methodOf lbServices.ProcedureTemplate.children
             *
             * @description
             *
             * Update a related item by id for children.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `fk` – `{*}` - Foreign key for children
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.children.updateById = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::updateById::ProcedureTemplate::children"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.ProcedureTemplate.parents
     * @header lbServices.ProcedureTemplate.parents
     * @object
     * @description
     *
     * The object `ProcedureTemplate.parents` groups methods
     * manipulating `ProcedureTemplate` instances related to `ProcedureTemplate`.
     *
     * Call {@link lbServices.ProcedureTemplate#parents ProcedureTemplate.parents()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate#parents
             * @methodOf lbServices.ProcedureTemplate
             *
             * @description
             *
             * Queries parents of ProcedureTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.parents = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::get::ProcedureTemplate::parents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.parents#count
             * @methodOf lbServices.ProcedureTemplate.parents
             *
             * @description
             *
             * Counts parents of ProcedureTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.parents.count = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::count::ProcedureTemplate::parents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.parents#create
             * @methodOf lbServices.ProcedureTemplate.parents
             *
             * @description
             *
             * Creates a new instance in parents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.parents.create = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::create::ProcedureTemplate::parents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.parents#createMany
             * @methodOf lbServices.ProcedureTemplate.parents
             *
             * @description
             *
             * Creates a new instance in parents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.parents.createMany = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::createMany::ProcedureTemplate::parents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.parents#destroyAll
             * @methodOf lbServices.ProcedureTemplate.parents
             *
             * @description
             *
             * Deletes all parents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.parents.destroyAll = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::delete::ProcedureTemplate::parents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.parents#destroyById
             * @methodOf lbServices.ProcedureTemplate.parents
             *
             * @description
             *
             * Delete a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.parents.destroyById = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::destroyById::ProcedureTemplate::parents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.parents#exists
             * @methodOf lbServices.ProcedureTemplate.parents
             *
             * @description
             *
             * Check the existence of parents relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.parents.exists = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::exists::ProcedureTemplate::parents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.parents#findById
             * @methodOf lbServices.ProcedureTemplate.parents
             *
             * @description
             *
             * Find a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.parents.findById = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::findById::ProcedureTemplate::parents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.parents#link
             * @methodOf lbServices.ProcedureTemplate.parents
             *
             * @description
             *
             * Add a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.parents.link = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::link::ProcedureTemplate::parents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.parents#unlink
             * @methodOf lbServices.ProcedureTemplate.parents
             *
             * @description
             *
             * Remove the parents relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.parents.unlink = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::unlink::ProcedureTemplate::parents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProcedureTemplate.parents#updateById
             * @methodOf lbServices.ProcedureTemplate.parents
             *
             * @description
             *
             * Update a related item by id for parents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProcedureTemplate id
             *
             *  - `fk` – `{*}` - Foreign key for parents
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProcedureTemplate` object.)
             * </em>
             */
        R.parents.updateById = function() {
          var TargetResource = $injector.get("ProcedureTemplate");
          var action = TargetResource["::updateById::ProcedureTemplate::parents"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Vehicle
 * @header lbServices.Vehicle
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Vehicle` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Vehicle",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Vehicles/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Vehicle.createdByUser() instead.
            "prototype$__get__createdByUser": {
              url: urlBase + "/Vehicles/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.updatedByUser() instead.
            "prototype$__get__updatedByUser": {
              url: urlBase + "/Vehicles/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.holder() instead.
            "prototype$__get__holder": {
              url: urlBase + "/Vehicles/:id/holder",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.quotes.findById() instead.
            "prototype$__findById__quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vehicles/:id/quotes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.quotes.destroyById() instead.
            "prototype$__destroyById__quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vehicles/:id/quotes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Vehicle.quotes.updateById() instead.
            "prototype$__updateById__quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vehicles/:id/quotes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Vehicle.brand() instead.
            "prototype$__get__brand": {
              url: urlBase + "/Vehicles/:id/brand",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.engineBrand() instead.
            "prototype$__get__engineBrand": {
              url: urlBase + "/Vehicles/:id/engineBrand",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.chassisBrand() instead.
            "prototype$__get__chassisBrand": {
              url: urlBase + "/Vehicles/:id/chassisBrand",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.province() instead.
            "prototype$__get__province": {
              url: urlBase + "/Vehicles/:id/province",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.fleet() instead.
            "prototype$__get__fleet": {
              url: urlBase + "/Vehicles/:id/fleet",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.quotes() instead.
            "prototype$__get__quotes": {
              isArray: true,
              url: urlBase + "/Vehicles/:id/quotes",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.quotes.create() instead.
            "prototype$__create__quotes": {
              url: urlBase + "/Vehicles/:id/quotes",
              method: "POST",
            },

            // INTERNAL. Use Vehicle.quotes.destroyAll() instead.
            "prototype$__delete__quotes": {
              url: urlBase + "/Vehicles/:id/quotes",
              method: "DELETE",
            },

            // INTERNAL. Use Vehicle.quotes.count() instead.
            "prototype$__count__quotes": {
              url: urlBase + "/Vehicles/:id/quotes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#create
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Vehicles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#patchOrCreate
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Vehicles",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#replaceOrCreate
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Vehicles/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#upsertWithWhere
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Vehicles/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#exists
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Vehicles/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#findById
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Vehicles/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#replaceById
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Vehicles/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#find
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Vehicles",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#findOne
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Vehicles/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#updateAll
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Vehicles/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#deleteById
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Vehicles/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#count
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Vehicles/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#prototype$patchAttributes
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Vehicles/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#createChangeStream
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Vehicles/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#createMany
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Vehicles",
              method: "POST",
            },

            // INTERNAL. Use Quote.vehicle() instead.
            "::get::Quote::vehicle": {
              url: urlBase + "/Quotes/:id/vehicle",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.vehicle() instead.
            "::get::OperativeSpending::vehicle": {
              url: urlBase + "/OperativeSpendings/:id/vehicle",
              method: "GET",
            },

            // INTERNAL. Use Operation.vehicle() instead.
            "::get::Operation::vehicle": {
              url: urlBase + "/Operations/:id/vehicle",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Vehicle#upsert
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#updateOrCreate
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#patchOrCreateWithWhere
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#update
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#destroyById
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#removeById
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#prototype$updateAttributes
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Vehicle#modelName
        * @propertyOf lbServices.Vehicle
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Vehicle`.
        */
        R.modelName = "Vehicle";

    /**
     * @ngdoc object
     * @name lbServices.Vehicle.createdByUser
     * @header lbServices.Vehicle.createdByUser
     * @object
     * @description
     *
     * The object `Vehicle.createdByUser` groups methods
     * manipulating `SegaUser` instances related to `Vehicle`.
     *
     * Call {@link lbServices.Vehicle#createdByUser Vehicle.createdByUser()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Vehicle#createManydByUser
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createManydByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Vehicle::createManydByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#createdByUser
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createdByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Vehicle::createdByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#updatedByUser
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Fetches belongsTo relation updatedByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.updatedByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Vehicle::updatedByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#holder
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Fetches belongsTo relation holder.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.holder = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::Vehicle::holder"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Vehicle.quotes
     * @header lbServices.Vehicle.quotes
     * @object
     * @description
     *
     * The object `Vehicle.quotes` groups methods
     * manipulating `Quote` instances related to `Vehicle`.
     *
     * Call {@link lbServices.Vehicle#quotes Vehicle.quotes()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Vehicle#quotes
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Queries quotes of Vehicle.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::get::Vehicle::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.quotes#count
             * @methodOf lbServices.Vehicle.quotes
             *
             * @description
             *
             * Counts quotes of Vehicle.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.quotes.count = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::count::Vehicle::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.quotes#create
             * @methodOf lbServices.Vehicle.quotes
             *
             * @description
             *
             * Creates a new instance in quotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.create = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::create::Vehicle::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.quotes#createMany
             * @methodOf lbServices.Vehicle.quotes
             *
             * @description
             *
             * Creates a new instance in quotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.createMany = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::createMany::Vehicle::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.quotes#destroyAll
             * @methodOf lbServices.Vehicle.quotes
             *
             * @description
             *
             * Deletes all quotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.quotes.destroyAll = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::delete::Vehicle::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.quotes#destroyById
             * @methodOf lbServices.Vehicle.quotes
             *
             * @description
             *
             * Delete a related item by id for quotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for quotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.quotes.destroyById = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::destroyById::Vehicle::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.quotes#findById
             * @methodOf lbServices.Vehicle.quotes
             *
             * @description
             *
             * Find a related item by id for quotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for quotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.findById = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::findById::Vehicle::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.quotes#updateById
             * @methodOf lbServices.Vehicle.quotes
             *
             * @description
             *
             * Update a related item by id for quotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `fk` – `{*}` - Foreign key for quotes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.updateById = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::updateById::Vehicle::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#brand
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Fetches belongsTo relation brand.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
        R.brand = function() {
          var TargetResource = $injector.get("Brand");
          var action = TargetResource["::get::Vehicle::brand"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#engineBrand
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Fetches belongsTo relation engineBrand.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
        R.engineBrand = function() {
          var TargetResource = $injector.get("Brand");
          var action = TargetResource["::get::Vehicle::engineBrand"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#chassisBrand
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Fetches belongsTo relation chassisBrand.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
        R.chassisBrand = function() {
          var TargetResource = $injector.get("Brand");
          var action = TargetResource["::get::Vehicle::chassisBrand"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#province
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Fetches belongsTo relation province.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R.province = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::get::Vehicle::province"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#fleet
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Fetches belongsTo relation fleet.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
        R.fleet = function() {
          var TargetResource = $injector.get("Fleet");
          var action = TargetResource["::get::Vehicle::fleet"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Quote
 * @header lbServices.Quote
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Quote` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Quote",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Quotes/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Quote.procedures.findById() instead.
            "prototype$__findById__procedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/procedures/:fk",
              method: "GET",
            },

            // INTERNAL. Use Quote.procedures.destroyById() instead.
            "prototype$__destroyById__procedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/procedures/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.procedures.updateById() instead.
            "prototype$__updateById__procedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/procedures/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Quote.client() instead.
            "prototype$__get__client": {
              url: urlBase + "/Quotes/:id/client",
              method: "GET",
            },

            // INTERNAL. Use Quote.holder() instead.
            "prototype$__get__holder": {
              url: urlBase + "/Quotes/:id/holder",
              method: "GET",
            },

            // INTERNAL. Use Quote.vehicle() instead.
            "prototype$__get__vehicle": {
              url: urlBase + "/Quotes/:id/vehicle",
              method: "GET",
            },

            // INTERNAL. Use Quote.createdByUser() instead.
            "prototype$__get__createdByUser": {
              url: urlBase + "/Quotes/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Quote.updatedByUser() instead.
            "prototype$__get__updatedByUser": {
              url: urlBase + "/Quotes/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use Quote.receipts.findById() instead.
            "prototype$__findById__receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receipts/:fk",
              method: "GET",
            },

            // INTERNAL. Use Quote.receipts.destroyById() instead.
            "prototype$__destroyById__receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receipts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.receipts.updateById() instead.
            "prototype$__updateById__receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receipts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Quote.receipts.link() instead.
            "prototype$__link__receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receipts/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Quote.receipts.unlink() instead.
            "prototype$__unlink__receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receipts/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.receipts.exists() instead.
            "prototype$__exists__receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receipts/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Quote.receiptQuotes.findById() instead.
            "prototype$__findById__receiptQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receiptQuotes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Quote.receiptQuotes.destroyById() instead.
            "prototype$__destroyById__receiptQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receiptQuotes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.receiptQuotes.updateById() instead.
            "prototype$__updateById__receiptQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receiptQuotes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Quote.operativeSpendings.findById() instead.
            "prototype$__findById__operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/operativeSpendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Quote.operativeSpendings.destroyById() instead.
            "prototype$__destroyById__operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/operativeSpendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.operativeSpendings.updateById() instead.
            "prototype$__updateById__operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/operativeSpendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Quote.groupInvoice() instead.
            "prototype$__get__groupInvoice": {
              url: urlBase + "/Quotes/:id/groupInvoice",
              method: "GET",
            },

            // INTERNAL. Use Quote.procedures() instead.
            "prototype$__get__procedures": {
              isArray: true,
              url: urlBase + "/Quotes/:id/procedures",
              method: "GET",
            },

            // INTERNAL. Use Quote.procedures.create() instead.
            "prototype$__create__procedures": {
              url: urlBase + "/Quotes/:id/procedures",
              method: "POST",
            },

            // INTERNAL. Use Quote.procedures.destroyAll() instead.
            "prototype$__delete__procedures": {
              url: urlBase + "/Quotes/:id/procedures",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.procedures.count() instead.
            "prototype$__count__procedures": {
              url: urlBase + "/Quotes/:id/procedures/count",
              method: "GET",
            },

            // INTERNAL. Use Quote.receipts() instead.
            "prototype$__get__receipts": {
              isArray: true,
              url: urlBase + "/Quotes/:id/receipts",
              method: "GET",
            },

            // INTERNAL. Use Quote.receipts.create() instead.
            "prototype$__create__receipts": {
              url: urlBase + "/Quotes/:id/receipts",
              method: "POST",
            },

            // INTERNAL. Use Quote.receipts.destroyAll() instead.
            "prototype$__delete__receipts": {
              url: urlBase + "/Quotes/:id/receipts",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.receipts.count() instead.
            "prototype$__count__receipts": {
              url: urlBase + "/Quotes/:id/receipts/count",
              method: "GET",
            },

            // INTERNAL. Use Quote.receiptQuotes() instead.
            "prototype$__get__receiptQuotes": {
              isArray: true,
              url: urlBase + "/Quotes/:id/receiptQuotes",
              method: "GET",
            },

            // INTERNAL. Use Quote.receiptQuotes.create() instead.
            "prototype$__create__receiptQuotes": {
              url: urlBase + "/Quotes/:id/receiptQuotes",
              method: "POST",
            },

            // INTERNAL. Use Quote.receiptQuotes.destroyAll() instead.
            "prototype$__delete__receiptQuotes": {
              url: urlBase + "/Quotes/:id/receiptQuotes",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.receiptQuotes.count() instead.
            "prototype$__count__receiptQuotes": {
              url: urlBase + "/Quotes/:id/receiptQuotes/count",
              method: "GET",
            },

            // INTERNAL. Use Quote.operativeSpendings() instead.
            "prototype$__get__operativeSpendings": {
              isArray: true,
              url: urlBase + "/Quotes/:id/operativeSpendings",
              method: "GET",
            },

            // INTERNAL. Use Quote.operativeSpendings.create() instead.
            "prototype$__create__operativeSpendings": {
              url: urlBase + "/Quotes/:id/operativeSpendings",
              method: "POST",
            },

            // INTERNAL. Use Quote.operativeSpendings.destroyAll() instead.
            "prototype$__delete__operativeSpendings": {
              url: urlBase + "/Quotes/:id/operativeSpendings",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.operativeSpendings.count() instead.
            "prototype$__count__operativeSpendings": {
              url: urlBase + "/Quotes/:id/operativeSpendings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#create
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Quotes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#patchOrCreate
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Quotes",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#replaceOrCreate
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Quotes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#upsertWithWhere
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Quotes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#exists
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Quotes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#findById
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Quotes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#replaceById
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Quotes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#find
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Quotes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#findOne
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Quotes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#updateAll
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Quotes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#deleteById
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Quotes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#count
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Quotes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#prototype$patchAttributes
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Quotes/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#createChangeStream
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Quotes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#approve
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Quote approval
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{integer}` - Quote id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `quote` – `{object=}` -
             */
            "approve": {
              url: urlBase + "/Quotes/approve",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#prototype$createProcedureFromTpl
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Create procedure from tpl
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `procedureTemplateId` – `{number}` - Tpl id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `procedures` – `{*=}` - Created procedures
             */
            "prototype$createProcedureFromTpl": {
              url: urlBase + "/Quotes/:id/createProcedureFromTpl",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#pdf
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Returns the pdf representation of the quote
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{integer}` - Quote id
             *
             *  - `procedureIds` – `{*=}` - Filter some procedures
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
            "pdf": {
              url: urlBase + "/Quotes/pdf",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#quoteFind
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Custom find method
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object}` - Filter object
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` - Contains Array of returned quotes and count
             */
            "quoteFind": {
              url: urlBase + "/Quotes/quoteFind",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#prototype$markNotInvoiceable
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Marks a quote as not invoiceable
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `reason` – `{string}` - Reason
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `quote` – `{object=}` -
             */
            "prototype$markNotInvoiceable": {
              url: urlBase + "/Quotes/:id/notInvoiceable",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Quote#createMany
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Quotes",
              method: "POST",
            },

            // INTERNAL. Use Client.quotes.findById() instead.
            "::findById::Client::quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/quotes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Client.quotes.destroyById() instead.
            "::destroyById::Client::quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/quotes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Client.quotes.updateById() instead.
            "::updateById::Client::quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/quotes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Client.holderQuotes.findById() instead.
            "::findById::Client::holderQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/holderQuotes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Client.holderQuotes.destroyById() instead.
            "::destroyById::Client::holderQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/holderQuotes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Client.holderQuotes.updateById() instead.
            "::updateById::Client::holderQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Clients/:id/holderQuotes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Client.quotes() instead.
            "::get::Client::quotes": {
              isArray: true,
              url: urlBase + "/Clients/:id/quotes",
              method: "GET",
            },

            // INTERNAL. Use Client.quotes.create() instead.
            "::create::Client::quotes": {
              url: urlBase + "/Clients/:id/quotes",
              method: "POST",
            },

            // INTERNAL. Use Client.quotes.createMany() instead.
            "::createMany::Client::quotes": {
              isArray: true,
              url: urlBase + "/Clients/:id/quotes",
              method: "POST",
            },

            // INTERNAL. Use Client.quotes.destroyAll() instead.
            "::delete::Client::quotes": {
              url: urlBase + "/Clients/:id/quotes",
              method: "DELETE",
            },

            // INTERNAL. Use Client.quotes.count() instead.
            "::count::Client::quotes": {
              url: urlBase + "/Clients/:id/quotes/count",
              method: "GET",
            },

            // INTERNAL. Use Client.holderQuotes() instead.
            "::get::Client::holderQuotes": {
              isArray: true,
              url: urlBase + "/Clients/:id/holderQuotes",
              method: "GET",
            },

            // INTERNAL. Use Client.holderQuotes.create() instead.
            "::create::Client::holderQuotes": {
              url: urlBase + "/Clients/:id/holderQuotes",
              method: "POST",
            },

            // INTERNAL. Use Client.holderQuotes.createMany() instead.
            "::createMany::Client::holderQuotes": {
              isArray: true,
              url: urlBase + "/Clients/:id/holderQuotes",
              method: "POST",
            },

            // INTERNAL. Use Client.holderQuotes.destroyAll() instead.
            "::delete::Client::holderQuotes": {
              url: urlBase + "/Clients/:id/holderQuotes",
              method: "DELETE",
            },

            // INTERNAL. Use Client.holderQuotes.count() instead.
            "::count::Client::holderQuotes": {
              url: urlBase + "/Clients/:id/holderQuotes/count",
              method: "GET",
            },

            // INTERNAL. Use Receipt.quotes.findById() instead.
            "::findById::Receipt::quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/quotes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Receipt.quotes.destroyById() instead.
            "::destroyById::Receipt::quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/quotes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.quotes.updateById() instead.
            "::updateById::Receipt::quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/quotes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Receipt.quotes.link() instead.
            "::link::Receipt::quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/quotes/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Receipt.quotes.unlink() instead.
            "::unlink::Receipt::quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/quotes/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.quotes.exists() instead.
            "::exists::Receipt::quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/quotes/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Receipt.quotes() instead.
            "::get::Receipt::quotes": {
              isArray: true,
              url: urlBase + "/Receipts/:id/quotes",
              method: "GET",
            },

            // INTERNAL. Use Receipt.quotes.create() instead.
            "::create::Receipt::quotes": {
              url: urlBase + "/Receipts/:id/quotes",
              method: "POST",
            },

            // INTERNAL. Use Receipt.quotes.createMany() instead.
            "::createMany::Receipt::quotes": {
              isArray: true,
              url: urlBase + "/Receipts/:id/quotes",
              method: "POST",
            },

            // INTERNAL. Use Receipt.quotes.destroyAll() instead.
            "::delete::Receipt::quotes": {
              url: urlBase + "/Receipts/:id/quotes",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.quotes.count() instead.
            "::count::Receipt::quotes": {
              url: urlBase + "/Receipts/:id/quotes/count",
              method: "GET",
            },

            // INTERNAL. Use Procedure.quote() instead.
            "::get::Procedure::quote": {
              url: urlBase + "/Procedures/:id/quote",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.quotes.findById() instead.
            "::findById::Vehicle::quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vehicles/:id/quotes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.quotes.destroyById() instead.
            "::destroyById::Vehicle::quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vehicles/:id/quotes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Vehicle.quotes.updateById() instead.
            "::updateById::Vehicle::quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vehicles/:id/quotes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Vehicle.quotes() instead.
            "::get::Vehicle::quotes": {
              isArray: true,
              url: urlBase + "/Vehicles/:id/quotes",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.quotes.create() instead.
            "::create::Vehicle::quotes": {
              url: urlBase + "/Vehicles/:id/quotes",
              method: "POST",
            },

            // INTERNAL. Use Vehicle.quotes.createMany() instead.
            "::createMany::Vehicle::quotes": {
              isArray: true,
              url: urlBase + "/Vehicles/:id/quotes",
              method: "POST",
            },

            // INTERNAL. Use Vehicle.quotes.destroyAll() instead.
            "::delete::Vehicle::quotes": {
              url: urlBase + "/Vehicles/:id/quotes",
              method: "DELETE",
            },

            // INTERNAL. Use Vehicle.quotes.count() instead.
            "::count::Vehicle::quotes": {
              url: urlBase + "/Vehicles/:id/quotes/count",
              method: "GET",
            },

            // INTERNAL. Use ReceiptQuote.quote() instead.
            "::get::ReceiptQuote::quote": {
              url: urlBase + "/ReceiptQuotes/:id/quote",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.quote() instead.
            "::get::OperativeSpending::quote": {
              url: urlBase + "/OperativeSpendings/:id/quote",
              method: "GET",
            },

            // INTERNAL. Use OSItem.quote() instead.
            "::get::OSItem::quote": {
              url: urlBase + "/OSItems/:id/quote",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.quotes.findById() instead.
            "::findById::GroupInvoice::quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/quotes/:fk",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.quotes.destroyById() instead.
            "::destroyById::GroupInvoice::quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/quotes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use GroupInvoice.quotes.updateById() instead.
            "::updateById::GroupInvoice::quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/quotes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use GroupInvoice.quotes() instead.
            "::get::GroupInvoice::quotes": {
              isArray: true,
              url: urlBase + "/GroupInvoices/:id/quotes",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.quotes.create() instead.
            "::create::GroupInvoice::quotes": {
              url: urlBase + "/GroupInvoices/:id/quotes",
              method: "POST",
            },

            // INTERNAL. Use GroupInvoice.quotes.createMany() instead.
            "::createMany::GroupInvoice::quotes": {
              isArray: true,
              url: urlBase + "/GroupInvoices/:id/quotes",
              method: "POST",
            },

            // INTERNAL. Use GroupInvoice.quotes.destroyAll() instead.
            "::delete::GroupInvoice::quotes": {
              url: urlBase + "/GroupInvoices/:id/quotes",
              method: "DELETE",
            },

            // INTERNAL. Use GroupInvoice.quotes.count() instead.
            "::count::GroupInvoice::quotes": {
              url: urlBase + "/GroupInvoices/:id/quotes/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Quote#upsert
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Quote#updateOrCreate
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Quote#patchOrCreateWithWhere
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Quote#update
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Quote#destroyById
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Quote#removeById
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Quote#prototype$updateAttributes
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Quote#modelName
        * @propertyOf lbServices.Quote
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Quote`.
        */
        R.modelName = "Quote";

    /**
     * @ngdoc object
     * @name lbServices.Quote.procedures
     * @header lbServices.Quote.procedures
     * @object
     * @description
     *
     * The object `Quote.procedures` groups methods
     * manipulating `Procedure` instances related to `Quote`.
     *
     * Call {@link lbServices.Quote#procedures Quote.procedures()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Quote#procedures
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Queries procedures of Quote.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R.procedures = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::get::Quote::procedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.procedures#count
             * @methodOf lbServices.Quote.procedures
             *
             * @description
             *
             * Counts procedures of Quote.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.procedures.count = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::count::Quote::procedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.procedures#create
             * @methodOf lbServices.Quote.procedures
             *
             * @description
             *
             * Creates a new instance in procedures of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R.procedures.create = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::create::Quote::procedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.procedures#createMany
             * @methodOf lbServices.Quote.procedures
             *
             * @description
             *
             * Creates a new instance in procedures of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R.procedures.createMany = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::createMany::Quote::procedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.procedures#destroyAll
             * @methodOf lbServices.Quote.procedures
             *
             * @description
             *
             * Deletes all procedures of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.procedures.destroyAll = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::delete::Quote::procedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.procedures#destroyById
             * @methodOf lbServices.Quote.procedures
             *
             * @description
             *
             * Delete a related item by id for procedures.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedures
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.procedures.destroyById = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::destroyById::Quote::procedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.procedures#findById
             * @methodOf lbServices.Quote.procedures
             *
             * @description
             *
             * Find a related item by id for procedures.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for procedures
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R.procedures.findById = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::findById::Quote::procedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.procedures#updateById
             * @methodOf lbServices.Quote.procedures
             *
             * @description
             *
             * Update a related item by id for procedures.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `fk` – `{*}` - Foreign key for procedures
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R.procedures.updateById = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::updateById::Quote::procedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote#client
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Fetches belongsTo relation client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.client = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::Quote::client"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote#holder
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Fetches belongsTo relation holder.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.holder = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::Quote::holder"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote#vehicle
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Fetches belongsTo relation vehicle.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R.vehicle = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::get::Quote::vehicle"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Quote.createdByUser
     * @header lbServices.Quote.createdByUser
     * @object
     * @description
     *
     * The object `Quote.createdByUser` groups methods
     * manipulating `SegaUser` instances related to `Quote`.
     *
     * Call {@link lbServices.Quote#createdByUser Quote.createdByUser()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Quote#createManydByUser
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createManydByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Quote::createManydByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote#createdByUser
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createdByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Quote::createdByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote#updatedByUser
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Fetches belongsTo relation updatedByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.updatedByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Quote::updatedByUser"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Quote.receipts
     * @header lbServices.Quote.receipts
     * @object
     * @description
     *
     * The object `Quote.receipts` groups methods
     * manipulating `Receipt` instances related to `Quote`.
     *
     * Call {@link lbServices.Quote#receipts Quote.receipts()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Quote#receipts
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Queries receipts of Quote.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::get::Quote::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receipts#count
             * @methodOf lbServices.Quote.receipts
             *
             * @description
             *
             * Counts receipts of Quote.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.receipts.count = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::count::Quote::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receipts#create
             * @methodOf lbServices.Quote.receipts
             *
             * @description
             *
             * Creates a new instance in receipts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.create = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::create::Quote::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receipts#createMany
             * @methodOf lbServices.Quote.receipts
             *
             * @description
             *
             * Creates a new instance in receipts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.createMany = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::createMany::Quote::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receipts#destroyAll
             * @methodOf lbServices.Quote.receipts
             *
             * @description
             *
             * Deletes all receipts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receipts.destroyAll = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::delete::Quote::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receipts#destroyById
             * @methodOf lbServices.Quote.receipts
             *
             * @description
             *
             * Delete a related item by id for receipts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receipts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receipts.destroyById = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::destroyById::Quote::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receipts#exists
             * @methodOf lbServices.Quote.receipts
             *
             * @description
             *
             * Check the existence of receipts relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receipts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.exists = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::exists::Quote::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receipts#findById
             * @methodOf lbServices.Quote.receipts
             *
             * @description
             *
             * Find a related item by id for receipts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receipts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.findById = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::findById::Quote::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receipts#link
             * @methodOf lbServices.Quote.receipts
             *
             * @description
             *
             * Add a related item by id for receipts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `fk` – `{*}` - Foreign key for receipts
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.link = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::link::Quote::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receipts#unlink
             * @methodOf lbServices.Quote.receipts
             *
             * @description
             *
             * Remove the receipts relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receipts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receipts.unlink = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::unlink::Quote::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receipts#updateById
             * @methodOf lbServices.Quote.receipts
             *
             * @description
             *
             * Update a related item by id for receipts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `fk` – `{*}` - Foreign key for receipts
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.updateById = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::updateById::Quote::receipts"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Quote.receiptQuotes
     * @header lbServices.Quote.receiptQuotes
     * @object
     * @description
     *
     * The object `Quote.receiptQuotes` groups methods
     * manipulating `ReceiptQuote` instances related to `Quote`.
     *
     * Call {@link lbServices.Quote#receiptQuotes Quote.receiptQuotes()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Quote#receiptQuotes
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Queries receiptQuotes of Quote.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R.receiptQuotes = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::get::Quote::receiptQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receiptQuotes#count
             * @methodOf lbServices.Quote.receiptQuotes
             *
             * @description
             *
             * Counts receiptQuotes of Quote.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.receiptQuotes.count = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::count::Quote::receiptQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receiptQuotes#create
             * @methodOf lbServices.Quote.receiptQuotes
             *
             * @description
             *
             * Creates a new instance in receiptQuotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R.receiptQuotes.create = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::create::Quote::receiptQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receiptQuotes#createMany
             * @methodOf lbServices.Quote.receiptQuotes
             *
             * @description
             *
             * Creates a new instance in receiptQuotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R.receiptQuotes.createMany = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::createMany::Quote::receiptQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receiptQuotes#destroyAll
             * @methodOf lbServices.Quote.receiptQuotes
             *
             * @description
             *
             * Deletes all receiptQuotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receiptQuotes.destroyAll = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::delete::Quote::receiptQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receiptQuotes#destroyById
             * @methodOf lbServices.Quote.receiptQuotes
             *
             * @description
             *
             * Delete a related item by id for receiptQuotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receiptQuotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receiptQuotes.destroyById = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::destroyById::Quote::receiptQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receiptQuotes#findById
             * @methodOf lbServices.Quote.receiptQuotes
             *
             * @description
             *
             * Find a related item by id for receiptQuotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receiptQuotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R.receiptQuotes.findById = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::findById::Quote::receiptQuotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.receiptQuotes#updateById
             * @methodOf lbServices.Quote.receiptQuotes
             *
             * @description
             *
             * Update a related item by id for receiptQuotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `fk` – `{*}` - Foreign key for receiptQuotes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R.receiptQuotes.updateById = function() {
          var TargetResource = $injector.get("ReceiptQuote");
          var action = TargetResource["::updateById::Quote::receiptQuotes"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Quote.operativeSpendings
     * @header lbServices.Quote.operativeSpendings
     * @object
     * @description
     *
     * The object `Quote.operativeSpendings` groups methods
     * manipulating `OperativeSpending` instances related to `Quote`.
     *
     * Call {@link lbServices.Quote#operativeSpendings Quote.operativeSpendings()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Quote#operativeSpendings
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Queries operativeSpendings of Quote.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpendings = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::get::Quote::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.operativeSpendings#count
             * @methodOf lbServices.Quote.operativeSpendings
             *
             * @description
             *
             * Counts operativeSpendings of Quote.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.operativeSpendings.count = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::count::Quote::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.operativeSpendings#create
             * @methodOf lbServices.Quote.operativeSpendings
             *
             * @description
             *
             * Creates a new instance in operativeSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpendings.create = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::create::Quote::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.operativeSpendings#createMany
             * @methodOf lbServices.Quote.operativeSpendings
             *
             * @description
             *
             * Creates a new instance in operativeSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpendings.createMany = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::createMany::Quote::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.operativeSpendings#destroyAll
             * @methodOf lbServices.Quote.operativeSpendings
             *
             * @description
             *
             * Deletes all operativeSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.operativeSpendings.destroyAll = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::delete::Quote::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.operativeSpendings#destroyById
             * @methodOf lbServices.Quote.operativeSpendings
             *
             * @description
             *
             * Delete a related item by id for operativeSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operativeSpendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.operativeSpendings.destroyById = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::destroyById::Quote::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.operativeSpendings#findById
             * @methodOf lbServices.Quote.operativeSpendings
             *
             * @description
             *
             * Find a related item by id for operativeSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operativeSpendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpendings.findById = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::findById::Quote::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote.operativeSpendings#updateById
             * @methodOf lbServices.Quote.operativeSpendings
             *
             * @description
             *
             * Update a related item by id for operativeSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `fk` – `{*}` - Foreign key for operativeSpendings
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpendings.updateById = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::updateById::Quote::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Quote#groupInvoice
             * @methodOf lbServices.Quote
             *
             * @description
             *
             * Fetches belongsTo relation groupInvoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Quote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
        R.groupInvoice = function() {
          var TargetResource = $injector.get("GroupInvoice");
          var action = TargetResource["::get::Quote::groupInvoice"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Item
 * @header lbServices.Item
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Item` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Item",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Items/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Item.procedure() instead.
            "prototype$__get__procedure": {
              url: urlBase + "/Items/:id/procedure",
              method: "GET",
            },

            // INTERNAL. Use Item.osItems.findById() instead.
            "prototype$__findById__osItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Items/:id/osItems/:fk",
              method: "GET",
            },

            // INTERNAL. Use Item.osItems.destroyById() instead.
            "prototype$__destroyById__osItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Items/:id/osItems/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Item.osItems.updateById() instead.
            "prototype$__updateById__osItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Items/:id/osItems/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Item.osItems() instead.
            "prototype$__get__osItems": {
              isArray: true,
              url: urlBase + "/Items/:id/osItems",
              method: "GET",
            },

            // INTERNAL. Use Item.osItems.create() instead.
            "prototype$__create__osItems": {
              url: urlBase + "/Items/:id/osItems",
              method: "POST",
            },

            // INTERNAL. Use Item.osItems.destroyAll() instead.
            "prototype$__delete__osItems": {
              url: urlBase + "/Items/:id/osItems",
              method: "DELETE",
            },

            // INTERNAL. Use Item.osItems.count() instead.
            "prototype$__count__osItems": {
              url: urlBase + "/Items/:id/osItems/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Item#create
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Items",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Item#patchOrCreate
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Items",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Item#replaceOrCreate
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Items/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Item#upsertWithWhere
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Items/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Item#exists
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Items/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Item#findById
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Items/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Item#replaceById
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Items/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Item#find
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Items",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Item#findOne
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Items/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Item#updateAll
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Items/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Item#deleteById
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Items/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Item#count
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Items/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Item#prototype$patchAttributes
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Item id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Items/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Item#createChangeStream
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Items/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Item#createMany
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Items",
              method: "POST",
            },

            // INTERNAL. Use Procedure.items.findById() instead.
            "::findById::Procedure::items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Procedures/:id/items/:fk",
              method: "GET",
            },

            // INTERNAL. Use Procedure.items.destroyById() instead.
            "::destroyById::Procedure::items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Procedures/:id/items/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Procedure.items.updateById() instead.
            "::updateById::Procedure::items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Procedures/:id/items/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Procedure.items() instead.
            "::get::Procedure::items": {
              isArray: true,
              url: urlBase + "/Procedures/:id/items",
              method: "GET",
            },

            // INTERNAL. Use Procedure.items.create() instead.
            "::create::Procedure::items": {
              url: urlBase + "/Procedures/:id/items",
              method: "POST",
            },

            // INTERNAL. Use Procedure.items.createMany() instead.
            "::createMany::Procedure::items": {
              isArray: true,
              url: urlBase + "/Procedures/:id/items",
              method: "POST",
            },

            // INTERNAL. Use Procedure.items.destroyAll() instead.
            "::delete::Procedure::items": {
              url: urlBase + "/Procedures/:id/items",
              method: "DELETE",
            },

            // INTERNAL. Use Procedure.items.count() instead.
            "::count::Procedure::items": {
              url: urlBase + "/Procedures/:id/items/count",
              method: "GET",
            },

            // INTERNAL. Use OSItem.item() instead.
            "::get::OSItem::item": {
              url: urlBase + "/OSItems/:id/item",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Item#upsert
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Item#updateOrCreate
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Item#patchOrCreateWithWhere
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Item#update
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Item#destroyById
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Item#removeById
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Item#prototype$updateAttributes
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Item id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Item#modelName
        * @propertyOf lbServices.Item
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Item`.
        */
        R.modelName = "Item";


            /**
             * @ngdoc method
             * @name lbServices.Item#procedure
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Fetches belongsTo relation procedure.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Item id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Procedure` object.)
             * </em>
             */
        R.procedure = function() {
          var TargetResource = $injector.get("Procedure");
          var action = TargetResource["::get::Item::procedure"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Item.osItems
     * @header lbServices.Item.osItems
     * @object
     * @description
     *
     * The object `Item.osItems` groups methods
     * manipulating `OSItem` instances related to `Item`.
     *
     * Call {@link lbServices.Item#osItems Item.osItems()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Item#osItems
             * @methodOf lbServices.Item
             *
             * @description
             *
             * Queries osItems of Item.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Item id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R.osItems = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::get::Item::osItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Item.osItems#count
             * @methodOf lbServices.Item.osItems
             *
             * @description
             *
             * Counts osItems of Item.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Item id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.osItems.count = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::count::Item::osItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Item.osItems#create
             * @methodOf lbServices.Item.osItems
             *
             * @description
             *
             * Creates a new instance in osItems of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Item id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R.osItems.create = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::create::Item::osItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Item.osItems#createMany
             * @methodOf lbServices.Item.osItems
             *
             * @description
             *
             * Creates a new instance in osItems of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Item id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R.osItems.createMany = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::createMany::Item::osItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Item.osItems#destroyAll
             * @methodOf lbServices.Item.osItems
             *
             * @description
             *
             * Deletes all osItems of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Item id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.osItems.destroyAll = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::delete::Item::osItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Item.osItems#destroyById
             * @methodOf lbServices.Item.osItems
             *
             * @description
             *
             * Delete a related item by id for osItems.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Item id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for osItems
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.osItems.destroyById = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::destroyById::Item::osItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Item.osItems#findById
             * @methodOf lbServices.Item.osItems
             *
             * @description
             *
             * Find a related item by id for osItems.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Item id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for osItems
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R.osItems.findById = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::findById::Item::osItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Item.osItems#updateById
             * @methodOf lbServices.Item.osItems
             *
             * @description
             *
             * Update a related item by id for osItems.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Item id
             *
             *  - `fk` – `{*}` - Foreign key for osItems
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R.osItems.updateById = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::updateById::Item::osItems"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ReceiptQuote
 * @header lbServices.ReceiptQuote
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ReceiptQuote` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ReceiptQuote",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ReceiptQuotes/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ReceiptQuote.receipt() instead.
            "prototype$__get__receipt": {
              url: urlBase + "/ReceiptQuotes/:id/receipt",
              method: "GET",
            },

            // INTERNAL. Use ReceiptQuote.quote() instead.
            "prototype$__get__quote": {
              url: urlBase + "/ReceiptQuotes/:id/quote",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#create
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/ReceiptQuotes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#patchOrCreate
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/ReceiptQuotes",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#replaceOrCreate
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/ReceiptQuotes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#upsertWithWhere
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/ReceiptQuotes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#exists
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/ReceiptQuotes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#findById
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/ReceiptQuotes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#replaceById
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/ReceiptQuotes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#find
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/ReceiptQuotes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#findOne
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/ReceiptQuotes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#updateAll
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/ReceiptQuotes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#deleteById
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/ReceiptQuotes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#count
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/ReceiptQuotes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#prototype$patchAttributes
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ReceiptQuote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/ReceiptQuotes/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#createChangeStream
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/ReceiptQuotes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#createMany
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/ReceiptQuotes",
              method: "POST",
            },

            // INTERNAL. Use Receipt.receiptQuotes.findById() instead.
            "::findById::Receipt::receiptQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/receiptQuotes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Receipt.receiptQuotes.destroyById() instead.
            "::destroyById::Receipt::receiptQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/receiptQuotes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.receiptQuotes.updateById() instead.
            "::updateById::Receipt::receiptQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/receiptQuotes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Receipt.receiptQuotes() instead.
            "::get::Receipt::receiptQuotes": {
              isArray: true,
              url: urlBase + "/Receipts/:id/receiptQuotes",
              method: "GET",
            },

            // INTERNAL. Use Receipt.receiptQuotes.create() instead.
            "::create::Receipt::receiptQuotes": {
              url: urlBase + "/Receipts/:id/receiptQuotes",
              method: "POST",
            },

            // INTERNAL. Use Receipt.receiptQuotes.createMany() instead.
            "::createMany::Receipt::receiptQuotes": {
              isArray: true,
              url: urlBase + "/Receipts/:id/receiptQuotes",
              method: "POST",
            },

            // INTERNAL. Use Receipt.receiptQuotes.destroyAll() instead.
            "::delete::Receipt::receiptQuotes": {
              url: urlBase + "/Receipts/:id/receiptQuotes",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.receiptQuotes.count() instead.
            "::count::Receipt::receiptQuotes": {
              url: urlBase + "/Receipts/:id/receiptQuotes/count",
              method: "GET",
            },

            // INTERNAL. Use Quote.receiptQuotes.findById() instead.
            "::findById::Quote::receiptQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receiptQuotes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Quote.receiptQuotes.destroyById() instead.
            "::destroyById::Quote::receiptQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receiptQuotes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.receiptQuotes.updateById() instead.
            "::updateById::Quote::receiptQuotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/receiptQuotes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Quote.receiptQuotes() instead.
            "::get::Quote::receiptQuotes": {
              isArray: true,
              url: urlBase + "/Quotes/:id/receiptQuotes",
              method: "GET",
            },

            // INTERNAL. Use Quote.receiptQuotes.create() instead.
            "::create::Quote::receiptQuotes": {
              url: urlBase + "/Quotes/:id/receiptQuotes",
              method: "POST",
            },

            // INTERNAL. Use Quote.receiptQuotes.createMany() instead.
            "::createMany::Quote::receiptQuotes": {
              isArray: true,
              url: urlBase + "/Quotes/:id/receiptQuotes",
              method: "POST",
            },

            // INTERNAL. Use Quote.receiptQuotes.destroyAll() instead.
            "::delete::Quote::receiptQuotes": {
              url: urlBase + "/Quotes/:id/receiptQuotes",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.receiptQuotes.count() instead.
            "::count::Quote::receiptQuotes": {
              url: urlBase + "/Quotes/:id/receiptQuotes/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#upsert
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#updateOrCreate
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#patchOrCreateWithWhere
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#update
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#destroyById
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#removeById
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#prototype$updateAttributes
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ReceiptQuote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptQuote` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ReceiptQuote#modelName
        * @propertyOf lbServices.ReceiptQuote
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ReceiptQuote`.
        */
        R.modelName = "ReceiptQuote";


            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#receipt
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Fetches belongsTo relation receipt.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ReceiptQuote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipt = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::get::ReceiptQuote::receipt"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ReceiptQuote#quote
             * @methodOf lbServices.ReceiptQuote
             *
             * @description
             *
             * Fetches belongsTo relation quote.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ReceiptQuote id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quote = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::get::ReceiptQuote::quote"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Invite
 * @header lbServices.Invite
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Invite` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Invite",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Invites/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Invite#create
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Invites",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invite#patchOrCreate
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Invites",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invite#replaceOrCreate
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Invites/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invite#upsertWithWhere
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Invites/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invite#exists
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Invites/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invite#findById
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Invites/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invite#replaceById
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Invites/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invite#find
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Invites",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invite#findOne
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Invites/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invite#updateAll
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Invites/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invite#deleteById
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Invites/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invite#count
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Invites/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invite#prototype$patchAttributes
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invite id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Invites/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invite#createChangeStream
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Invites/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invite#createMany
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Invites",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Invite#upsert
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Invite#updateOrCreate
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Invite#patchOrCreateWithWhere
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Invite#update
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Invite#destroyById
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Invite#removeById
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Invite#prototype$updateAttributes
             * @methodOf lbServices.Invite
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invite id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invite` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Invite#modelName
        * @propertyOf lbServices.Invite
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Invite`.
        */
        R.modelName = "Invite";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.CollectionSpending
 * @header lbServices.CollectionSpending
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `CollectionSpending` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "CollectionSpending",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/CollectionSpendings/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use CollectionSpending.collection() instead.
            "prototype$__get__collection": {
              url: urlBase + "/CollectionSpendings/:id/collection",
              method: "GET",
            },

            // INTERNAL. Use CollectionSpending.employee() instead.
            "prototype$__get__employee": {
              url: urlBase + "/CollectionSpendings/:id/employee",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#create
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/CollectionSpendings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#patchOrCreate
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/CollectionSpendings",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#replaceOrCreate
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/CollectionSpendings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#upsertWithWhere
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/CollectionSpendings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#exists
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/CollectionSpendings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#findById
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/CollectionSpendings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#replaceById
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/CollectionSpendings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#find
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/CollectionSpendings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#findOne
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/CollectionSpendings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#updateAll
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/CollectionSpendings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#deleteById
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/CollectionSpendings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#count
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/CollectionSpendings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#prototype$patchAttributes
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CollectionSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/CollectionSpendings/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#createChangeStream
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/CollectionSpendings/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#createMany
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/CollectionSpendings",
              method: "POST",
            },

            // INTERNAL. Use Employee.collectionSpendings.findById() instead.
            "::findById::Employee::collectionSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/collectionSpendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Employee.collectionSpendings.destroyById() instead.
            "::destroyById::Employee::collectionSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/collectionSpendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Employee.collectionSpendings.updateById() instead.
            "::updateById::Employee::collectionSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Employees/:id/collectionSpendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Employee.collectionSpendings() instead.
            "::get::Employee::collectionSpendings": {
              isArray: true,
              url: urlBase + "/Employees/:id/collectionSpendings",
              method: "GET",
            },

            // INTERNAL. Use Employee.collectionSpendings.create() instead.
            "::create::Employee::collectionSpendings": {
              url: urlBase + "/Employees/:id/collectionSpendings",
              method: "POST",
            },

            // INTERNAL. Use Employee.collectionSpendings.createMany() instead.
            "::createMany::Employee::collectionSpendings": {
              isArray: true,
              url: urlBase + "/Employees/:id/collectionSpendings",
              method: "POST",
            },

            // INTERNAL. Use Employee.collectionSpendings.destroyAll() instead.
            "::delete::Employee::collectionSpendings": {
              url: urlBase + "/Employees/:id/collectionSpendings",
              method: "DELETE",
            },

            // INTERNAL. Use Employee.collectionSpendings.count() instead.
            "::count::Employee::collectionSpendings": {
              url: urlBase + "/Employees/:id/collectionSpendings/count",
              method: "GET",
            },

            // INTERNAL. Use Collection.collectionSpendings.findById() instead.
            "::findById::Collection::collectionSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/collectionSpendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Collection.collectionSpendings.destroyById() instead.
            "::destroyById::Collection::collectionSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/collectionSpendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.collectionSpendings.updateById() instead.
            "::updateById::Collection::collectionSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/collectionSpendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Collection.collectionSpendings() instead.
            "::get::Collection::collectionSpendings": {
              isArray: true,
              url: urlBase + "/Collections/:id/collectionSpendings",
              method: "GET",
            },

            // INTERNAL. Use Collection.collectionSpendings.create() instead.
            "::create::Collection::collectionSpendings": {
              url: urlBase + "/Collections/:id/collectionSpendings",
              method: "POST",
            },

            // INTERNAL. Use Collection.collectionSpendings.createMany() instead.
            "::createMany::Collection::collectionSpendings": {
              isArray: true,
              url: urlBase + "/Collections/:id/collectionSpendings",
              method: "POST",
            },

            // INTERNAL. Use Collection.collectionSpendings.destroyAll() instead.
            "::delete::Collection::collectionSpendings": {
              url: urlBase + "/Collections/:id/collectionSpendings",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.collectionSpendings.count() instead.
            "::count::Collection::collectionSpendings": {
              url: urlBase + "/Collections/:id/collectionSpendings/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#upsert
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#updateOrCreate
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#patchOrCreateWithWhere
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#update
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#destroyById
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#removeById
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#prototype$updateAttributes
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CollectionSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CollectionSpending` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.CollectionSpending#modelName
        * @propertyOf lbServices.CollectionSpending
        * @description
        * The name of the model represented by this $resource,
        * i.e. `CollectionSpending`.
        */
        R.modelName = "CollectionSpending";


            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#collection
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Fetches belongsTo relation collection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CollectionSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
        R.collection = function() {
          var TargetResource = $injector.get("Collection");
          var action = TargetResource["::get::CollectionSpending::collection"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CollectionSpending#employee
             * @methodOf lbServices.CollectionSpending
             *
             * @description
             *
             * Fetches belongsTo relation employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CollectionSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R.employee = function() {
          var TargetResource = $injector.get("Employee");
          var action = TargetResource["::get::CollectionSpending::employee"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Cashbox
 * @header lbServices.Cashbox
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Cashbox` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Cashbox",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Cashboxes/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Cashbox.employee() instead.
            "prototype$__get__employee": {
              url: urlBase + "/Cashboxes/:id/employee",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#create
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Cashboxes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#patchOrCreate
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Cashboxes",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#replaceOrCreate
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Cashboxes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#upsertWithWhere
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Cashboxes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#exists
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Cashboxes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#findById
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Cashboxes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#replaceById
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Cashboxes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#find
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Cashboxes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#findOne
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Cashboxes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#updateAll
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Cashboxes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#deleteById
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Cashboxes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#count
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Cashboxes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#prototype$patchAttributes
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cashbox id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Cashboxes/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#createChangeStream
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Cashboxes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#createAdjustment
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Creates a cashbox adjustment
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - Cashbox id
             *
             *  - `type` – `{string}` - Adjustment type: debit/credit
             *
             *  - `amount` – `{number}` - Amount
             *
             *  - `comments` – `{string}` - Comments
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `transaction` – `{object=}` -
             */
            "createAdjustment": {
              url: urlBase + "/Cashboxes/createAdjustment",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#createMany
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Cashboxes",
              method: "POST",
            },

            // INTERNAL. Use Employee.cashbox() instead.
            "::get::Employee::cashbox": {
              url: urlBase + "/Employees/:id/cashbox",
              method: "GET",
            },

            // INTERNAL. Use Employee.cashbox.create() instead.
            "::create::Employee::cashbox": {
              url: urlBase + "/Employees/:id/cashbox",
              method: "POST",
            },

            // INTERNAL. Use Employee.cashbox.createMany() instead.
            "::createMany::Employee::cashbox": {
              isArray: true,
              url: urlBase + "/Employees/:id/cashbox",
              method: "POST",
            },

            // INTERNAL. Use Employee.cashbox.update() instead.
            "::update::Employee::cashbox": {
              url: urlBase + "/Employees/:id/cashbox",
              method: "PUT",
            },

            // INTERNAL. Use Employee.cashbox.destroy() instead.
            "::destroy::Employee::cashbox": {
              url: urlBase + "/Employees/:id/cashbox",
              method: "DELETE",
            },

            // INTERNAL. Use CashboxTransaction.src() instead.
            "::get::CashboxTransaction::src": {
              url: urlBase + "/CashboxTransactions/:id/src",
              method: "GET",
            },

            // INTERNAL. Use CashboxTransaction.dst() instead.
            "::get::CashboxTransaction::dst": {
              url: urlBase + "/CashboxTransactions/:id/dst",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Cashbox#upsert
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#updateOrCreate
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#patchOrCreateWithWhere
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#update
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#destroyById
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#removeById
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cashbox#prototype$updateAttributes
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cashbox id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Cashbox#modelName
        * @propertyOf lbServices.Cashbox
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Cashbox`.
        */
        R.modelName = "Cashbox";


            /**
             * @ngdoc method
             * @name lbServices.Cashbox#employee
             * @methodOf lbServices.Cashbox
             *
             * @description
             *
             * Fetches belongsTo relation employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cashbox id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R.employee = function() {
          var TargetResource = $injector.get("Employee");
          var action = TargetResource["::get::Cashbox::employee"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.CashboxTransaction
 * @header lbServices.CashboxTransaction
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `CashboxTransaction` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "CashboxTransaction",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/CashboxTransactions/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use CashboxTransaction.src() instead.
            "prototype$__get__src": {
              url: urlBase + "/CashboxTransactions/:id/src",
              method: "GET",
            },

            // INTERNAL. Use CashboxTransaction.dst() instead.
            "prototype$__get__dst": {
              url: urlBase + "/CashboxTransactions/:id/dst",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#create
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/CashboxTransactions",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#patchOrCreate
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/CashboxTransactions",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#replaceOrCreate
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/CashboxTransactions/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#upsertWithWhere
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/CashboxTransactions/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#exists
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/CashboxTransactions/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#findById
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/CashboxTransactions/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#replaceById
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/CashboxTransactions/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#find
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/CashboxTransactions",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#findOne
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/CashboxTransactions/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#updateAll
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/CashboxTransactions/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#deleteById
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/CashboxTransactions/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#count
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/CashboxTransactions/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#prototype$patchAttributes
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CashboxTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/CashboxTransactions/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#createChangeStream
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/CashboxTransactions/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#createMany
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/CashboxTransactions",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#upsert
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#updateOrCreate
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#patchOrCreateWithWhere
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#update
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#destroyById
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#removeById
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#prototype$updateAttributes
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CashboxTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransaction` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.CashboxTransaction#modelName
        * @propertyOf lbServices.CashboxTransaction
        * @description
        * The name of the model represented by this $resource,
        * i.e. `CashboxTransaction`.
        */
        R.modelName = "CashboxTransaction";


            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#src
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Fetches belongsTo relation src.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CashboxTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
        R.src = function() {
          var TargetResource = $injector.get("Cashbox");
          var action = TargetResource["::get::CashboxTransaction::src"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransaction#dst
             * @methodOf lbServices.CashboxTransaction
             *
             * @description
             *
             * Fetches belongsTo relation dst.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CashboxTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cashbox` object.)
             * </em>
             */
        R.dst = function() {
          var TargetResource = $injector.get("Cashbox");
          var action = TargetResource["::get::CashboxTransaction::dst"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Spending
 * @header lbServices.Spending
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Spending` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Spending",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Spendings/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Spending.employee() instead.
            "prototype$__get__employee": {
              url: urlBase + "/Spendings/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use Spending.collection() instead.
            "prototype$__get__collection": {
              url: urlBase + "/Spendings/:id/collection",
              method: "GET",
            },

            // INTERNAL. Use Spending.spendingType() instead.
            "prototype$__get__spendingType": {
              url: urlBase + "/Spendings/:id/spendingType",
              method: "GET",
            },

            // INTERNAL. Use Spending.voucher() instead.
            "prototype$__get__voucher": {
              url: urlBase + "/Spendings/:id/voucher",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#create
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Spendings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#patchOrCreate
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Spendings",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#replaceOrCreate
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Spendings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#upsertWithWhere
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Spendings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#exists
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Spendings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#findById
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Spendings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#replaceById
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Spendings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#find
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Spendings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#findOne
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Spendings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#updateAll
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Spendings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#deleteById
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Spendings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#count
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Spendings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#prototype$patchAttributes
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Spending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Spendings/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#createChangeStream
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Spendings/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#void
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Voids a spending
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - Spending id
             *
             *  - `reason` – `{string}` - Voidance reason
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `spending` – `{object=}` -
             */
            "void": {
              url: urlBase + "/Spendings/void",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Spending#createMany
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Spendings",
              method: "POST",
            },

            // INTERNAL. Use Collection.spendings.findById() instead.
            "::findById::Collection::spendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/spendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Collection.spendings.destroyById() instead.
            "::destroyById::Collection::spendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/spendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.spendings.updateById() instead.
            "::updateById::Collection::spendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/spendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Collection.spendings() instead.
            "::get::Collection::spendings": {
              isArray: true,
              url: urlBase + "/Collections/:id/spendings",
              method: "GET",
            },

            // INTERNAL. Use Collection.spendings.create() instead.
            "::create::Collection::spendings": {
              url: urlBase + "/Collections/:id/spendings",
              method: "POST",
            },

            // INTERNAL. Use Collection.spendings.createMany() instead.
            "::createMany::Collection::spendings": {
              isArray: true,
              url: urlBase + "/Collections/:id/spendings",
              method: "POST",
            },

            // INTERNAL. Use Collection.spendings.destroyAll() instead.
            "::delete::Collection::spendings": {
              url: urlBase + "/Collections/:id/spendings",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.spendings.count() instead.
            "::count::Collection::spendings": {
              url: urlBase + "/Collections/:id/spendings/count",
              method: "GET",
            },

            // INTERNAL. Use Voucher.spendings.findById() instead.
            "::findById::Voucher::spendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/spendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Voucher.spendings.destroyById() instead.
            "::destroyById::Voucher::spendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/spendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.spendings.updateById() instead.
            "::updateById::Voucher::spendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/spendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Voucher.spendings() instead.
            "::get::Voucher::spendings": {
              isArray: true,
              url: urlBase + "/Vouchers/:id/spendings",
              method: "GET",
            },

            // INTERNAL. Use Voucher.spendings.create() instead.
            "::create::Voucher::spendings": {
              url: urlBase + "/Vouchers/:id/spendings",
              method: "POST",
            },

            // INTERNAL. Use Voucher.spendings.createMany() instead.
            "::createMany::Voucher::spendings": {
              isArray: true,
              url: urlBase + "/Vouchers/:id/spendings",
              method: "POST",
            },

            // INTERNAL. Use Voucher.spendings.destroyAll() instead.
            "::delete::Voucher::spendings": {
              url: urlBase + "/Vouchers/:id/spendings",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.spendings.count() instead.
            "::count::Voucher::spendings": {
              url: urlBase + "/Vouchers/:id/spendings/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Spending#upsert
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Spending#updateOrCreate
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Spending#patchOrCreateWithWhere
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Spending#update
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Spending#destroyById
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Spending#removeById
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Spending#prototype$updateAttributes
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Spending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Spending#modelName
        * @propertyOf lbServices.Spending
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Spending`.
        */
        R.modelName = "Spending";


            /**
             * @ngdoc method
             * @name lbServices.Spending#employee
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Fetches belongsTo relation employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Spending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R.employee = function() {
          var TargetResource = $injector.get("Employee");
          var action = TargetResource["::get::Spending::employee"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Spending#collection
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Fetches belongsTo relation collection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Spending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
        R.collection = function() {
          var TargetResource = $injector.get("Collection");
          var action = TargetResource["::get::Spending::collection"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Spending#spendingType
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Fetches belongsTo relation spendingType.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Spending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
        R.spendingType = function() {
          var TargetResource = $injector.get("SpendingType");
          var action = TargetResource["::get::Spending::spendingType"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Spending#voucher
             * @methodOf lbServices.Spending
             *
             * @description
             *
             * Fetches belongsTo relation voucher.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Spending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
        R.voucher = function() {
          var TargetResource = $injector.get("Voucher");
          var action = TargetResource["::get::Spending::voucher"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.SpendingType
 * @header lbServices.SpendingType
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `SpendingType` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "SpendingType",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/SpendingTypes/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#create
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/SpendingTypes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#patchOrCreate
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/SpendingTypes",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#replaceOrCreate
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/SpendingTypes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#upsertWithWhere
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/SpendingTypes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#exists
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/SpendingTypes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#findById
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/SpendingTypes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#replaceById
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/SpendingTypes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#find
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/SpendingTypes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#findOne
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/SpendingTypes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#updateAll
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/SpendingTypes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#deleteById
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/SpendingTypes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#count
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/SpendingTypes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#prototype$patchAttributes
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SpendingType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/SpendingTypes/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#createChangeStream
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/SpendingTypes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#createMany
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/SpendingTypes",
              method: "POST",
            },

            // INTERNAL. Use Spending.spendingType() instead.
            "::get::Spending::spendingType": {
              url: urlBase + "/Spendings/:id/spendingType",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.SpendingType#upsert
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#updateOrCreate
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#patchOrCreateWithWhere
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#update
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#destroyById
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#removeById
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SpendingType#prototype$updateAttributes
             * @methodOf lbServices.SpendingType
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SpendingType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SpendingType` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.SpendingType#modelName
        * @propertyOf lbServices.SpendingType
        * @description
        * The name of the model represented by this $resource,
        * i.e. `SpendingType`.
        */
        R.modelName = "SpendingType";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OperativeSpending
 * @header lbServices.OperativeSpending
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OperativeSpending` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OperativeSpending",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/OperativeSpendings/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OperativeSpending.employee() instead.
            "prototype$__get__employee": {
              url: urlBase + "/OperativeSpendings/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.collection() instead.
            "prototype$__get__collection": {
              url: urlBase + "/OperativeSpendings/:id/collection",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.quote() instead.
            "prototype$__get__quote": {
              url: urlBase + "/OperativeSpendings/:id/quote",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.vehicle() instead.
            "prototype$__get__vehicle": {
              url: urlBase + "/OperativeSpendings/:id/vehicle",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.holder() instead.
            "prototype$__get__holder": {
              url: urlBase + "/OperativeSpendings/:id/holder",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.createdByUser() instead.
            "prototype$__get__createdByUser": {
              url: urlBase + "/OperativeSpendings/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.updatedByUser() instead.
            "prototype$__get__updatedByUser": {
              url: urlBase + "/OperativeSpendings/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.osItems.findById() instead.
            "prototype$__findById__osItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperativeSpendings/:id/osItems/:fk",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.osItems.destroyById() instead.
            "prototype$__destroyById__osItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperativeSpendings/:id/osItems/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OperativeSpending.osItems.updateById() instead.
            "prototype$__updateById__osItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperativeSpendings/:id/osItems/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OperativeSpending.voucher() instead.
            "prototype$__get__voucher": {
              url: urlBase + "/OperativeSpendings/:id/voucher",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.osItems() instead.
            "prototype$__get__osItems": {
              isArray: true,
              url: urlBase + "/OperativeSpendings/:id/osItems",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.osItems.create() instead.
            "prototype$__create__osItems": {
              url: urlBase + "/OperativeSpendings/:id/osItems",
              method: "POST",
            },

            // INTERNAL. Use OperativeSpending.osItems.destroyAll() instead.
            "prototype$__delete__osItems": {
              url: urlBase + "/OperativeSpendings/:id/osItems",
              method: "DELETE",
            },

            // INTERNAL. Use OperativeSpending.osItems.count() instead.
            "prototype$__count__osItems": {
              url: urlBase + "/OperativeSpendings/:id/osItems/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#create
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/OperativeSpendings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#patchOrCreate
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/OperativeSpendings",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#replaceOrCreate
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/OperativeSpendings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#upsertWithWhere
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/OperativeSpendings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#exists
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/OperativeSpendings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#findById
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/OperativeSpendings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#replaceById
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/OperativeSpendings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#find
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/OperativeSpendings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#findOne
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/OperativeSpendings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#updateAll
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/OperativeSpendings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#deleteById
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/OperativeSpendings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#count
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/OperativeSpendings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#prototype$patchAttributes
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/OperativeSpendings/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#createChangeStream
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/OperativeSpendings/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#void
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Voids a spending
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - Spending id
             *
             *  - `reason` – `{string}` - Voidance reason
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `spending` – `{object=}` -
             */
            "void": {
              url: urlBase + "/OperativeSpendings/void",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#associate
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Associates a spending against a given Quote
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - Spending id
             *
             *  - `quoteId` – `{number}` - Quote id
             *
             *  - `associations` – `{*}` - Associations
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
            "associate": {
              url: urlBase + "/OperativeSpendings/associate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#disassociate
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Disassociates a spending
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - Spending id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `spending` – `{object=}` -
             */
            "disassociate": {
              url: urlBase + "/OperativeSpendings/disassociate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#findAssociable
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Custom find method
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object}` - Filter object
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `oSpendings` – `{object=}` - Contains Array of returned spendings
             */
            "findAssociable": {
              url: urlBase + "/OperativeSpendings/findAssociable",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#createMany
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/OperativeSpendings",
              method: "POST",
            },

            // INTERNAL. Use Collection.operativeSpendings.findById() instead.
            "::findById::Collection::operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/operativeSpendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Collection.operativeSpendings.destroyById() instead.
            "::destroyById::Collection::operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/operativeSpendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.operativeSpendings.updateById() instead.
            "::updateById::Collection::operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/operativeSpendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Collection.operativeSpendings() instead.
            "::get::Collection::operativeSpendings": {
              isArray: true,
              url: urlBase + "/Collections/:id/operativeSpendings",
              method: "GET",
            },

            // INTERNAL. Use Collection.operativeSpendings.create() instead.
            "::create::Collection::operativeSpendings": {
              url: urlBase + "/Collections/:id/operativeSpendings",
              method: "POST",
            },

            // INTERNAL. Use Collection.operativeSpendings.createMany() instead.
            "::createMany::Collection::operativeSpendings": {
              isArray: true,
              url: urlBase + "/Collections/:id/operativeSpendings",
              method: "POST",
            },

            // INTERNAL. Use Collection.operativeSpendings.destroyAll() instead.
            "::delete::Collection::operativeSpendings": {
              url: urlBase + "/Collections/:id/operativeSpendings",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.operativeSpendings.count() instead.
            "::count::Collection::operativeSpendings": {
              url: urlBase + "/Collections/:id/operativeSpendings/count",
              method: "GET",
            },

            // INTERNAL. Use Quote.operativeSpendings.findById() instead.
            "::findById::Quote::operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/operativeSpendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Quote.operativeSpendings.destroyById() instead.
            "::destroyById::Quote::operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/operativeSpendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.operativeSpendings.updateById() instead.
            "::updateById::Quote::operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Quotes/:id/operativeSpendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Quote.operativeSpendings() instead.
            "::get::Quote::operativeSpendings": {
              isArray: true,
              url: urlBase + "/Quotes/:id/operativeSpendings",
              method: "GET",
            },

            // INTERNAL. Use Quote.operativeSpendings.create() instead.
            "::create::Quote::operativeSpendings": {
              url: urlBase + "/Quotes/:id/operativeSpendings",
              method: "POST",
            },

            // INTERNAL. Use Quote.operativeSpendings.createMany() instead.
            "::createMany::Quote::operativeSpendings": {
              isArray: true,
              url: urlBase + "/Quotes/:id/operativeSpendings",
              method: "POST",
            },

            // INTERNAL. Use Quote.operativeSpendings.destroyAll() instead.
            "::delete::Quote::operativeSpendings": {
              url: urlBase + "/Quotes/:id/operativeSpendings",
              method: "DELETE",
            },

            // INTERNAL. Use Quote.operativeSpendings.count() instead.
            "::count::Quote::operativeSpendings": {
              url: urlBase + "/Quotes/:id/operativeSpendings/count",
              method: "GET",
            },

            // INTERNAL. Use OSItem.operativeSpending() instead.
            "::get::OSItem::operativeSpending": {
              url: urlBase + "/OSItems/:id/operativeSpending",
              method: "GET",
            },

            // INTERNAL. Use Voucher.operativeSpendings.findById() instead.
            "::findById::Voucher::operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/operativeSpendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Voucher.operativeSpendings.destroyById() instead.
            "::destroyById::Voucher::operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/operativeSpendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.operativeSpendings.updateById() instead.
            "::updateById::Voucher::operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/operativeSpendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Voucher.operativeSpendings() instead.
            "::get::Voucher::operativeSpendings": {
              isArray: true,
              url: urlBase + "/Vouchers/:id/operativeSpendings",
              method: "GET",
            },

            // INTERNAL. Use Voucher.operativeSpendings.create() instead.
            "::create::Voucher::operativeSpendings": {
              url: urlBase + "/Vouchers/:id/operativeSpendings",
              method: "POST",
            },

            // INTERNAL. Use Voucher.operativeSpendings.createMany() instead.
            "::createMany::Voucher::operativeSpendings": {
              isArray: true,
              url: urlBase + "/Vouchers/:id/operativeSpendings",
              method: "POST",
            },

            // INTERNAL. Use Voucher.operativeSpendings.destroyAll() instead.
            "::delete::Voucher::operativeSpendings": {
              url: urlBase + "/Vouchers/:id/operativeSpendings",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.operativeSpendings.count() instead.
            "::count::Voucher::operativeSpendings": {
              url: urlBase + "/Vouchers/:id/operativeSpendings/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#upsert
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#updateOrCreate
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#patchOrCreateWithWhere
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#update
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#destroyById
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#removeById
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#prototype$updateAttributes
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OperativeSpending#modelName
        * @propertyOf lbServices.OperativeSpending
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OperativeSpending`.
        */
        R.modelName = "OperativeSpending";


            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#employee
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Fetches belongsTo relation employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R.employee = function() {
          var TargetResource = $injector.get("Employee");
          var action = TargetResource["::get::OperativeSpending::employee"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#collection
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Fetches belongsTo relation collection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collection` object.)
             * </em>
             */
        R.collection = function() {
          var TargetResource = $injector.get("Collection");
          var action = TargetResource["::get::OperativeSpending::collection"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#quote
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Fetches belongsTo relation quote.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quote = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::get::OperativeSpending::quote"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#vehicle
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Fetches belongsTo relation vehicle.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R.vehicle = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::get::OperativeSpending::vehicle"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#holder
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Fetches belongsTo relation holder.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.holder = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::OperativeSpending::holder"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OperativeSpending.createdByUser
     * @header lbServices.OperativeSpending.createdByUser
     * @object
     * @description
     *
     * The object `OperativeSpending.createdByUser` groups methods
     * manipulating `SegaUser` instances related to `OperativeSpending`.
     *
     * Call {@link lbServices.OperativeSpending#createdByUser OperativeSpending.createdByUser()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#createManydByUser
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createManydByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::OperativeSpending::createManydByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#createdByUser
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createdByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::OperativeSpending::createdByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#updatedByUser
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Fetches belongsTo relation updatedByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.updatedByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::OperativeSpending::updatedByUser"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OperativeSpending.osItems
     * @header lbServices.OperativeSpending.osItems
     * @object
     * @description
     *
     * The object `OperativeSpending.osItems` groups methods
     * manipulating `OSItem` instances related to `OperativeSpending`.
     *
     * Call {@link lbServices.OperativeSpending#osItems OperativeSpending.osItems()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#osItems
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Queries osItems of OperativeSpending.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R.osItems = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::get::OperativeSpending::osItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending.osItems#count
             * @methodOf lbServices.OperativeSpending.osItems
             *
             * @description
             *
             * Counts osItems of OperativeSpending.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.osItems.count = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::count::OperativeSpending::osItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending.osItems#create
             * @methodOf lbServices.OperativeSpending.osItems
             *
             * @description
             *
             * Creates a new instance in osItems of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R.osItems.create = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::create::OperativeSpending::osItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending.osItems#createMany
             * @methodOf lbServices.OperativeSpending.osItems
             *
             * @description
             *
             * Creates a new instance in osItems of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R.osItems.createMany = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::createMany::OperativeSpending::osItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending.osItems#destroyAll
             * @methodOf lbServices.OperativeSpending.osItems
             *
             * @description
             *
             * Deletes all osItems of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.osItems.destroyAll = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::delete::OperativeSpending::osItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending.osItems#destroyById
             * @methodOf lbServices.OperativeSpending.osItems
             *
             * @description
             *
             * Delete a related item by id for osItems.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for osItems
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.osItems.destroyById = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::destroyById::OperativeSpending::osItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending.osItems#findById
             * @methodOf lbServices.OperativeSpending.osItems
             *
             * @description
             *
             * Find a related item by id for osItems.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for osItems
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R.osItems.findById = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::findById::OperativeSpending::osItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending.osItems#updateById
             * @methodOf lbServices.OperativeSpending.osItems
             *
             * @description
             *
             * Update a related item by id for osItems.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `fk` – `{*}` - Foreign key for osItems
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R.osItems.updateById = function() {
          var TargetResource = $injector.get("OSItem");
          var action = TargetResource["::updateById::OperativeSpending::osItems"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperativeSpending#voucher
             * @methodOf lbServices.OperativeSpending
             *
             * @description
             *
             * Fetches belongsTo relation voucher.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperativeSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
        R.voucher = function() {
          var TargetResource = $injector.get("Voucher");
          var action = TargetResource["::get::OperativeSpending::voucher"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OSItem
 * @header lbServices.OSItem
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OSItem` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OSItem",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/OSItems/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OSItem.operativeSpending() instead.
            "prototype$__get__operativeSpending": {
              url: urlBase + "/OSItems/:id/operativeSpending",
              method: "GET",
            },

            // INTERNAL. Use OSItem.quote() instead.
            "prototype$__get__quote": {
              url: urlBase + "/OSItems/:id/quote",
              method: "GET",
            },

            // INTERNAL. Use OSItem.item() instead.
            "prototype$__get__item": {
              url: urlBase + "/OSItems/:id/item",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OSItem#create
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/OSItems",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OSItem#patchOrCreate
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/OSItems",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OSItem#replaceOrCreate
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/OSItems/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OSItem#upsertWithWhere
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/OSItems/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OSItem#exists
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/OSItems/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OSItem#findById
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/OSItems/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OSItem#replaceById
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/OSItems/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OSItem#find
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/OSItems",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OSItem#findOne
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/OSItems/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OSItem#updateAll
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/OSItems/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OSItem#deleteById
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/OSItems/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OSItem#count
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/OSItems/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OSItem#prototype$patchAttributes
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OSItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/OSItems/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OSItem#createChangeStream
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/OSItems/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OSItem#createMany
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/OSItems",
              method: "POST",
            },

            // INTERNAL. Use Item.osItems.findById() instead.
            "::findById::Item::osItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Items/:id/osItems/:fk",
              method: "GET",
            },

            // INTERNAL. Use Item.osItems.destroyById() instead.
            "::destroyById::Item::osItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Items/:id/osItems/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Item.osItems.updateById() instead.
            "::updateById::Item::osItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Items/:id/osItems/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Item.osItems() instead.
            "::get::Item::osItems": {
              isArray: true,
              url: urlBase + "/Items/:id/osItems",
              method: "GET",
            },

            // INTERNAL. Use Item.osItems.create() instead.
            "::create::Item::osItems": {
              url: urlBase + "/Items/:id/osItems",
              method: "POST",
            },

            // INTERNAL. Use Item.osItems.createMany() instead.
            "::createMany::Item::osItems": {
              isArray: true,
              url: urlBase + "/Items/:id/osItems",
              method: "POST",
            },

            // INTERNAL. Use Item.osItems.destroyAll() instead.
            "::delete::Item::osItems": {
              url: urlBase + "/Items/:id/osItems",
              method: "DELETE",
            },

            // INTERNAL. Use Item.osItems.count() instead.
            "::count::Item::osItems": {
              url: urlBase + "/Items/:id/osItems/count",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.osItems.findById() instead.
            "::findById::OperativeSpending::osItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperativeSpendings/:id/osItems/:fk",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.osItems.destroyById() instead.
            "::destroyById::OperativeSpending::osItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperativeSpendings/:id/osItems/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OperativeSpending.osItems.updateById() instead.
            "::updateById::OperativeSpending::osItems": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperativeSpendings/:id/osItems/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OperativeSpending.osItems() instead.
            "::get::OperativeSpending::osItems": {
              isArray: true,
              url: urlBase + "/OperativeSpendings/:id/osItems",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.osItems.create() instead.
            "::create::OperativeSpending::osItems": {
              url: urlBase + "/OperativeSpendings/:id/osItems",
              method: "POST",
            },

            // INTERNAL. Use OperativeSpending.osItems.createMany() instead.
            "::createMany::OperativeSpending::osItems": {
              isArray: true,
              url: urlBase + "/OperativeSpendings/:id/osItems",
              method: "POST",
            },

            // INTERNAL. Use OperativeSpending.osItems.destroyAll() instead.
            "::delete::OperativeSpending::osItems": {
              url: urlBase + "/OperativeSpendings/:id/osItems",
              method: "DELETE",
            },

            // INTERNAL. Use OperativeSpending.osItems.count() instead.
            "::count::OperativeSpending::osItems": {
              url: urlBase + "/OperativeSpendings/:id/osItems/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OSItem#upsert
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OSItem#updateOrCreate
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OSItem#patchOrCreateWithWhere
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OSItem#update
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OSItem#destroyById
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OSItem#removeById
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OSItem#prototype$updateAttributes
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OSItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OSItem` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OSItem#modelName
        * @propertyOf lbServices.OSItem
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OSItem`.
        */
        R.modelName = "OSItem";


            /**
             * @ngdoc method
             * @name lbServices.OSItem#operativeSpending
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Fetches belongsTo relation operativeSpending.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OSItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpending = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::get::OSItem::operativeSpending"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OSItem#quote
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Fetches belongsTo relation quote.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OSItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quote = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::get::OSItem::quote"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OSItem#item
             * @methodOf lbServices.OSItem
             *
             * @description
             *
             * Fetches belongsTo relation item.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OSItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Item` object.)
             * </em>
             */
        R.item = function() {
          var TargetResource = $injector.get("Item");
          var action = TargetResource["::get::OSItem::item"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Voucher
 * @header lbServices.Voucher
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Voucher` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Voucher",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Vouchers/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Voucher.operativeSpendings.findById() instead.
            "prototype$__findById__operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/operativeSpendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Voucher.operativeSpendings.destroyById() instead.
            "prototype$__destroyById__operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/operativeSpendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.operativeSpendings.updateById() instead.
            "prototype$__updateById__operativeSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/operativeSpendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Voucher.spendings.findById() instead.
            "prototype$__findById__spendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/spendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Voucher.spendings.destroyById() instead.
            "prototype$__destroyById__spendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/spendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.spendings.updateById() instead.
            "prototype$__updateById__spendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/spendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Voucher.employee() instead.
            "prototype$__get__employee": {
              url: urlBase + "/Vouchers/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use Voucher.assignedEmployee() instead.
            "prototype$__get__assignedEmployee": {
              url: urlBase + "/Vouchers/:id/assignedEmployee",
              method: "GET",
            },

            // INTERNAL. Use Voucher.createdByUser() instead.
            "prototype$__get__createdByUser": {
              url: urlBase + "/Vouchers/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Voucher.updatedByUser() instead.
            "prototype$__get__updatedByUser": {
              url: urlBase + "/Vouchers/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use Voucher.pendingSpendings.findById() instead.
            "prototype$__findById__pendingSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/pendingSpendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Voucher.pendingSpendings.destroyById() instead.
            "prototype$__destroyById__pendingSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/pendingSpendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.pendingSpendings.updateById() instead.
            "prototype$__updateById__pendingSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/pendingSpendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Voucher.generatedPendingSpendings.findById() instead.
            "prototype$__findById__generatedPendingSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/generatedPendingSpendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Voucher.generatedPendingSpendings.destroyById() instead.
            "prototype$__destroyById__generatedPendingSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/generatedPendingSpendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.generatedPendingSpendings.updateById() instead.
            "prototype$__updateById__generatedPendingSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/generatedPendingSpendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Voucher.worker() instead.
            "prototype$__get__worker": {
              url: urlBase + "/Vouchers/:id/worker",
              method: "GET",
            },

            // INTERNAL. Use Voucher.operativeSpendings() instead.
            "prototype$__get__operativeSpendings": {
              isArray: true,
              url: urlBase + "/Vouchers/:id/operativeSpendings",
              method: "GET",
            },

            // INTERNAL. Use Voucher.operativeSpendings.create() instead.
            "prototype$__create__operativeSpendings": {
              url: urlBase + "/Vouchers/:id/operativeSpendings",
              method: "POST",
            },

            // INTERNAL. Use Voucher.operativeSpendings.destroyAll() instead.
            "prototype$__delete__operativeSpendings": {
              url: urlBase + "/Vouchers/:id/operativeSpendings",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.operativeSpendings.count() instead.
            "prototype$__count__operativeSpendings": {
              url: urlBase + "/Vouchers/:id/operativeSpendings/count",
              method: "GET",
            },

            // INTERNAL. Use Voucher.spendings() instead.
            "prototype$__get__spendings": {
              isArray: true,
              url: urlBase + "/Vouchers/:id/spendings",
              method: "GET",
            },

            // INTERNAL. Use Voucher.spendings.create() instead.
            "prototype$__create__spendings": {
              url: urlBase + "/Vouchers/:id/spendings",
              method: "POST",
            },

            // INTERNAL. Use Voucher.spendings.destroyAll() instead.
            "prototype$__delete__spendings": {
              url: urlBase + "/Vouchers/:id/spendings",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.spendings.count() instead.
            "prototype$__count__spendings": {
              url: urlBase + "/Vouchers/:id/spendings/count",
              method: "GET",
            },

            // INTERNAL. Use Voucher.pendingSpendings() instead.
            "prototype$__get__pendingSpendings": {
              isArray: true,
              url: urlBase + "/Vouchers/:id/pendingSpendings",
              method: "GET",
            },

            // INTERNAL. Use Voucher.pendingSpendings.create() instead.
            "prototype$__create__pendingSpendings": {
              url: urlBase + "/Vouchers/:id/pendingSpendings",
              method: "POST",
            },

            // INTERNAL. Use Voucher.pendingSpendings.destroyAll() instead.
            "prototype$__delete__pendingSpendings": {
              url: urlBase + "/Vouchers/:id/pendingSpendings",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.pendingSpendings.count() instead.
            "prototype$__count__pendingSpendings": {
              url: urlBase + "/Vouchers/:id/pendingSpendings/count",
              method: "GET",
            },

            // INTERNAL. Use Voucher.generatedPendingSpendings() instead.
            "prototype$__get__generatedPendingSpendings": {
              isArray: true,
              url: urlBase + "/Vouchers/:id/generatedPendingSpendings",
              method: "GET",
            },

            // INTERNAL. Use Voucher.generatedPendingSpendings.create() instead.
            "prototype$__create__generatedPendingSpendings": {
              url: urlBase + "/Vouchers/:id/generatedPendingSpendings",
              method: "POST",
            },

            // INTERNAL. Use Voucher.generatedPendingSpendings.destroyAll() instead.
            "prototype$__delete__generatedPendingSpendings": {
              url: urlBase + "/Vouchers/:id/generatedPendingSpendings",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.generatedPendingSpendings.count() instead.
            "prototype$__count__generatedPendingSpendings": {
              url: urlBase + "/Vouchers/:id/generatedPendingSpendings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#create
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Vouchers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#patchOrCreate
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Vouchers",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#replaceOrCreate
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Vouchers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#upsertWithWhere
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Vouchers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#exists
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Vouchers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#findById
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Vouchers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#replaceById
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Vouchers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#find
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Vouchers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#findOne
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Vouchers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#updateAll
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Vouchers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#deleteById
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Vouchers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#count
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Vouchers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#prototype$patchAttributes
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Vouchers/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#createChangeStream
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Vouchers/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#pdf
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Returns a pdf representation of the voucher
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{integer}` - Voucher id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
            "pdf": {
              url: urlBase + "/Vouchers/pdf",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#newPdf
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Returns a pdf representation of the voucher
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{integer}` - Voucher id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
            "newPdf": {
              url: urlBase + "/Vouchers/newPdf",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#void
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Voids a voucher
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - Voucher id
             *
             *  - `reason` – `{string}` - Voidance reason
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `voucher` – `{object=}` -
             */
            "void": {
              url: urlBase + "/Vouchers/void",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#html
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Returns the html representation of the voucher
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{integer}` - Voucher id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
            "html": {
              url: urlBase + "/Vouchers/html",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#createNew
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Creates a new voucher
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `opts` – `{object}` - Voucher data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `voucher` – `{object=}` - Voucher recently created
             */
            "createNew": {
              url: urlBase + "/Vouchers/createNew",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#addCashReturn
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Adds a cash return to a voucher
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - Voucher id
             *
             *  - `amount` – `{number}` - Amount
             *
             *  - `comments` – `{string=}` - Comments
             *
             *  - `dstCashboxId` – `{number=}` - Destination cashbox id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Result stuff
             */
            "addCashReturn": {
              url: urlBase + "/Vouchers/addCashReturn",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#voidCashReturn
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Voids a cash return
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `voucherId` – `{number}` - Voucher id
             *
             *  - `cashboxTxId` – `{number}` - Amount
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Result stuff
             */
            "voidCashReturn": {
              url: urlBase + "/Vouchers/voidCashReturn",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#findCashReturns
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Returns cash returns
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` - Voucher id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `transactions` – `{*=}` - Cashbox transactions
             */
            "findCashReturns": {
              url: urlBase + "/Vouchers/findCashReturns",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#findVouchers
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Custom find method
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object}` - Filter object
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` - Contains Array of returned vouchers and count
             */
            "findVouchers": {
              url: urlBase + "/Vouchers/findVouchers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Voucher#createMany
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Vouchers",
              method: "POST",
            },

            // INTERNAL. Use Spending.voucher() instead.
            "::get::Spending::voucher": {
              url: urlBase + "/Spendings/:id/voucher",
              method: "GET",
            },

            // INTERNAL. Use OperativeSpending.voucher() instead.
            "::get::OperativeSpending::voucher": {
              url: urlBase + "/OperativeSpendings/:id/voucher",
              method: "GET",
            },

            // INTERNAL. Use PendingSpending.srcVoucher() instead.
            "::get::PendingSpending::srcVoucher": {
              url: urlBase + "/PendingSpendings/:id/srcVoucher",
              method: "GET",
            },

            // INTERNAL. Use PendingSpending.dstVoucher() instead.
            "::get::PendingSpending::dstVoucher": {
              url: urlBase + "/PendingSpendings/:id/dstVoucher",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Voucher#upsert
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Voucher#updateOrCreate
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Voucher#patchOrCreateWithWhere
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Voucher#update
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Voucher#destroyById
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Voucher#removeById
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Voucher#prototype$updateAttributes
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Voucher#modelName
        * @propertyOf lbServices.Voucher
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Voucher`.
        */
        R.modelName = "Voucher";

    /**
     * @ngdoc object
     * @name lbServices.Voucher.operativeSpendings
     * @header lbServices.Voucher.operativeSpendings
     * @object
     * @description
     *
     * The object `Voucher.operativeSpendings` groups methods
     * manipulating `OperativeSpending` instances related to `Voucher`.
     *
     * Call {@link lbServices.Voucher#operativeSpendings Voucher.operativeSpendings()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Voucher#operativeSpendings
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Queries operativeSpendings of Voucher.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpendings = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::get::Voucher::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.operativeSpendings#count
             * @methodOf lbServices.Voucher.operativeSpendings
             *
             * @description
             *
             * Counts operativeSpendings of Voucher.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.operativeSpendings.count = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::count::Voucher::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.operativeSpendings#create
             * @methodOf lbServices.Voucher.operativeSpendings
             *
             * @description
             *
             * Creates a new instance in operativeSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpendings.create = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::create::Voucher::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.operativeSpendings#createMany
             * @methodOf lbServices.Voucher.operativeSpendings
             *
             * @description
             *
             * Creates a new instance in operativeSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpendings.createMany = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::createMany::Voucher::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.operativeSpendings#destroyAll
             * @methodOf lbServices.Voucher.operativeSpendings
             *
             * @description
             *
             * Deletes all operativeSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.operativeSpendings.destroyAll = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::delete::Voucher::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.operativeSpendings#destroyById
             * @methodOf lbServices.Voucher.operativeSpendings
             *
             * @description
             *
             * Delete a related item by id for operativeSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operativeSpendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.operativeSpendings.destroyById = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::destroyById::Voucher::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.operativeSpendings#findById
             * @methodOf lbServices.Voucher.operativeSpendings
             *
             * @description
             *
             * Find a related item by id for operativeSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operativeSpendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpendings.findById = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::findById::Voucher::operativeSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.operativeSpendings#updateById
             * @methodOf lbServices.Voucher.operativeSpendings
             *
             * @description
             *
             * Update a related item by id for operativeSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `fk` – `{*}` - Foreign key for operativeSpendings
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperativeSpending` object.)
             * </em>
             */
        R.operativeSpendings.updateById = function() {
          var TargetResource = $injector.get("OperativeSpending");
          var action = TargetResource["::updateById::Voucher::operativeSpendings"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Voucher.spendings
     * @header lbServices.Voucher.spendings
     * @object
     * @description
     *
     * The object `Voucher.spendings` groups methods
     * manipulating `Spending` instances related to `Voucher`.
     *
     * Call {@link lbServices.Voucher#spendings Voucher.spendings()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Voucher#spendings
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Queries spendings of Voucher.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R.spendings = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::get::Voucher::spendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.spendings#count
             * @methodOf lbServices.Voucher.spendings
             *
             * @description
             *
             * Counts spendings of Voucher.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.spendings.count = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::count::Voucher::spendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.spendings#create
             * @methodOf lbServices.Voucher.spendings
             *
             * @description
             *
             * Creates a new instance in spendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R.spendings.create = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::create::Voucher::spendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.spendings#createMany
             * @methodOf lbServices.Voucher.spendings
             *
             * @description
             *
             * Creates a new instance in spendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R.spendings.createMany = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::createMany::Voucher::spendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.spendings#destroyAll
             * @methodOf lbServices.Voucher.spendings
             *
             * @description
             *
             * Deletes all spendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.spendings.destroyAll = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::delete::Voucher::spendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.spendings#destroyById
             * @methodOf lbServices.Voucher.spendings
             *
             * @description
             *
             * Delete a related item by id for spendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for spendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.spendings.destroyById = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::destroyById::Voucher::spendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.spendings#findById
             * @methodOf lbServices.Voucher.spendings
             *
             * @description
             *
             * Find a related item by id for spendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for spendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R.spendings.findById = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::findById::Voucher::spendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.spendings#updateById
             * @methodOf lbServices.Voucher.spendings
             *
             * @description
             *
             * Update a related item by id for spendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `fk` – `{*}` - Foreign key for spendings
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Spending` object.)
             * </em>
             */
        R.spendings.updateById = function() {
          var TargetResource = $injector.get("Spending");
          var action = TargetResource["::updateById::Voucher::spendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher#employee
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Fetches belongsTo relation employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R.employee = function() {
          var TargetResource = $injector.get("Employee");
          var action = TargetResource["::get::Voucher::employee"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher#assignedEmployee
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Fetches belongsTo relation assignedEmployee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R.assignedEmployee = function() {
          var TargetResource = $injector.get("Employee");
          var action = TargetResource["::get::Voucher::assignedEmployee"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Voucher.createdByUser
     * @header lbServices.Voucher.createdByUser
     * @object
     * @description
     *
     * The object `Voucher.createdByUser` groups methods
     * manipulating `SegaUser` instances related to `Voucher`.
     *
     * Call {@link lbServices.Voucher#createdByUser Voucher.createdByUser()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Voucher#createManydByUser
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createManydByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Voucher::createManydByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher#createdByUser
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createdByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Voucher::createdByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher#updatedByUser
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Fetches belongsTo relation updatedByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.updatedByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Voucher::updatedByUser"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Voucher.pendingSpendings
     * @header lbServices.Voucher.pendingSpendings
     * @object
     * @description
     *
     * The object `Voucher.pendingSpendings` groups methods
     * manipulating `PendingSpending` instances related to `Voucher`.
     *
     * Call {@link lbServices.Voucher#pendingSpendings Voucher.pendingSpendings()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Voucher#pendingSpendings
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Queries pendingSpendings of Voucher.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R.pendingSpendings = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::get::Voucher::pendingSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.pendingSpendings#count
             * @methodOf lbServices.Voucher.pendingSpendings
             *
             * @description
             *
             * Counts pendingSpendings of Voucher.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.pendingSpendings.count = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::count::Voucher::pendingSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.pendingSpendings#create
             * @methodOf lbServices.Voucher.pendingSpendings
             *
             * @description
             *
             * Creates a new instance in pendingSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R.pendingSpendings.create = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::create::Voucher::pendingSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.pendingSpendings#createMany
             * @methodOf lbServices.Voucher.pendingSpendings
             *
             * @description
             *
             * Creates a new instance in pendingSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R.pendingSpendings.createMany = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::createMany::Voucher::pendingSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.pendingSpendings#destroyAll
             * @methodOf lbServices.Voucher.pendingSpendings
             *
             * @description
             *
             * Deletes all pendingSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.pendingSpendings.destroyAll = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::delete::Voucher::pendingSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.pendingSpendings#destroyById
             * @methodOf lbServices.Voucher.pendingSpendings
             *
             * @description
             *
             * Delete a related item by id for pendingSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for pendingSpendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.pendingSpendings.destroyById = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::destroyById::Voucher::pendingSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.pendingSpendings#findById
             * @methodOf lbServices.Voucher.pendingSpendings
             *
             * @description
             *
             * Find a related item by id for pendingSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for pendingSpendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R.pendingSpendings.findById = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::findById::Voucher::pendingSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.pendingSpendings#updateById
             * @methodOf lbServices.Voucher.pendingSpendings
             *
             * @description
             *
             * Update a related item by id for pendingSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `fk` – `{*}` - Foreign key for pendingSpendings
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R.pendingSpendings.updateById = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::updateById::Voucher::pendingSpendings"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Voucher.generatedPendingSpendings
     * @header lbServices.Voucher.generatedPendingSpendings
     * @object
     * @description
     *
     * The object `Voucher.generatedPendingSpendings` groups methods
     * manipulating `PendingSpending` instances related to `Voucher`.
     *
     * Call {@link lbServices.Voucher#generatedPendingSpendings Voucher.generatedPendingSpendings()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Voucher#generatedPendingSpendings
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Queries generatedPendingSpendings of Voucher.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R.generatedPendingSpendings = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::get::Voucher::generatedPendingSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.generatedPendingSpendings#count
             * @methodOf lbServices.Voucher.generatedPendingSpendings
             *
             * @description
             *
             * Counts generatedPendingSpendings of Voucher.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.generatedPendingSpendings.count = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::count::Voucher::generatedPendingSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.generatedPendingSpendings#create
             * @methodOf lbServices.Voucher.generatedPendingSpendings
             *
             * @description
             *
             * Creates a new instance in generatedPendingSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R.generatedPendingSpendings.create = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::create::Voucher::generatedPendingSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.generatedPendingSpendings#createMany
             * @methodOf lbServices.Voucher.generatedPendingSpendings
             *
             * @description
             *
             * Creates a new instance in generatedPendingSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R.generatedPendingSpendings.createMany = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::createMany::Voucher::generatedPendingSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.generatedPendingSpendings#destroyAll
             * @methodOf lbServices.Voucher.generatedPendingSpendings
             *
             * @description
             *
             * Deletes all generatedPendingSpendings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.generatedPendingSpendings.destroyAll = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::delete::Voucher::generatedPendingSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.generatedPendingSpendings#destroyById
             * @methodOf lbServices.Voucher.generatedPendingSpendings
             *
             * @description
             *
             * Delete a related item by id for generatedPendingSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for generatedPendingSpendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.generatedPendingSpendings.destroyById = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::destroyById::Voucher::generatedPendingSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.generatedPendingSpendings#findById
             * @methodOf lbServices.Voucher.generatedPendingSpendings
             *
             * @description
             *
             * Find a related item by id for generatedPendingSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for generatedPendingSpendings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R.generatedPendingSpendings.findById = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::findById::Voucher::generatedPendingSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher.generatedPendingSpendings#updateById
             * @methodOf lbServices.Voucher.generatedPendingSpendings
             *
             * @description
             *
             * Update a related item by id for generatedPendingSpendings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `fk` – `{*}` - Foreign key for generatedPendingSpendings
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R.generatedPendingSpendings.updateById = function() {
          var TargetResource = $injector.get("PendingSpending");
          var action = TargetResource["::updateById::Voucher::generatedPendingSpendings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Voucher#worker
             * @methodOf lbServices.Voucher
             *
             * @description
             *
             * Fetches belongsTo relation worker.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Voucher id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
        R.worker = function() {
          var TargetResource = $injector.get("Worker");
          var action = TargetResource["::get::Voucher::worker"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PendingSpending
 * @header lbServices.PendingSpending
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PendingSpending` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PendingSpending",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/PendingSpendings/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PendingSpending.srcVoucher() instead.
            "prototype$__get__srcVoucher": {
              url: urlBase + "/PendingSpendings/:id/srcVoucher",
              method: "GET",
            },

            // INTERNAL. Use PendingSpending.dstVoucher() instead.
            "prototype$__get__dstVoucher": {
              url: urlBase + "/PendingSpendings/:id/dstVoucher",
              method: "GET",
            },

            // INTERNAL. Use PendingSpending.registry() instead.
            "prototype$__get__registry": {
              url: urlBase + "/PendingSpendings/:id/registry",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#create
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/PendingSpendings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#patchOrCreate
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/PendingSpendings",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#replaceOrCreate
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/PendingSpendings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#upsertWithWhere
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/PendingSpendings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#exists
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/PendingSpendings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#findById
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/PendingSpendings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#replaceById
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/PendingSpendings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#find
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/PendingSpendings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#findOne
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/PendingSpendings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#updateAll
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/PendingSpendings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#deleteById
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/PendingSpendings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#count
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/PendingSpendings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#prototype$patchAttributes
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PendingSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/PendingSpendings/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#createChangeStream
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/PendingSpendings/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#addToVoucher
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Adds pending spending to a voucher
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{integer}` - PS id
             *
             *  - `voucherId` – `{integer}` - Voucher id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `pendingSpending` – `{object=}` -
             */
            "addToVoucher": {
              url: urlBase + "/PendingSpendings/addToVoucher",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#void
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Voids a pending spending
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - PSpending id
             *
             *  - `reason` – `{string}` - Voidance reason
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `pendingSpending` – `{object=}` -
             */
            "void": {
              url: urlBase + "/PendingSpendings/void",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#removeFromVoucher
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Removes a pending spending from a voucher
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{integer}` - PS id
             *
             *  - `voucherId` – `{integer}` - Voucher id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `pendingSpending` – `{object=}` -
             */
            "removeFromVoucher": {
              url: urlBase + "/PendingSpendings/removeFromVoucher",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#createMany
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/PendingSpendings",
              method: "POST",
            },

            // INTERNAL. Use Voucher.pendingSpendings.findById() instead.
            "::findById::Voucher::pendingSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/pendingSpendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Voucher.pendingSpendings.destroyById() instead.
            "::destroyById::Voucher::pendingSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/pendingSpendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.pendingSpendings.updateById() instead.
            "::updateById::Voucher::pendingSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/pendingSpendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Voucher.generatedPendingSpendings.findById() instead.
            "::findById::Voucher::generatedPendingSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/generatedPendingSpendings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Voucher.generatedPendingSpendings.destroyById() instead.
            "::destroyById::Voucher::generatedPendingSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/generatedPendingSpendings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.generatedPendingSpendings.updateById() instead.
            "::updateById::Voucher::generatedPendingSpendings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vouchers/:id/generatedPendingSpendings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Voucher.pendingSpendings() instead.
            "::get::Voucher::pendingSpendings": {
              isArray: true,
              url: urlBase + "/Vouchers/:id/pendingSpendings",
              method: "GET",
            },

            // INTERNAL. Use Voucher.pendingSpendings.create() instead.
            "::create::Voucher::pendingSpendings": {
              url: urlBase + "/Vouchers/:id/pendingSpendings",
              method: "POST",
            },

            // INTERNAL. Use Voucher.pendingSpendings.createMany() instead.
            "::createMany::Voucher::pendingSpendings": {
              isArray: true,
              url: urlBase + "/Vouchers/:id/pendingSpendings",
              method: "POST",
            },

            // INTERNAL. Use Voucher.pendingSpendings.destroyAll() instead.
            "::delete::Voucher::pendingSpendings": {
              url: urlBase + "/Vouchers/:id/pendingSpendings",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.pendingSpendings.count() instead.
            "::count::Voucher::pendingSpendings": {
              url: urlBase + "/Vouchers/:id/pendingSpendings/count",
              method: "GET",
            },

            // INTERNAL. Use Voucher.generatedPendingSpendings() instead.
            "::get::Voucher::generatedPendingSpendings": {
              isArray: true,
              url: urlBase + "/Vouchers/:id/generatedPendingSpendings",
              method: "GET",
            },

            // INTERNAL. Use Voucher.generatedPendingSpendings.create() instead.
            "::create::Voucher::generatedPendingSpendings": {
              url: urlBase + "/Vouchers/:id/generatedPendingSpendings",
              method: "POST",
            },

            // INTERNAL. Use Voucher.generatedPendingSpendings.createMany() instead.
            "::createMany::Voucher::generatedPendingSpendings": {
              isArray: true,
              url: urlBase + "/Vouchers/:id/generatedPendingSpendings",
              method: "POST",
            },

            // INTERNAL. Use Voucher.generatedPendingSpendings.destroyAll() instead.
            "::delete::Voucher::generatedPendingSpendings": {
              url: urlBase + "/Vouchers/:id/generatedPendingSpendings",
              method: "DELETE",
            },

            // INTERNAL. Use Voucher.generatedPendingSpendings.count() instead.
            "::count::Voucher::generatedPendingSpendings": {
              url: urlBase + "/Vouchers/:id/generatedPendingSpendings/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#upsert
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#updateOrCreate
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#patchOrCreateWithWhere
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#update
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#destroyById
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#removeById
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#prototype$updateAttributes
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PendingSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PendingSpending` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PendingSpending#modelName
        * @propertyOf lbServices.PendingSpending
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PendingSpending`.
        */
        R.modelName = "PendingSpending";


            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#srcVoucher
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Fetches belongsTo relation srcVoucher.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PendingSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
        R.srcVoucher = function() {
          var TargetResource = $injector.get("Voucher");
          var action = TargetResource["::get::PendingSpending::srcVoucher"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#dstVoucher
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Fetches belongsTo relation dstVoucher.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PendingSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Voucher` object.)
             * </em>
             */
        R.dstVoucher = function() {
          var TargetResource = $injector.get("Voucher");
          var action = TargetResource["::get::PendingSpending::dstVoucher"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PendingSpending#registry
             * @methodOf lbServices.PendingSpending
             *
             * @description
             *
             * Fetches belongsTo relation registry.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PendingSpending id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
        R.registry = function() {
          var TargetResource = $injector.get("Registry");
          var action = TargetResource["::get::PendingSpending::registry"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Worker
 * @header lbServices.Worker
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Worker` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Worker",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Workers/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Worker#create
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Workers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Worker#patchOrCreate
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Workers",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Worker#replaceOrCreate
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Workers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Worker#upsertWithWhere
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Workers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Worker#exists
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Workers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Worker#findById
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Workers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Worker#replaceById
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Workers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Worker#find
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Workers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Worker#findOne
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Workers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Worker#updateAll
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Workers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Worker#deleteById
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Workers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Worker#count
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Workers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Worker#prototype$patchAttributes
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Worker id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Workers/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Worker#createChangeStream
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Workers/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Worker#createMany
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Workers",
              method: "POST",
            },

            // INTERNAL. Use Voucher.worker() instead.
            "::get::Voucher::worker": {
              url: urlBase + "/Vouchers/:id/worker",
              method: "GET",
            },

            // INTERNAL. Use Assignation.worker() instead.
            "::get::Assignation::worker": {
              url: urlBase + "/Assignations/:id/worker",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Worker#upsert
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Worker#updateOrCreate
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Worker#patchOrCreateWithWhere
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Worker#update
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Worker#destroyById
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Worker#removeById
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Worker#prototype$updateAttributes
             * @methodOf lbServices.Worker
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Worker id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Worker#modelName
        * @propertyOf lbServices.Worker
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Worker`.
        */
        R.modelName = "Worker";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Registry
 * @header lbServices.Registry
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Registry` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Registry",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Registries/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Registry#create
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Registries",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Registry#patchOrCreate
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Registries",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Registry#replaceOrCreate
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Registries/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Registry#upsertWithWhere
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Registries/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Registry#exists
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Registries/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Registry#findById
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Registries/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Registry#replaceById
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Registries/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Registry#find
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Registries",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Registry#findOne
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Registries/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Registry#updateAll
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Registries/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Registry#deleteById
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Registries/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Registry#count
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Registries/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Registry#prototype$patchAttributes
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Registry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Registries/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Registry#createChangeStream
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Registries/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Registry#createMany
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Registries",
              method: "POST",
            },

            // INTERNAL. Use PendingSpending.registry() instead.
            "::get::PendingSpending::registry": {
              url: urlBase + "/PendingSpendings/:id/registry",
              method: "GET",
            },

            // INTERNAL. Use Assignation.registry() instead.
            "::get::Assignation::registry": {
              url: urlBase + "/Assignations/:id/registry",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Registry#upsert
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Registry#updateOrCreate
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Registry#patchOrCreateWithWhere
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Registry#update
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Registry#destroyById
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Registry#removeById
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Registry#prototype$updateAttributes
             * @methodOf lbServices.Registry
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Registry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Registry#modelName
        * @propertyOf lbServices.Registry
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Registry`.
        */
        R.modelName = "Registry";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.GroupInvoice
 * @header lbServices.GroupInvoice
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `GroupInvoice` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "GroupInvoice",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/GroupInvoices/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use GroupInvoice.client() instead.
            "prototype$__get__client": {
              url: urlBase + "/GroupInvoices/:id/client",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.quotes.findById() instead.
            "prototype$__findById__quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/quotes/:fk",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.quotes.destroyById() instead.
            "prototype$__destroyById__quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/quotes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use GroupInvoice.quotes.updateById() instead.
            "prototype$__updateById__quotes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/quotes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use GroupInvoice.receipts.findById() instead.
            "prototype$__findById__receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receipts/:fk",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.receipts.destroyById() instead.
            "prototype$__destroyById__receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receipts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use GroupInvoice.receipts.updateById() instead.
            "prototype$__updateById__receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receipts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use GroupInvoice.receipts.link() instead.
            "prototype$__link__receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receipts/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use GroupInvoice.receipts.unlink() instead.
            "prototype$__unlink__receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receipts/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use GroupInvoice.receipts.exists() instead.
            "prototype$__exists__receipts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receipts/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use GroupInvoice.receiptGroupInvoices.findById() instead.
            "prototype$__findById__receiptGroupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receiptGroupInvoices/:fk",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.receiptGroupInvoices.destroyById() instead.
            "prototype$__destroyById__receiptGroupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receiptGroupInvoices/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use GroupInvoice.receiptGroupInvoices.updateById() instead.
            "prototype$__updateById__receiptGroupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receiptGroupInvoices/:fk",
              method: "PUT",
            },

            // INTERNAL. Use GroupInvoice.quotes() instead.
            "prototype$__get__quotes": {
              isArray: true,
              url: urlBase + "/GroupInvoices/:id/quotes",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.quotes.create() instead.
            "prototype$__create__quotes": {
              url: urlBase + "/GroupInvoices/:id/quotes",
              method: "POST",
            },

            // INTERNAL. Use GroupInvoice.quotes.destroyAll() instead.
            "prototype$__delete__quotes": {
              url: urlBase + "/GroupInvoices/:id/quotes",
              method: "DELETE",
            },

            // INTERNAL. Use GroupInvoice.quotes.count() instead.
            "prototype$__count__quotes": {
              url: urlBase + "/GroupInvoices/:id/quotes/count",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.receipts() instead.
            "prototype$__get__receipts": {
              isArray: true,
              url: urlBase + "/GroupInvoices/:id/receipts",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.receipts.create() instead.
            "prototype$__create__receipts": {
              url: urlBase + "/GroupInvoices/:id/receipts",
              method: "POST",
            },

            // INTERNAL. Use GroupInvoice.receipts.destroyAll() instead.
            "prototype$__delete__receipts": {
              url: urlBase + "/GroupInvoices/:id/receipts",
              method: "DELETE",
            },

            // INTERNAL. Use GroupInvoice.receipts.count() instead.
            "prototype$__count__receipts": {
              url: urlBase + "/GroupInvoices/:id/receipts/count",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.receiptGroupInvoices() instead.
            "prototype$__get__receiptGroupInvoices": {
              isArray: true,
              url: urlBase + "/GroupInvoices/:id/receiptGroupInvoices",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.receiptGroupInvoices.create() instead.
            "prototype$__create__receiptGroupInvoices": {
              url: urlBase + "/GroupInvoices/:id/receiptGroupInvoices",
              method: "POST",
            },

            // INTERNAL. Use GroupInvoice.receiptGroupInvoices.destroyAll() instead.
            "prototype$__delete__receiptGroupInvoices": {
              url: urlBase + "/GroupInvoices/:id/receiptGroupInvoices",
              method: "DELETE",
            },

            // INTERNAL. Use GroupInvoice.receiptGroupInvoices.count() instead.
            "prototype$__count__receiptGroupInvoices": {
              url: urlBase + "/GroupInvoices/:id/receiptGroupInvoices/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#create
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/GroupInvoices",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#patchOrCreate
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/GroupInvoices",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#replaceOrCreate
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/GroupInvoices/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#upsertWithWhere
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/GroupInvoices/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#exists
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/GroupInvoices/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#findById
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/GroupInvoices/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#replaceById
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/GroupInvoices/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#find
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/GroupInvoices",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#findOne
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/GroupInvoices/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#updateAll
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/GroupInvoices/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#deleteById
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/GroupInvoices/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#count
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/GroupInvoices/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#prototype$patchAttributes
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/GroupInvoices/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#createChangeStream
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/GroupInvoices/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#addQuotes
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Adds a quote
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `groupInvoiceId` – `{number}` -
             *
             *  - `quoteIds` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `groupInvoice` – `{object=}` -
             */
            "addQuotes": {
              url: urlBase + "/GroupInvoices/addQuote",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#createMany
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/GroupInvoices",
              method: "POST",
            },

            // INTERNAL. Use Receipt.groupInvoice() instead.
            "::get::Receipt::groupInvoice": {
              url: urlBase + "/Receipts/:id/groupInvoice",
              method: "GET",
            },

            // INTERNAL. Use Receipt.groupInvoices.findById() instead.
            "::findById::Receipt::groupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/groupInvoices/:fk",
              method: "GET",
            },

            // INTERNAL. Use Receipt.groupInvoices.destroyById() instead.
            "::destroyById::Receipt::groupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/groupInvoices/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.groupInvoices.updateById() instead.
            "::updateById::Receipt::groupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/groupInvoices/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Receipt.groupInvoices.link() instead.
            "::link::Receipt::groupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/groupInvoices/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Receipt.groupInvoices.unlink() instead.
            "::unlink::Receipt::groupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/groupInvoices/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.groupInvoices.exists() instead.
            "::exists::Receipt::groupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/groupInvoices/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Receipt.groupInvoices() instead.
            "::get::Receipt::groupInvoices": {
              isArray: true,
              url: urlBase + "/Receipts/:id/groupInvoices",
              method: "GET",
            },

            // INTERNAL. Use Receipt.groupInvoices.create() instead.
            "::create::Receipt::groupInvoices": {
              url: urlBase + "/Receipts/:id/groupInvoices",
              method: "POST",
            },

            // INTERNAL. Use Receipt.groupInvoices.createMany() instead.
            "::createMany::Receipt::groupInvoices": {
              isArray: true,
              url: urlBase + "/Receipts/:id/groupInvoices",
              method: "POST",
            },

            // INTERNAL. Use Receipt.groupInvoices.destroyAll() instead.
            "::delete::Receipt::groupInvoices": {
              url: urlBase + "/Receipts/:id/groupInvoices",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.groupInvoices.count() instead.
            "::count::Receipt::groupInvoices": {
              url: urlBase + "/Receipts/:id/groupInvoices/count",
              method: "GET",
            },

            // INTERNAL. Use Quote.groupInvoice() instead.
            "::get::Quote::groupInvoice": {
              url: urlBase + "/Quotes/:id/groupInvoice",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#upsert
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#updateOrCreate
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#patchOrCreateWithWhere
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#update
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#destroyById
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#removeById
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#prototype$updateAttributes
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GroupInvoice` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.GroupInvoice#modelName
        * @propertyOf lbServices.GroupInvoice
        * @description
        * The name of the model represented by this $resource,
        * i.e. `GroupInvoice`.
        */
        R.modelName = "GroupInvoice";


            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#client
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Fetches belongsTo relation client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.client = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::GroupInvoice::client"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.GroupInvoice.quotes
     * @header lbServices.GroupInvoice.quotes
     * @object
     * @description
     *
     * The object `GroupInvoice.quotes` groups methods
     * manipulating `Quote` instances related to `GroupInvoice`.
     *
     * Call {@link lbServices.GroupInvoice#quotes GroupInvoice.quotes()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#quotes
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Queries quotes of GroupInvoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::get::GroupInvoice::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.quotes#count
             * @methodOf lbServices.GroupInvoice.quotes
             *
             * @description
             *
             * Counts quotes of GroupInvoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.quotes.count = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::count::GroupInvoice::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.quotes#create
             * @methodOf lbServices.GroupInvoice.quotes
             *
             * @description
             *
             * Creates a new instance in quotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.create = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::create::GroupInvoice::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.quotes#createMany
             * @methodOf lbServices.GroupInvoice.quotes
             *
             * @description
             *
             * Creates a new instance in quotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.createMany = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::createMany::GroupInvoice::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.quotes#destroyAll
             * @methodOf lbServices.GroupInvoice.quotes
             *
             * @description
             *
             * Deletes all quotes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.quotes.destroyAll = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::delete::GroupInvoice::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.quotes#destroyById
             * @methodOf lbServices.GroupInvoice.quotes
             *
             * @description
             *
             * Delete a related item by id for quotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for quotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.quotes.destroyById = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::destroyById::GroupInvoice::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.quotes#findById
             * @methodOf lbServices.GroupInvoice.quotes
             *
             * @description
             *
             * Find a related item by id for quotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for quotes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.findById = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::findById::GroupInvoice::quotes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.quotes#updateById
             * @methodOf lbServices.GroupInvoice.quotes
             *
             * @description
             *
             * Update a related item by id for quotes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `fk` – `{*}` - Foreign key for quotes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Quote` object.)
             * </em>
             */
        R.quotes.updateById = function() {
          var TargetResource = $injector.get("Quote");
          var action = TargetResource["::updateById::GroupInvoice::quotes"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.GroupInvoice.receipts
     * @header lbServices.GroupInvoice.receipts
     * @object
     * @description
     *
     * The object `GroupInvoice.receipts` groups methods
     * manipulating `Receipt` instances related to `GroupInvoice`.
     *
     * Call {@link lbServices.GroupInvoice#receipts GroupInvoice.receipts()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#receipts
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Queries receipts of GroupInvoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::get::GroupInvoice::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receipts#count
             * @methodOf lbServices.GroupInvoice.receipts
             *
             * @description
             *
             * Counts receipts of GroupInvoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.receipts.count = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::count::GroupInvoice::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receipts#create
             * @methodOf lbServices.GroupInvoice.receipts
             *
             * @description
             *
             * Creates a new instance in receipts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.create = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::create::GroupInvoice::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receipts#createMany
             * @methodOf lbServices.GroupInvoice.receipts
             *
             * @description
             *
             * Creates a new instance in receipts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.createMany = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::createMany::GroupInvoice::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receipts#destroyAll
             * @methodOf lbServices.GroupInvoice.receipts
             *
             * @description
             *
             * Deletes all receipts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receipts.destroyAll = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::delete::GroupInvoice::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receipts#destroyById
             * @methodOf lbServices.GroupInvoice.receipts
             *
             * @description
             *
             * Delete a related item by id for receipts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receipts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receipts.destroyById = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::destroyById::GroupInvoice::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receipts#exists
             * @methodOf lbServices.GroupInvoice.receipts
             *
             * @description
             *
             * Check the existence of receipts relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receipts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.exists = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::exists::GroupInvoice::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receipts#findById
             * @methodOf lbServices.GroupInvoice.receipts
             *
             * @description
             *
             * Find a related item by id for receipts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receipts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.findById = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::findById::GroupInvoice::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receipts#link
             * @methodOf lbServices.GroupInvoice.receipts
             *
             * @description
             *
             * Add a related item by id for receipts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `fk` – `{*}` - Foreign key for receipts
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.link = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::link::GroupInvoice::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receipts#unlink
             * @methodOf lbServices.GroupInvoice.receipts
             *
             * @description
             *
             * Remove the receipts relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receipts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receipts.unlink = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::unlink::GroupInvoice::receipts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receipts#updateById
             * @methodOf lbServices.GroupInvoice.receipts
             *
             * @description
             *
             * Update a related item by id for receipts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `fk` – `{*}` - Foreign key for receipts
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Receipt` object.)
             * </em>
             */
        R.receipts.updateById = function() {
          var TargetResource = $injector.get("Receipt");
          var action = TargetResource["::updateById::GroupInvoice::receipts"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.GroupInvoice.receiptGroupInvoices
     * @header lbServices.GroupInvoice.receiptGroupInvoices
     * @object
     * @description
     *
     * The object `GroupInvoice.receiptGroupInvoices` groups methods
     * manipulating `ReceiptGroupInvoice` instances related to `GroupInvoice`.
     *
     * Call {@link lbServices.GroupInvoice#receiptGroupInvoices GroupInvoice.receiptGroupInvoices()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice#receiptGroupInvoices
             * @methodOf lbServices.GroupInvoice
             *
             * @description
             *
             * Queries receiptGroupInvoices of GroupInvoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R.receiptGroupInvoices = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::get::GroupInvoice::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receiptGroupInvoices#count
             * @methodOf lbServices.GroupInvoice.receiptGroupInvoices
             *
             * @description
             *
             * Counts receiptGroupInvoices of GroupInvoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.receiptGroupInvoices.count = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::count::GroupInvoice::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receiptGroupInvoices#create
             * @methodOf lbServices.GroupInvoice.receiptGroupInvoices
             *
             * @description
             *
             * Creates a new instance in receiptGroupInvoices of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R.receiptGroupInvoices.create = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::create::GroupInvoice::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receiptGroupInvoices#createMany
             * @methodOf lbServices.GroupInvoice.receiptGroupInvoices
             *
             * @description
             *
             * Creates a new instance in receiptGroupInvoices of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R.receiptGroupInvoices.createMany = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::createMany::GroupInvoice::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receiptGroupInvoices#destroyAll
             * @methodOf lbServices.GroupInvoice.receiptGroupInvoices
             *
             * @description
             *
             * Deletes all receiptGroupInvoices of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receiptGroupInvoices.destroyAll = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::delete::GroupInvoice::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receiptGroupInvoices#destroyById
             * @methodOf lbServices.GroupInvoice.receiptGroupInvoices
             *
             * @description
             *
             * Delete a related item by id for receiptGroupInvoices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receiptGroupInvoices
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.receiptGroupInvoices.destroyById = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::destroyById::GroupInvoice::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receiptGroupInvoices#findById
             * @methodOf lbServices.GroupInvoice.receiptGroupInvoices
             *
             * @description
             *
             * Find a related item by id for receiptGroupInvoices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for receiptGroupInvoices
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R.receiptGroupInvoices.findById = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::findById::GroupInvoice::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GroupInvoice.receiptGroupInvoices#updateById
             * @methodOf lbServices.GroupInvoice.receiptGroupInvoices
             *
             * @description
             *
             * Update a related item by id for receiptGroupInvoices.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GroupInvoice id
             *
             *  - `fk` – `{*}` - Foreign key for receiptGroupInvoices
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R.receiptGroupInvoices.updateById = function() {
          var TargetResource = $injector.get("ReceiptGroupInvoice");
          var action = TargetResource["::updateById::GroupInvoice::receiptGroupInvoices"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.CashboxTransfer
 * @header lbServices.CashboxTransfer
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `CashboxTransfer` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "CashboxTransfer",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/CashboxTransfers/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransfer#findById
             * @methodOf lbServices.CashboxTransfer
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CashboxTransfer` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/CashboxTransfers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransfer#count
             * @methodOf lbServices.CashboxTransfer
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/CashboxTransfers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransfer#createNew
             * @methodOf lbServices.CashboxTransfer
             *
             * @description
             *
             * Creates a new cashbox transfer
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `opts` – `{object}` - Transfer data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `cashboxTransfer` – `{object=}` - CashboxTransfer recently created
             */
            "createNew": {
              url: urlBase + "/CashboxTransfers/createNew",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransfer#customFind
             * @methodOf lbServices.CashboxTransfer
             *
             * @description
             *
             * Custom find
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Results
             */
            "customFind": {
              isArray: true,
              url: urlBase + "/CashboxTransfers/customFind",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransfer#count
             * @methodOf lbServices.CashboxTransfer
             *
             * @description
             *
             * Custom count
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Filter
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` - Count result
             */
            "count": {
              url: urlBase + "/CashboxTransfers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CashboxTransfer#void
             * @methodOf lbServices.CashboxTransfer
             *
             * @description
             *
             * Voids a CashboxTransfer
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` - Cashbox transfer id
             *
             *  - `reason` – `{string}` - Voidance reason
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `cashboxTransfer` – `{object=}` -
             */
            "void": {
              url: urlBase + "/CashboxTransfers/void",
              method: "POST",
            },

            // INTERNAL. Use Collection.cashboxTransfers.findById() instead.
            "::findById::Collection::cashboxTransfers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/cashboxTransfers/:fk",
              method: "GET",
            },

            // INTERNAL. Use Collection.cashboxTransfers.destroyById() instead.
            "::destroyById::Collection::cashboxTransfers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/cashboxTransfers/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.cashboxTransfers.updateById() instead.
            "::updateById::Collection::cashboxTransfers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Collections/:id/cashboxTransfers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Collection.cashboxTransfers() instead.
            "::get::Collection::cashboxTransfers": {
              isArray: true,
              url: urlBase + "/Collections/:id/cashboxTransfers",
              method: "GET",
            },

            // INTERNAL. Use Collection.cashboxTransfers.create() instead.
            "::create::Collection::cashboxTransfers": {
              url: urlBase + "/Collections/:id/cashboxTransfers",
              method: "POST",
            },

            // INTERNAL. Use Collection.cashboxTransfers.createMany() instead.
            "::createMany::Collection::cashboxTransfers": {
              isArray: true,
              url: urlBase + "/Collections/:id/cashboxTransfers",
              method: "POST",
            },

            // INTERNAL. Use Collection.cashboxTransfers.destroyAll() instead.
            "::delete::Collection::cashboxTransfers": {
              url: urlBase + "/Collections/:id/cashboxTransfers",
              method: "DELETE",
            },

            // INTERNAL. Use Collection.cashboxTransfers.count() instead.
            "::count::Collection::cashboxTransfers": {
              url: urlBase + "/Collections/:id/cashboxTransfers/count",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.CashboxTransfer#modelName
        * @propertyOf lbServices.CashboxTransfer
        * @description
        * The name of the model represented by this $resource,
        * i.e. `CashboxTransfer`.
        */
        R.modelName = "CashboxTransfer";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ReceiptGroupInvoice
 * @header lbServices.ReceiptGroupInvoice
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ReceiptGroupInvoice` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ReceiptGroupInvoice",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ReceiptGroupInvoices/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#create
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/ReceiptGroupInvoices",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#patchOrCreate
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/ReceiptGroupInvoices",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#replaceOrCreate
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/ReceiptGroupInvoices/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#upsertWithWhere
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/ReceiptGroupInvoices/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#exists
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/ReceiptGroupInvoices/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#findById
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/ReceiptGroupInvoices/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#replaceById
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/ReceiptGroupInvoices/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#find
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/ReceiptGroupInvoices",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#findOne
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/ReceiptGroupInvoices/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#updateAll
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/ReceiptGroupInvoices/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#deleteById
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/ReceiptGroupInvoices/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#count
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/ReceiptGroupInvoices/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#prototype$patchAttributes
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ReceiptGroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/ReceiptGroupInvoices/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#createChangeStream
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/ReceiptGroupInvoices/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#createMany
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/ReceiptGroupInvoices",
              method: "POST",
            },

            // INTERNAL. Use Receipt.receiptGroupInvoices.findById() instead.
            "::findById::Receipt::receiptGroupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/receiptGroupInvoices/:fk",
              method: "GET",
            },

            // INTERNAL. Use Receipt.receiptGroupInvoices.destroyById() instead.
            "::destroyById::Receipt::receiptGroupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/receiptGroupInvoices/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.receiptGroupInvoices.updateById() instead.
            "::updateById::Receipt::receiptGroupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Receipts/:id/receiptGroupInvoices/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Receipt.receiptGroupInvoices() instead.
            "::get::Receipt::receiptGroupInvoices": {
              isArray: true,
              url: urlBase + "/Receipts/:id/receiptGroupInvoices",
              method: "GET",
            },

            // INTERNAL. Use Receipt.receiptGroupInvoices.create() instead.
            "::create::Receipt::receiptGroupInvoices": {
              url: urlBase + "/Receipts/:id/receiptGroupInvoices",
              method: "POST",
            },

            // INTERNAL. Use Receipt.receiptGroupInvoices.createMany() instead.
            "::createMany::Receipt::receiptGroupInvoices": {
              isArray: true,
              url: urlBase + "/Receipts/:id/receiptGroupInvoices",
              method: "POST",
            },

            // INTERNAL. Use Receipt.receiptGroupInvoices.destroyAll() instead.
            "::delete::Receipt::receiptGroupInvoices": {
              url: urlBase + "/Receipts/:id/receiptGroupInvoices",
              method: "DELETE",
            },

            // INTERNAL. Use Receipt.receiptGroupInvoices.count() instead.
            "::count::Receipt::receiptGroupInvoices": {
              url: urlBase + "/Receipts/:id/receiptGroupInvoices/count",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.receiptGroupInvoices.findById() instead.
            "::findById::GroupInvoice::receiptGroupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receiptGroupInvoices/:fk",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.receiptGroupInvoices.destroyById() instead.
            "::destroyById::GroupInvoice::receiptGroupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receiptGroupInvoices/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use GroupInvoice.receiptGroupInvoices.updateById() instead.
            "::updateById::GroupInvoice::receiptGroupInvoices": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/GroupInvoices/:id/receiptGroupInvoices/:fk",
              method: "PUT",
            },

            // INTERNAL. Use GroupInvoice.receiptGroupInvoices() instead.
            "::get::GroupInvoice::receiptGroupInvoices": {
              isArray: true,
              url: urlBase + "/GroupInvoices/:id/receiptGroupInvoices",
              method: "GET",
            },

            // INTERNAL. Use GroupInvoice.receiptGroupInvoices.create() instead.
            "::create::GroupInvoice::receiptGroupInvoices": {
              url: urlBase + "/GroupInvoices/:id/receiptGroupInvoices",
              method: "POST",
            },

            // INTERNAL. Use GroupInvoice.receiptGroupInvoices.createMany() instead.
            "::createMany::GroupInvoice::receiptGroupInvoices": {
              isArray: true,
              url: urlBase + "/GroupInvoices/:id/receiptGroupInvoices",
              method: "POST",
            },

            // INTERNAL. Use GroupInvoice.receiptGroupInvoices.destroyAll() instead.
            "::delete::GroupInvoice::receiptGroupInvoices": {
              url: urlBase + "/GroupInvoices/:id/receiptGroupInvoices",
              method: "DELETE",
            },

            // INTERNAL. Use GroupInvoice.receiptGroupInvoices.count() instead.
            "::count::GroupInvoice::receiptGroupInvoices": {
              url: urlBase + "/GroupInvoices/:id/receiptGroupInvoices/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#upsert
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#updateOrCreate
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#patchOrCreateWithWhere
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#update
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#destroyById
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#removeById
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ReceiptGroupInvoice#prototype$updateAttributes
             * @methodOf lbServices.ReceiptGroupInvoice
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ReceiptGroupInvoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReceiptGroupInvoice` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ReceiptGroupInvoice#modelName
        * @propertyOf lbServices.ReceiptGroupInvoice
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ReceiptGroupInvoice`.
        */
        R.modelName = "ReceiptGroupInvoice";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TaxWithholding
 * @header lbServices.TaxWithholding
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TaxWithholding` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TaxWithholding",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/TaxWithholdings/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TaxWithholding.paymentItem() instead.
            "prototype$__get__paymentItem": {
              url: urlBase + "/TaxWithholdings/:id/paymentItem",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#create
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/TaxWithholdings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#patchOrCreate
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/TaxWithholdings",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#replaceOrCreate
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/TaxWithholdings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#upsertWithWhere
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/TaxWithholdings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#exists
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/TaxWithholdings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#findById
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/TaxWithholdings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#replaceById
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/TaxWithholdings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#find
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/TaxWithholdings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#findOne
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/TaxWithholdings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#updateAll
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/TaxWithholdings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#deleteById
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/TaxWithholdings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#count
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/TaxWithholdings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#prototype$patchAttributes
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TaxWithholding id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/TaxWithholdings/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#createChangeStream
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/TaxWithholdings/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#createMany
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/TaxWithholdings",
              method: "POST",
            },

            // INTERNAL. Use PaymentItem.taxWithholding() instead.
            "::get::PaymentItem::taxWithholding": {
              url: urlBase + "/PaymentItems/:id/taxWithholding",
              method: "GET",
            },

            // INTERNAL. Use PaymentItem.taxWithholding.create() instead.
            "::create::PaymentItem::taxWithholding": {
              url: urlBase + "/PaymentItems/:id/taxWithholding",
              method: "POST",
            },

            // INTERNAL. Use PaymentItem.taxWithholding.createMany() instead.
            "::createMany::PaymentItem::taxWithholding": {
              isArray: true,
              url: urlBase + "/PaymentItems/:id/taxWithholding",
              method: "POST",
            },

            // INTERNAL. Use PaymentItem.taxWithholding.update() instead.
            "::update::PaymentItem::taxWithholding": {
              url: urlBase + "/PaymentItems/:id/taxWithholding",
              method: "PUT",
            },

            // INTERNAL. Use PaymentItem.taxWithholding.destroy() instead.
            "::destroy::PaymentItem::taxWithholding": {
              url: urlBase + "/PaymentItems/:id/taxWithholding",
              method: "DELETE",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#upsert
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#updateOrCreate
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#patchOrCreateWithWhere
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#update
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#destroyById
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#removeById
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#prototype$updateAttributes
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TaxWithholding id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TaxWithholding` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TaxWithholding#modelName
        * @propertyOf lbServices.TaxWithholding
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TaxWithholding`.
        */
        R.modelName = "TaxWithholding";


            /**
             * @ngdoc method
             * @name lbServices.TaxWithholding#paymentItem
             * @methodOf lbServices.TaxWithholding
             *
             * @description
             *
             * Fetches belongsTo relation paymentItem.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TaxWithholding id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PaymentItem` object.)
             * </em>
             */
        R.paymentItem = function() {
          var TargetResource = $injector.get("PaymentItem");
          var action = TargetResource["::get::TaxWithholding::paymentItem"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.StatesTemplate
 * @header lbServices.StatesTemplate
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `StatesTemplate` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "StatesTemplate",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/StatesTemplates/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use StatesTemplate.operationTypes.findById() instead.
            "prototype$__findById__operationTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/StatesTemplates/:id/operationTypes/:fk",
              method: "GET",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.destroyById() instead.
            "prototype$__destroyById__operationTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/StatesTemplates/:id/operationTypes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.updateById() instead.
            "prototype$__updateById__operationTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/StatesTemplates/:id/operationTypes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.link() instead.
            "prototype$__link__operationTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/StatesTemplates/:id/operationTypes/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.unlink() instead.
            "prototype$__unlink__operationTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/StatesTemplates/:id/operationTypes/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.exists() instead.
            "prototype$__exists__operationTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/StatesTemplates/:id/operationTypes/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use StatesTemplate.operationTypes() instead.
            "prototype$__get__operationTypes": {
              isArray: true,
              url: urlBase + "/StatesTemplates/:id/operationTypes",
              method: "GET",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.create() instead.
            "prototype$__create__operationTypes": {
              url: urlBase + "/StatesTemplates/:id/operationTypes",
              method: "POST",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.destroyAll() instead.
            "prototype$__delete__operationTypes": {
              url: urlBase + "/StatesTemplates/:id/operationTypes",
              method: "DELETE",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.count() instead.
            "prototype$__count__operationTypes": {
              url: urlBase + "/StatesTemplates/:id/operationTypes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#create
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/StatesTemplates",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#patchOrCreate
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/StatesTemplates",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#replaceOrCreate
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/StatesTemplates/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#upsertWithWhere
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/StatesTemplates/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#exists
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/StatesTemplates/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#findById
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/StatesTemplates/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#replaceById
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/StatesTemplates/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#find
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/StatesTemplates",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#findOne
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/StatesTemplates/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#updateAll
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/StatesTemplates/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#deleteById
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/StatesTemplates/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#count
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/StatesTemplates/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#prototype$patchAttributes
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatesTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/StatesTemplates/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#createChangeStream
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/StatesTemplates/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#createMany
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/StatesTemplates",
              method: "POST",
            },

            // INTERNAL. Use OperationType.statesTemplates.findById() instead.
            "::findById::OperationType::statesTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationTypes/:id/statesTemplates/:fk",
              method: "GET",
            },

            // INTERNAL. Use OperationType.statesTemplates.destroyById() instead.
            "::destroyById::OperationType::statesTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationTypes/:id/statesTemplates/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OperationType.statesTemplates.updateById() instead.
            "::updateById::OperationType::statesTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationTypes/:id/statesTemplates/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OperationType.statesTemplates.link() instead.
            "::link::OperationType::statesTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationTypes/:id/statesTemplates/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OperationType.statesTemplates.unlink() instead.
            "::unlink::OperationType::statesTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationTypes/:id/statesTemplates/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OperationType.statesTemplates.exists() instead.
            "::exists::OperationType::statesTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationTypes/:id/statesTemplates/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use OperationType.statesTemplates() instead.
            "::get::OperationType::statesTemplates": {
              isArray: true,
              url: urlBase + "/OperationTypes/:id/statesTemplates",
              method: "GET",
            },

            // INTERNAL. Use OperationType.statesTemplates.create() instead.
            "::create::OperationType::statesTemplates": {
              url: urlBase + "/OperationTypes/:id/statesTemplates",
              method: "POST",
            },

            // INTERNAL. Use OperationType.statesTemplates.createMany() instead.
            "::createMany::OperationType::statesTemplates": {
              isArray: true,
              url: urlBase + "/OperationTypes/:id/statesTemplates",
              method: "POST",
            },

            // INTERNAL. Use OperationType.statesTemplates.destroyAll() instead.
            "::delete::OperationType::statesTemplates": {
              url: urlBase + "/OperationTypes/:id/statesTemplates",
              method: "DELETE",
            },

            // INTERNAL. Use OperationType.statesTemplates.count() instead.
            "::count::OperationType::statesTemplates": {
              url: urlBase + "/OperationTypes/:id/statesTemplates/count",
              method: "GET",
            },

            // INTERNAL. Use OperationTypeStatesTemplate.statesTemplate() instead.
            "::get::OperationTypeStatesTemplate::statesTemplate": {
              url: urlBase + "/OperationTypeStatesTemplates/:id/statesTemplate",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#upsert
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#updateOrCreate
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#patchOrCreateWithWhere
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#update
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#destroyById
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#removeById
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#prototype$updateAttributes
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatesTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.StatesTemplate#modelName
        * @propertyOf lbServices.StatesTemplate
        * @description
        * The name of the model represented by this $resource,
        * i.e. `StatesTemplate`.
        */
        R.modelName = "StatesTemplate";

    /**
     * @ngdoc object
     * @name lbServices.StatesTemplate.operationTypes
     * @header lbServices.StatesTemplate.operationTypes
     * @object
     * @description
     *
     * The object `StatesTemplate.operationTypes` groups methods
     * manipulating `OperationType` instances related to `StatesTemplate`.
     *
     * Call {@link lbServices.StatesTemplate#operationTypes StatesTemplate.operationTypes()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate#operationTypes
             * @methodOf lbServices.StatesTemplate
             *
             * @description
             *
             * Queries operationTypes of StatesTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatesTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
        R.operationTypes = function() {
          var TargetResource = $injector.get("OperationType");
          var action = TargetResource["::get::StatesTemplate::operationTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate.operationTypes#count
             * @methodOf lbServices.StatesTemplate.operationTypes
             *
             * @description
             *
             * Counts operationTypes of StatesTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatesTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.operationTypes.count = function() {
          var TargetResource = $injector.get("OperationType");
          var action = TargetResource["::count::StatesTemplate::operationTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate.operationTypes#create
             * @methodOf lbServices.StatesTemplate.operationTypes
             *
             * @description
             *
             * Creates a new instance in operationTypes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatesTemplate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
        R.operationTypes.create = function() {
          var TargetResource = $injector.get("OperationType");
          var action = TargetResource["::create::StatesTemplate::operationTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate.operationTypes#createMany
             * @methodOf lbServices.StatesTemplate.operationTypes
             *
             * @description
             *
             * Creates a new instance in operationTypes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatesTemplate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
        R.operationTypes.createMany = function() {
          var TargetResource = $injector.get("OperationType");
          var action = TargetResource["::createMany::StatesTemplate::operationTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate.operationTypes#destroyAll
             * @methodOf lbServices.StatesTemplate.operationTypes
             *
             * @description
             *
             * Deletes all operationTypes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatesTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.operationTypes.destroyAll = function() {
          var TargetResource = $injector.get("OperationType");
          var action = TargetResource["::delete::StatesTemplate::operationTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate.operationTypes#destroyById
             * @methodOf lbServices.StatesTemplate.operationTypes
             *
             * @description
             *
             * Delete a related item by id for operationTypes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatesTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operationTypes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.operationTypes.destroyById = function() {
          var TargetResource = $injector.get("OperationType");
          var action = TargetResource["::destroyById::StatesTemplate::operationTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate.operationTypes#exists
             * @methodOf lbServices.StatesTemplate.operationTypes
             *
             * @description
             *
             * Check the existence of operationTypes relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatesTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operationTypes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
        R.operationTypes.exists = function() {
          var TargetResource = $injector.get("OperationType");
          var action = TargetResource["::exists::StatesTemplate::operationTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate.operationTypes#findById
             * @methodOf lbServices.StatesTemplate.operationTypes
             *
             * @description
             *
             * Find a related item by id for operationTypes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatesTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operationTypes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
        R.operationTypes.findById = function() {
          var TargetResource = $injector.get("OperationType");
          var action = TargetResource["::findById::StatesTemplate::operationTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate.operationTypes#link
             * @methodOf lbServices.StatesTemplate.operationTypes
             *
             * @description
             *
             * Add a related item by id for operationTypes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatesTemplate id
             *
             *  - `fk` – `{*}` - Foreign key for operationTypes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
        R.operationTypes.link = function() {
          var TargetResource = $injector.get("OperationType");
          var action = TargetResource["::link::StatesTemplate::operationTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate.operationTypes#unlink
             * @methodOf lbServices.StatesTemplate.operationTypes
             *
             * @description
             *
             * Remove the operationTypes relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatesTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operationTypes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.operationTypes.unlink = function() {
          var TargetResource = $injector.get("OperationType");
          var action = TargetResource["::unlink::StatesTemplate::operationTypes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.StatesTemplate.operationTypes#updateById
             * @methodOf lbServices.StatesTemplate.operationTypes
             *
             * @description
             *
             * Update a related item by id for operationTypes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatesTemplate id
             *
             *  - `fk` – `{*}` - Foreign key for operationTypes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
        R.operationTypes.updateById = function() {
          var TargetResource = $injector.get("OperationType");
          var action = TargetResource["::updateById::StatesTemplate::operationTypes"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OperationProcedure
 * @header lbServices.OperationProcedure
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OperationProcedure` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OperationProcedure",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/OperationProcedures/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OperationProcedure.operationProcedureHistories.findById() instead.
            "prototype$__findById__operationProcedureHistories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationProcedures/:id/operationProcedureHistories/:fk",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedure.operationProcedureHistories.destroyById() instead.
            "prototype$__destroyById__operationProcedureHistories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationProcedures/:id/operationProcedureHistories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OperationProcedure.operationProcedureHistories.updateById() instead.
            "prototype$__updateById__operationProcedureHistories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationProcedures/:id/operationProcedureHistories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OperationProcedure.operation() instead.
            "prototype$__get__operation": {
              url: urlBase + "/OperationProcedures/:id/operation",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedure.currentTask() instead.
            "prototype$__get__currentTask": {
              url: urlBase + "/OperationProcedures/:id/currentTask",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedure.tasks.findById() instead.
            "prototype$__findById__tasks": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationProcedures/:id/tasks/:fk",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedure.tasks.destroyById() instead.
            "prototype$__destroyById__tasks": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationProcedures/:id/tasks/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OperationProcedure.tasks.updateById() instead.
            "prototype$__updateById__tasks": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationProcedures/:id/tasks/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OperationProcedure.operationProcedureHistories() instead.
            "prototype$__get__operationProcedureHistories": {
              isArray: true,
              url: urlBase + "/OperationProcedures/:id/operationProcedureHistories",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedure.operationProcedureHistories.create() instead.
            "prototype$__create__operationProcedureHistories": {
              url: urlBase + "/OperationProcedures/:id/operationProcedureHistories",
              method: "POST",
            },

            // INTERNAL. Use OperationProcedure.operationProcedureHistories.destroyAll() instead.
            "prototype$__delete__operationProcedureHistories": {
              url: urlBase + "/OperationProcedures/:id/operationProcedureHistories",
              method: "DELETE",
            },

            // INTERNAL. Use OperationProcedure.operationProcedureHistories.count() instead.
            "prototype$__count__operationProcedureHistories": {
              url: urlBase + "/OperationProcedures/:id/operationProcedureHistories/count",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedure.tasks() instead.
            "prototype$__get__tasks": {
              isArray: true,
              url: urlBase + "/OperationProcedures/:id/tasks",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedure.tasks.create() instead.
            "prototype$__create__tasks": {
              url: urlBase + "/OperationProcedures/:id/tasks",
              method: "POST",
            },

            // INTERNAL. Use OperationProcedure.tasks.destroyAll() instead.
            "prototype$__delete__tasks": {
              url: urlBase + "/OperationProcedures/:id/tasks",
              method: "DELETE",
            },

            // INTERNAL. Use OperationProcedure.tasks.count() instead.
            "prototype$__count__tasks": {
              url: urlBase + "/OperationProcedures/:id/tasks/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#create
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/OperationProcedures",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#patchOrCreate
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/OperationProcedures",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#replaceOrCreate
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/OperationProcedures/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#upsertWithWhere
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/OperationProcedures/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#exists
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/OperationProcedures/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#findById
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/OperationProcedures/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#replaceById
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/OperationProcedures/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#find
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/OperationProcedures",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#findOne
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/OperationProcedures/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#updateAll
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/OperationProcedures/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#deleteById
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/OperationProcedures/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#count
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/OperationProcedures/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#prototype$patchAttributes
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/OperationProcedures/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#createChangeStream
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/OperationProcedures/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#remoteNext
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Moves procedure to next state
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `opId` – `{number}` -
             *
             *  - `completedAt` – `{date}` - New completed date
             *
             *  - `comments` – `{string=}` - Comments to be added to the history item to be generated
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `operationProcedure` – `{object=}` -
             */
            "remoteNext": {
              url: urlBase + "/OperationProcedures/next",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#remoteStay
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Stays on the same state, adds OPH
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `opId` – `{number}` -
             *
             *  - `comments` – `{string=}` - Comments to be added to the history item to be generated
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `operationProcedure` – `{object=}` -
             */
            "remoteStay": {
              url: urlBase + "/OperationProcedures/stay",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#remotePostpone
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Postpones due date, adds OPH
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `opId` – `{number}` -
             *
             *  - `dueAt` – `{date}` - New due date
             *
             *  - `comments` – `{string=}` - Comments to be added to the history item to be generated
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `operationProcedure` – `{object=}` -
             */
            "remotePostpone": {
              url: urlBase + "/OperationProcedures/postpone",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#remotePrev
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Moves procedure to prev state
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `opId` – `{number}` -
             *
             *  - `comments` – `{string=}` - Comments to be added to the history item to be generated
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `operationProcedure` – `{object=}` -
             */
            "remotePrev": {
              url: urlBase + "/OperationProcedures/prev",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#remoteDeactivate
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Deactivates procedure
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `opId` – `{number}` -
             *
             *  - `comments` – `{string=}` - Comments to be added to the history item to be generated
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `operationProcedure` – `{object=}` -
             */
            "remoteDeactivate": {
              url: urlBase + "/OperationProcedures/deactivate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#remoteReactivate
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Reactivates previously deactivated procedure
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `opId` – `{number}` -
             *
             *  - `comments` – `{string=}` - Comments to be added to the history item to be generated
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `operationProcedure` – `{object=}` -
             */
            "remoteReactivate": {
              url: urlBase + "/OperationProcedures/reactivate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#createMany
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/OperationProcedures",
              method: "POST",
            },

            // INTERNAL. Use OperationProcedureHistory.operationProcedure() instead.
            "::get::OperationProcedureHistory::operationProcedure": {
              url: urlBase + "/OperationProcedureHistories/:id/operationProcedure",
              method: "GET",
            },

            // INTERNAL. Use Operation.operationProcedures.findById() instead.
            "::findById::Operation::operationProcedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Operations/:id/operationProcedures/:fk",
              method: "GET",
            },

            // INTERNAL. Use Operation.operationProcedures.destroyById() instead.
            "::destroyById::Operation::operationProcedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Operations/:id/operationProcedures/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Operation.operationProcedures.updateById() instead.
            "::updateById::Operation::operationProcedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Operations/:id/operationProcedures/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Operation.operationProcedures() instead.
            "::get::Operation::operationProcedures": {
              isArray: true,
              url: urlBase + "/Operations/:id/operationProcedures",
              method: "GET",
            },

            // INTERNAL. Use Operation.operationProcedures.create() instead.
            "::create::Operation::operationProcedures": {
              url: urlBase + "/Operations/:id/operationProcedures",
              method: "POST",
            },

            // INTERNAL. Use Operation.operationProcedures.createMany() instead.
            "::createMany::Operation::operationProcedures": {
              isArray: true,
              url: urlBase + "/Operations/:id/operationProcedures",
              method: "POST",
            },

            // INTERNAL. Use Operation.operationProcedures.destroyAll() instead.
            "::delete::Operation::operationProcedures": {
              url: urlBase + "/Operations/:id/operationProcedures",
              method: "DELETE",
            },

            // INTERNAL. Use Operation.operationProcedures.count() instead.
            "::count::Operation::operationProcedures": {
              url: urlBase + "/Operations/:id/operationProcedures/count",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedureTask.operationProcedure() instead.
            "::get::OperationProcedureTask::operationProcedure": {
              url: urlBase + "/OperationProcedureTasks/:id/operationProcedure",
              method: "GET",
            },

            // INTERNAL. Use Assignation.operationProcedure() instead.
            "::get::Assignation::operationProcedure": {
              url: urlBase + "/Assignations/:id/operationProcedure",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#upsert
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#updateOrCreate
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#patchOrCreateWithWhere
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#update
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#destroyById
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#removeById
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#prototype$updateAttributes
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OperationProcedure#modelName
        * @propertyOf lbServices.OperationProcedure
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OperationProcedure`.
        */
        R.modelName = "OperationProcedure";

    /**
     * @ngdoc object
     * @name lbServices.OperationProcedure.operationProcedureHistories
     * @header lbServices.OperationProcedure.operationProcedureHistories
     * @object
     * @description
     *
     * The object `OperationProcedure.operationProcedureHistories` groups methods
     * manipulating `OperationProcedureHistory` instances related to `OperationProcedure`.
     *
     * Call {@link lbServices.OperationProcedure#operationProcedureHistories OperationProcedure.operationProcedureHistories()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#operationProcedureHistories
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Queries operationProcedureHistories of OperationProcedure.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
        R.operationProcedureHistories = function() {
          var TargetResource = $injector.get("OperationProcedureHistory");
          var action = TargetResource["::get::OperationProcedure::operationProcedureHistories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure.operationProcedureHistories#count
             * @methodOf lbServices.OperationProcedure.operationProcedureHistories
             *
             * @description
             *
             * Counts operationProcedureHistories of OperationProcedure.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.operationProcedureHistories.count = function() {
          var TargetResource = $injector.get("OperationProcedureHistory");
          var action = TargetResource["::count::OperationProcedure::operationProcedureHistories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure.operationProcedureHistories#create
             * @methodOf lbServices.OperationProcedure.operationProcedureHistories
             *
             * @description
             *
             * Creates a new instance in operationProcedureHistories of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
        R.operationProcedureHistories.create = function() {
          var TargetResource = $injector.get("OperationProcedureHistory");
          var action = TargetResource["::create::OperationProcedure::operationProcedureHistories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure.operationProcedureHistories#createMany
             * @methodOf lbServices.OperationProcedure.operationProcedureHistories
             *
             * @description
             *
             * Creates a new instance in operationProcedureHistories of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
        R.operationProcedureHistories.createMany = function() {
          var TargetResource = $injector.get("OperationProcedureHistory");
          var action = TargetResource["::createMany::OperationProcedure::operationProcedureHistories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure.operationProcedureHistories#destroyAll
             * @methodOf lbServices.OperationProcedure.operationProcedureHistories
             *
             * @description
             *
             * Deletes all operationProcedureHistories of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.operationProcedureHistories.destroyAll = function() {
          var TargetResource = $injector.get("OperationProcedureHistory");
          var action = TargetResource["::delete::OperationProcedure::operationProcedureHistories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure.operationProcedureHistories#destroyById
             * @methodOf lbServices.OperationProcedure.operationProcedureHistories
             *
             * @description
             *
             * Delete a related item by id for operationProcedureHistories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operationProcedureHistories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.operationProcedureHistories.destroyById = function() {
          var TargetResource = $injector.get("OperationProcedureHistory");
          var action = TargetResource["::destroyById::OperationProcedure::operationProcedureHistories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure.operationProcedureHistories#findById
             * @methodOf lbServices.OperationProcedure.operationProcedureHistories
             *
             * @description
             *
             * Find a related item by id for operationProcedureHistories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operationProcedureHistories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
        R.operationProcedureHistories.findById = function() {
          var TargetResource = $injector.get("OperationProcedureHistory");
          var action = TargetResource["::findById::OperationProcedure::operationProcedureHistories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure.operationProcedureHistories#updateById
             * @methodOf lbServices.OperationProcedure.operationProcedureHistories
             *
             * @description
             *
             * Update a related item by id for operationProcedureHistories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `fk` – `{*}` - Foreign key for operationProcedureHistories
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
        R.operationProcedureHistories.updateById = function() {
          var TargetResource = $injector.get("OperationProcedureHistory");
          var action = TargetResource["::updateById::OperationProcedure::operationProcedureHistories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#operation
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Fetches belongsTo relation operation.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
        R.operation = function() {
          var TargetResource = $injector.get("Operation");
          var action = TargetResource["::get::OperationProcedure::operation"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#currentTask
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Fetches belongsTo relation currentTask.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
        R.currentTask = function() {
          var TargetResource = $injector.get("OperationProcedureTask");
          var action = TargetResource["::get::OperationProcedure::currentTask"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OperationProcedure.tasks
     * @header lbServices.OperationProcedure.tasks
     * @object
     * @description
     *
     * The object `OperationProcedure.tasks` groups methods
     * manipulating `OperationProcedureTask` instances related to `OperationProcedure`.
     *
     * Call {@link lbServices.OperationProcedure#tasks OperationProcedure.tasks()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure#tasks
             * @methodOf lbServices.OperationProcedure
             *
             * @description
             *
             * Queries tasks of OperationProcedure.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
        R.tasks = function() {
          var TargetResource = $injector.get("OperationProcedureTask");
          var action = TargetResource["::get::OperationProcedure::tasks"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure.tasks#count
             * @methodOf lbServices.OperationProcedure.tasks
             *
             * @description
             *
             * Counts tasks of OperationProcedure.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.tasks.count = function() {
          var TargetResource = $injector.get("OperationProcedureTask");
          var action = TargetResource["::count::OperationProcedure::tasks"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure.tasks#create
             * @methodOf lbServices.OperationProcedure.tasks
             *
             * @description
             *
             * Creates a new instance in tasks of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
        R.tasks.create = function() {
          var TargetResource = $injector.get("OperationProcedureTask");
          var action = TargetResource["::create::OperationProcedure::tasks"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure.tasks#createMany
             * @methodOf lbServices.OperationProcedure.tasks
             *
             * @description
             *
             * Creates a new instance in tasks of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
        R.tasks.createMany = function() {
          var TargetResource = $injector.get("OperationProcedureTask");
          var action = TargetResource["::createMany::OperationProcedure::tasks"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure.tasks#destroyAll
             * @methodOf lbServices.OperationProcedure.tasks
             *
             * @description
             *
             * Deletes all tasks of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tasks.destroyAll = function() {
          var TargetResource = $injector.get("OperationProcedureTask");
          var action = TargetResource["::delete::OperationProcedure::tasks"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure.tasks#destroyById
             * @methodOf lbServices.OperationProcedure.tasks
             *
             * @description
             *
             * Delete a related item by id for tasks.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for tasks
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tasks.destroyById = function() {
          var TargetResource = $injector.get("OperationProcedureTask");
          var action = TargetResource["::destroyById::OperationProcedure::tasks"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure.tasks#findById
             * @methodOf lbServices.OperationProcedure.tasks
             *
             * @description
             *
             * Find a related item by id for tasks.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for tasks
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
        R.tasks.findById = function() {
          var TargetResource = $injector.get("OperationProcedureTask");
          var action = TargetResource["::findById::OperationProcedure::tasks"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedure.tasks#updateById
             * @methodOf lbServices.OperationProcedure.tasks
             *
             * @description
             *
             * Update a related item by id for tasks.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedure id
             *
             *  - `fk` – `{*}` - Foreign key for tasks
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
        R.tasks.updateById = function() {
          var TargetResource = $injector.get("OperationProcedureTask");
          var action = TargetResource["::updateById::OperationProcedure::tasks"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OperationProcedureHistory
 * @header lbServices.OperationProcedureHistory
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OperationProcedureHistory` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OperationProcedureHistory",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/OperationProcedureHistories/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OperationProcedureHistory.operationProcedure() instead.
            "prototype$__get__operationProcedure": {
              url: urlBase + "/OperationProcedureHistories/:id/operationProcedure",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedureHistory.updatedByUser() instead.
            "prototype$__get__updatedByUser": {
              url: urlBase + "/OperationProcedureHistories/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedureHistory.createdByUser() instead.
            "prototype$__get__createdByUser": {
              url: urlBase + "/OperationProcedureHistories/:id/createdByUser",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#create
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/OperationProcedureHistories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#patchOrCreate
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/OperationProcedureHistories",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#replaceOrCreate
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/OperationProcedureHistories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#upsertWithWhere
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/OperationProcedureHistories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#exists
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/OperationProcedureHistories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#findById
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/OperationProcedureHistories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#replaceById
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/OperationProcedureHistories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#find
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/OperationProcedureHistories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#findOne
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/OperationProcedureHistories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#updateAll
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/OperationProcedureHistories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#deleteById
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/OperationProcedureHistories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#count
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/OperationProcedureHistories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#prototype$patchAttributes
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedureHistory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/OperationProcedureHistories/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#createChangeStream
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/OperationProcedureHistories/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#createMany
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/OperationProcedureHistories",
              method: "POST",
            },

            // INTERNAL. Use OperationProcedure.operationProcedureHistories.findById() instead.
            "::findById::OperationProcedure::operationProcedureHistories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationProcedures/:id/operationProcedureHistories/:fk",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedure.operationProcedureHistories.destroyById() instead.
            "::destroyById::OperationProcedure::operationProcedureHistories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationProcedures/:id/operationProcedureHistories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OperationProcedure.operationProcedureHistories.updateById() instead.
            "::updateById::OperationProcedure::operationProcedureHistories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationProcedures/:id/operationProcedureHistories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OperationProcedure.operationProcedureHistories() instead.
            "::get::OperationProcedure::operationProcedureHistories": {
              isArray: true,
              url: urlBase + "/OperationProcedures/:id/operationProcedureHistories",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedure.operationProcedureHistories.create() instead.
            "::create::OperationProcedure::operationProcedureHistories": {
              url: urlBase + "/OperationProcedures/:id/operationProcedureHistories",
              method: "POST",
            },

            // INTERNAL. Use OperationProcedure.operationProcedureHistories.createMany() instead.
            "::createMany::OperationProcedure::operationProcedureHistories": {
              isArray: true,
              url: urlBase + "/OperationProcedures/:id/operationProcedureHistories",
              method: "POST",
            },

            // INTERNAL. Use OperationProcedure.operationProcedureHistories.destroyAll() instead.
            "::delete::OperationProcedure::operationProcedureHistories": {
              url: urlBase + "/OperationProcedures/:id/operationProcedureHistories",
              method: "DELETE",
            },

            // INTERNAL. Use OperationProcedure.operationProcedureHistories.count() instead.
            "::count::OperationProcedure::operationProcedureHistories": {
              url: urlBase + "/OperationProcedures/:id/operationProcedureHistories/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#upsert
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#updateOrCreate
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#patchOrCreateWithWhere
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#update
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#destroyById
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#removeById
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#prototype$updateAttributes
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedureHistory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureHistory` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OperationProcedureHistory#modelName
        * @propertyOf lbServices.OperationProcedureHistory
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OperationProcedureHistory`.
        */
        R.modelName = "OperationProcedureHistory";


            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#operationProcedure
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Fetches belongsTo relation operationProcedure.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedureHistory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
        R.operationProcedure = function() {
          var TargetResource = $injector.get("OperationProcedure");
          var action = TargetResource["::get::OperationProcedureHistory::operationProcedure"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#updatedByUser
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Fetches belongsTo relation updatedByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedureHistory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.updatedByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::OperationProcedureHistory::updatedByUser"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OperationProcedureHistory.createdByUser
     * @header lbServices.OperationProcedureHistory.createdByUser
     * @object
     * @description
     *
     * The object `OperationProcedureHistory.createdByUser` groups methods
     * manipulating `SegaUser` instances related to `OperationProcedureHistory`.
     *
     * Call {@link lbServices.OperationProcedureHistory#createdByUser OperationProcedureHistory.createdByUser()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#createManydByUser
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedureHistory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createManydByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::OperationProcedureHistory::createManydByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureHistory#createdByUser
             * @methodOf lbServices.OperationProcedureHistory
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedureHistory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createdByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::OperationProcedureHistory::createdByUser"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Brand
 * @header lbServices.Brand
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Brand` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Brand",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Brands/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Brand#create
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Brands",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#patchOrCreate
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Brands",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#replaceOrCreate
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Brands/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#upsertWithWhere
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Brands/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#exists
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Brands/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#findById
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Brands/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#replaceById
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Brands/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#find
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Brands",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#findOne
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Brands/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#updateAll
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Brands/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#deleteById
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Brands/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#count
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Brands/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#prototype$patchAttributes
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Brand id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Brands/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#createChangeStream
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Brands/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#createMany
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Brands",
              method: "POST",
            },

            // INTERNAL. Use Vehicle.brand() instead.
            "::get::Vehicle::brand": {
              url: urlBase + "/Vehicles/:id/brand",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.engineBrand() instead.
            "::get::Vehicle::engineBrand": {
              url: urlBase + "/Vehicles/:id/engineBrand",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.chassisBrand() instead.
            "::get::Vehicle::chassisBrand": {
              url: urlBase + "/Vehicles/:id/chassisBrand",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Brand#upsert
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Brand#updateOrCreate
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Brand#patchOrCreateWithWhere
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Brand#update
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Brand#destroyById
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Brand#removeById
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Brand#prototype$updateAttributes
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Brand id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Brand#modelName
        * @propertyOf lbServices.Brand
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Brand`.
        */
        R.modelName = "Brand";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Creditor
 * @header lbServices.Creditor
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Creditor` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Creditor",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Creditors/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Creditor#create
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Creditors",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Creditor#patchOrCreate
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Creditors",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Creditor#replaceOrCreate
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Creditors/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Creditor#upsertWithWhere
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Creditors/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Creditor#exists
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Creditors/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Creditor#findById
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Creditors/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Creditor#replaceById
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Creditors/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Creditor#find
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Creditors",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Creditor#findOne
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Creditors/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Creditor#updateAll
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Creditors/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Creditor#deleteById
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Creditors/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Creditor#count
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Creditors/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Creditor#prototype$patchAttributes
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Creditor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Creditors/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Creditor#createChangeStream
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Creditors/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Creditor#createMany
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Creditors",
              method: "POST",
            },

            // INTERNAL. Use Operation.creditor() instead.
            "::get::Operation::creditor": {
              url: urlBase + "/Operations/:id/creditor",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Creditor#upsert
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Creditor#updateOrCreate
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Creditor#patchOrCreateWithWhere
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Creditor#update
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Creditor#destroyById
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Creditor#removeById
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Creditor#prototype$updateAttributes
             * @methodOf lbServices.Creditor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Creditor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Creditor#modelName
        * @propertyOf lbServices.Creditor
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Creditor`.
        */
        R.modelName = "Creditor";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Agency
 * @header lbServices.Agency
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Agency` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Agency",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Agencies/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Agency#create
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Agencies",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Agency#patchOrCreate
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Agencies",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Agency#replaceOrCreate
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Agencies/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Agency#upsertWithWhere
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Agencies/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Agency#exists
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Agencies/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Agency#findById
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Agencies/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Agency#replaceById
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Agencies/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Agency#find
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Agencies",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Agency#findOne
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Agencies/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Agency#updateAll
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Agencies/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Agency#deleteById
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Agencies/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Agency#count
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Agencies/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Agency#prototype$patchAttributes
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Agency id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Agencies/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Agency#createChangeStream
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Agencies/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Agency#createMany
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Agencies",
              method: "POST",
            },

            // INTERNAL. Use Operation.agency() instead.
            "::get::Operation::agency": {
              url: urlBase + "/Operations/:id/agency",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Agency#upsert
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Agency#updateOrCreate
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Agency#patchOrCreateWithWhere
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Agency#update
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Agency#destroyById
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Agency#removeById
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Agency#prototype$updateAttributes
             * @methodOf lbServices.Agency
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Agency id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Agency#modelName
        * @propertyOf lbServices.Agency
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Agency`.
        */
        R.modelName = "Agency";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Salesman
 * @header lbServices.Salesman
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Salesman` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Salesman",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Salesmans/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Salesman#create
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Salesmans",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Salesman#patchOrCreate
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Salesmans",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Salesman#replaceOrCreate
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Salesmans/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Salesman#upsertWithWhere
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Salesmans/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Salesman#exists
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Salesmans/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Salesman#findById
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Salesmans/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Salesman#replaceById
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Salesmans/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Salesman#find
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Salesmans",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Salesman#findOne
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Salesmans/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Salesman#updateAll
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Salesmans/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Salesman#deleteById
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Salesmans/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Salesman#count
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Salesmans/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Salesman#prototype$patchAttributes
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Salesman id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Salesmans/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Salesman#createChangeStream
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Salesmans/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Salesman#createMany
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Salesmans",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Salesman#upsert
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Salesman#updateOrCreate
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Salesman#patchOrCreateWithWhere
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Salesman#update
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Salesman#destroyById
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Salesman#removeById
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Salesman#prototype$updateAttributes
             * @methodOf lbServices.Salesman
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Salesman id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Salesman` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Salesman#modelName
        * @propertyOf lbServices.Salesman
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Salesman`.
        */
        R.modelName = "Salesman";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OperationType
 * @header lbServices.OperationType
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OperationType` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OperationType",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/OperationTypes/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OperationType.statesTemplates.findById() instead.
            "prototype$__findById__statesTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationTypes/:id/statesTemplates/:fk",
              method: "GET",
            },

            // INTERNAL. Use OperationType.statesTemplates.destroyById() instead.
            "prototype$__destroyById__statesTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationTypes/:id/statesTemplates/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OperationType.statesTemplates.updateById() instead.
            "prototype$__updateById__statesTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationTypes/:id/statesTemplates/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OperationType.statesTemplates.link() instead.
            "prototype$__link__statesTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationTypes/:id/statesTemplates/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OperationType.statesTemplates.unlink() instead.
            "prototype$__unlink__statesTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationTypes/:id/statesTemplates/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OperationType.statesTemplates.exists() instead.
            "prototype$__exists__statesTemplates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationTypes/:id/statesTemplates/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use OperationType.statesTemplates() instead.
            "prototype$__get__statesTemplates": {
              isArray: true,
              url: urlBase + "/OperationTypes/:id/statesTemplates",
              method: "GET",
            },

            // INTERNAL. Use OperationType.statesTemplates.create() instead.
            "prototype$__create__statesTemplates": {
              url: urlBase + "/OperationTypes/:id/statesTemplates",
              method: "POST",
            },

            // INTERNAL. Use OperationType.statesTemplates.destroyAll() instead.
            "prototype$__delete__statesTemplates": {
              url: urlBase + "/OperationTypes/:id/statesTemplates",
              method: "DELETE",
            },

            // INTERNAL. Use OperationType.statesTemplates.count() instead.
            "prototype$__count__statesTemplates": {
              url: urlBase + "/OperationTypes/:id/statesTemplates/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#create
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/OperationTypes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#patchOrCreate
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/OperationTypes",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#replaceOrCreate
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/OperationTypes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#upsertWithWhere
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/OperationTypes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#exists
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/OperationTypes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#findById
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/OperationTypes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#replaceById
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/OperationTypes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#find
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/OperationTypes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#findOne
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/OperationTypes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#updateAll
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/OperationTypes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#deleteById
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/OperationTypes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#count
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/OperationTypes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#prototype$patchAttributes
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/OperationTypes/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#createChangeStream
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/OperationTypes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#addStatesTemplate
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `operationTypeId` – `{number}` -
             *
             *  - `statesTemplateId` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "addStatesTemplate": {
              url: urlBase + "/OperationTypes/addStatesTemplate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#removeStatesTemplate
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `operationTypeId` – `{number}` -
             *
             *  - `statesTemplateId` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "removeStatesTemplate": {
              url: urlBase + "/OperationTypes/removeStatesTemplate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationType#createMany
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/OperationTypes",
              method: "POST",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.findById() instead.
            "::findById::StatesTemplate::operationTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/StatesTemplates/:id/operationTypes/:fk",
              method: "GET",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.destroyById() instead.
            "::destroyById::StatesTemplate::operationTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/StatesTemplates/:id/operationTypes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.updateById() instead.
            "::updateById::StatesTemplate::operationTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/StatesTemplates/:id/operationTypes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.link() instead.
            "::link::StatesTemplate::operationTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/StatesTemplates/:id/operationTypes/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.unlink() instead.
            "::unlink::StatesTemplate::operationTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/StatesTemplates/:id/operationTypes/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.exists() instead.
            "::exists::StatesTemplate::operationTypes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/StatesTemplates/:id/operationTypes/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use StatesTemplate.operationTypes() instead.
            "::get::StatesTemplate::operationTypes": {
              isArray: true,
              url: urlBase + "/StatesTemplates/:id/operationTypes",
              method: "GET",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.create() instead.
            "::create::StatesTemplate::operationTypes": {
              url: urlBase + "/StatesTemplates/:id/operationTypes",
              method: "POST",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.createMany() instead.
            "::createMany::StatesTemplate::operationTypes": {
              isArray: true,
              url: urlBase + "/StatesTemplates/:id/operationTypes",
              method: "POST",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.destroyAll() instead.
            "::delete::StatesTemplate::operationTypes": {
              url: urlBase + "/StatesTemplates/:id/operationTypes",
              method: "DELETE",
            },

            // INTERNAL. Use StatesTemplate.operationTypes.count() instead.
            "::count::StatesTemplate::operationTypes": {
              url: urlBase + "/StatesTemplates/:id/operationTypes/count",
              method: "GET",
            },

            // INTERNAL. Use OperationTypeStatesTemplate.operationType() instead.
            "::get::OperationTypeStatesTemplate::operationType": {
              url: urlBase + "/OperationTypeStatesTemplates/:id/operationType",
              method: "GET",
            },

            // INTERNAL. Use Operation.operationType() instead.
            "::get::Operation::operationType": {
              url: urlBase + "/Operations/:id/operationType",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OperationType#upsert
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OperationType#updateOrCreate
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OperationType#patchOrCreateWithWhere
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OperationType#update
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OperationType#destroyById
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OperationType#removeById
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OperationType#prototype$updateAttributes
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OperationType#modelName
        * @propertyOf lbServices.OperationType
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OperationType`.
        */
        R.modelName = "OperationType";

    /**
     * @ngdoc object
     * @name lbServices.OperationType.statesTemplates
     * @header lbServices.OperationType.statesTemplates
     * @object
     * @description
     *
     * The object `OperationType.statesTemplates` groups methods
     * manipulating `StatesTemplate` instances related to `OperationType`.
     *
     * Call {@link lbServices.OperationType#statesTemplates OperationType.statesTemplates()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OperationType#statesTemplates
             * @methodOf lbServices.OperationType
             *
             * @description
             *
             * Queries statesTemplates of OperationType.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
        R.statesTemplates = function() {
          var TargetResource = $injector.get("StatesTemplate");
          var action = TargetResource["::get::OperationType::statesTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationType.statesTemplates#count
             * @methodOf lbServices.OperationType.statesTemplates
             *
             * @description
             *
             * Counts statesTemplates of OperationType.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.statesTemplates.count = function() {
          var TargetResource = $injector.get("StatesTemplate");
          var action = TargetResource["::count::OperationType::statesTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationType.statesTemplates#create
             * @methodOf lbServices.OperationType.statesTemplates
             *
             * @description
             *
             * Creates a new instance in statesTemplates of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationType id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
        R.statesTemplates.create = function() {
          var TargetResource = $injector.get("StatesTemplate");
          var action = TargetResource["::create::OperationType::statesTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationType.statesTemplates#createMany
             * @methodOf lbServices.OperationType.statesTemplates
             *
             * @description
             *
             * Creates a new instance in statesTemplates of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationType id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
        R.statesTemplates.createMany = function() {
          var TargetResource = $injector.get("StatesTemplate");
          var action = TargetResource["::createMany::OperationType::statesTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationType.statesTemplates#destroyAll
             * @methodOf lbServices.OperationType.statesTemplates
             *
             * @description
             *
             * Deletes all statesTemplates of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.statesTemplates.destroyAll = function() {
          var TargetResource = $injector.get("StatesTemplate");
          var action = TargetResource["::delete::OperationType::statesTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationType.statesTemplates#destroyById
             * @methodOf lbServices.OperationType.statesTemplates
             *
             * @description
             *
             * Delete a related item by id for statesTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for statesTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.statesTemplates.destroyById = function() {
          var TargetResource = $injector.get("StatesTemplate");
          var action = TargetResource["::destroyById::OperationType::statesTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationType.statesTemplates#exists
             * @methodOf lbServices.OperationType.statesTemplates
             *
             * @description
             *
             * Check the existence of statesTemplates relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for statesTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
        R.statesTemplates.exists = function() {
          var TargetResource = $injector.get("StatesTemplate");
          var action = TargetResource["::exists::OperationType::statesTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationType.statesTemplates#findById
             * @methodOf lbServices.OperationType.statesTemplates
             *
             * @description
             *
             * Find a related item by id for statesTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for statesTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
        R.statesTemplates.findById = function() {
          var TargetResource = $injector.get("StatesTemplate");
          var action = TargetResource["::findById::OperationType::statesTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationType.statesTemplates#link
             * @methodOf lbServices.OperationType.statesTemplates
             *
             * @description
             *
             * Add a related item by id for statesTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationType id
             *
             *  - `fk` – `{*}` - Foreign key for statesTemplates
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
        R.statesTemplates.link = function() {
          var TargetResource = $injector.get("StatesTemplate");
          var action = TargetResource["::link::OperationType::statesTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationType.statesTemplates#unlink
             * @methodOf lbServices.OperationType.statesTemplates
             *
             * @description
             *
             * Remove the statesTemplates relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationType id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for statesTemplates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.statesTemplates.unlink = function() {
          var TargetResource = $injector.get("StatesTemplate");
          var action = TargetResource["::unlink::OperationType::statesTemplates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationType.statesTemplates#updateById
             * @methodOf lbServices.OperationType.statesTemplates
             *
             * @description
             *
             * Update a related item by id for statesTemplates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationType id
             *
             *  - `fk` – `{*}` - Foreign key for statesTemplates
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
        R.statesTemplates.updateById = function() {
          var TargetResource = $injector.get("StatesTemplate");
          var action = TargetResource["::updateById::OperationType::statesTemplates"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OperationTypeStatesTemplate
 * @header lbServices.OperationTypeStatesTemplate
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OperationTypeStatesTemplate` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OperationTypeStatesTemplate",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/OperationTypeStatesTemplates/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OperationTypeStatesTemplate.operationType() instead.
            "prototype$__get__operationType": {
              url: urlBase + "/OperationTypeStatesTemplates/:id/operationType",
              method: "GET",
            },

            // INTERNAL. Use OperationTypeStatesTemplate.statesTemplate() instead.
            "prototype$__get__statesTemplate": {
              url: urlBase + "/OperationTypeStatesTemplates/:id/statesTemplate",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#create
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/OperationTypeStatesTemplates",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#patchOrCreate
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/OperationTypeStatesTemplates",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#replaceOrCreate
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/OperationTypeStatesTemplates/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#upsertWithWhere
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/OperationTypeStatesTemplates/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#exists
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/OperationTypeStatesTemplates/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#findById
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/OperationTypeStatesTemplates/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#replaceById
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/OperationTypeStatesTemplates/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#find
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/OperationTypeStatesTemplates",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#findOne
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/OperationTypeStatesTemplates/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#updateAll
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/OperationTypeStatesTemplates/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#deleteById
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/OperationTypeStatesTemplates/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#count
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/OperationTypeStatesTemplates/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#prototype$patchAttributes
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationTypeStatesTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/OperationTypeStatesTemplates/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#createChangeStream
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/OperationTypeStatesTemplates/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#createMany
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/OperationTypeStatesTemplates",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#upsert
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#updateOrCreate
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#patchOrCreateWithWhere
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#update
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#destroyById
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#removeById
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#prototype$updateAttributes
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationTypeStatesTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationTypeStatesTemplate` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OperationTypeStatesTemplate#modelName
        * @propertyOf lbServices.OperationTypeStatesTemplate
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OperationTypeStatesTemplate`.
        */
        R.modelName = "OperationTypeStatesTemplate";


            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#operationType
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Fetches belongsTo relation operationType.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationTypeStatesTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
        R.operationType = function() {
          var TargetResource = $injector.get("OperationType");
          var action = TargetResource["::get::OperationTypeStatesTemplate::operationType"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationTypeStatesTemplate#statesTemplate
             * @methodOf lbServices.OperationTypeStatesTemplate
             *
             * @description
             *
             * Fetches belongsTo relation statesTemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationTypeStatesTemplate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatesTemplate` object.)
             * </em>
             */
        R.statesTemplate = function() {
          var TargetResource = $injector.get("StatesTemplate");
          var action = TargetResource["::get::OperationTypeStatesTemplate::statesTemplate"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Operation
 * @header lbServices.Operation
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Operation` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Operation",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Operations/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Operation.operationType() instead.
            "prototype$__get__operationType": {
              url: urlBase + "/Operations/:id/operationType",
              method: "GET",
            },

            // INTERNAL. Use Operation.operationProcedures.findById() instead.
            "prototype$__findById__operationProcedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Operations/:id/operationProcedures/:fk",
              method: "GET",
            },

            // INTERNAL. Use Operation.operationProcedures.destroyById() instead.
            "prototype$__destroyById__operationProcedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Operations/:id/operationProcedures/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Operation.operationProcedures.updateById() instead.
            "prototype$__updateById__operationProcedures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Operations/:id/operationProcedures/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Operation.client() instead.
            "prototype$__get__client": {
              url: urlBase + "/Operations/:id/client",
              method: "GET",
            },

            // INTERNAL. Use Operation.holder() instead.
            "prototype$__get__holder": {
              url: urlBase + "/Operations/:id/holder",
              method: "GET",
            },

            // INTERNAL. Use Operation.vehicle() instead.
            "prototype$__get__vehicle": {
              url: urlBase + "/Operations/:id/vehicle",
              method: "GET",
            },

            // INTERNAL. Use Operation.agency() instead.
            "prototype$__get__agency": {
              url: urlBase + "/Operations/:id/agency",
              method: "GET",
            },

            // INTERNAL. Use Operation.creditor() instead.
            "prototype$__get__creditor": {
              url: urlBase + "/Operations/:id/creditor",
              method: "GET",
            },

            // INTERNAL. Use Operation.createdByUser() instead.
            "prototype$__get__createdByUser": {
              url: urlBase + "/Operations/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Operation.updatedByUser() instead.
            "prototype$__get__updatedByUser": {
              url: urlBase + "/Operations/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use Operation.operationComments.findById() instead.
            "prototype$__findById__operationComments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Operations/:id/operationComments/:fk",
              method: "GET",
            },

            // INTERNAL. Use Operation.operationComments.destroyById() instead.
            "prototype$__destroyById__operationComments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Operations/:id/operationComments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Operation.operationComments.updateById() instead.
            "prototype$__updateById__operationComments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Operations/:id/operationComments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Operation.operationProcedures() instead.
            "prototype$__get__operationProcedures": {
              isArray: true,
              url: urlBase + "/Operations/:id/operationProcedures",
              method: "GET",
            },

            // INTERNAL. Use Operation.operationProcedures.create() instead.
            "prototype$__create__operationProcedures": {
              url: urlBase + "/Operations/:id/operationProcedures",
              method: "POST",
            },

            // INTERNAL. Use Operation.operationProcedures.destroyAll() instead.
            "prototype$__delete__operationProcedures": {
              url: urlBase + "/Operations/:id/operationProcedures",
              method: "DELETE",
            },

            // INTERNAL. Use Operation.operationProcedures.count() instead.
            "prototype$__count__operationProcedures": {
              url: urlBase + "/Operations/:id/operationProcedures/count",
              method: "GET",
            },

            // INTERNAL. Use Operation.operationComments() instead.
            "prototype$__get__operationComments": {
              isArray: true,
              url: urlBase + "/Operations/:id/operationComments",
              method: "GET",
            },

            // INTERNAL. Use Operation.operationComments.create() instead.
            "prototype$__create__operationComments": {
              url: urlBase + "/Operations/:id/operationComments",
              method: "POST",
            },

            // INTERNAL. Use Operation.operationComments.destroyAll() instead.
            "prototype$__delete__operationComments": {
              url: urlBase + "/Operations/:id/operationComments",
              method: "DELETE",
            },

            // INTERNAL. Use Operation.operationComments.count() instead.
            "prototype$__count__operationComments": {
              url: urlBase + "/Operations/:id/operationComments/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#create
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Operations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#patchOrCreate
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Operations",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#replaceOrCreate
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Operations/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#upsertWithWhere
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Operations/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#exists
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Operations/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#findById
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Operations/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#replaceById
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Operations/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#find
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Operations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#findOne
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Operations/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#updateAll
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Operations/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#deleteById
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Operations/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#count
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Operations/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#prototype$patchAttributes
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Operations/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#createChangeStream
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Operations/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#excelExport
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Exports absences data to an Excel file
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object}` - Where object which filters results
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `body` – `{string=}` - File
             */
            "excelExport": {
              url: urlBase + "/Operations/excelExport",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#createNew
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Creates a new Operation
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `operationData` – `{object}` - Operation data
             *
             *  - `statesTemplates` – `{*=}` - States templates to be used for generation of operation procedures
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `operation` – `{object=}` - Operation just created
             */
            "createNew": {
              url: urlBase + "/Operations/create-new",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#addProcedure
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Creates a new Operation Procedure
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `operationId` – `{number}` - Operation id
             *
             *  - `statesTemplateId` – `{number}` - ST id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `operationProcedure` – `{object=}` - Operation Procedure
             */
            "addProcedure": {
              url: urlBase + "/Operations/add-procedure",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#removeProcedure
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Destroys an operation procedure
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `operationId` – `{number}` - Operation id
             *
             *  - `operationProcedureId` – `{number}` - OP id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `operation` – `{object=}` - Operation
             */
            "removeProcedure": {
              url: urlBase + "/Operations/remove-procedure",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Operation#createMany
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Operations",
              method: "POST",
            },

            // INTERNAL. Use OperationProcedure.operation() instead.
            "::get::OperationProcedure::operation": {
              url: urlBase + "/OperationProcedures/:id/operation",
              method: "GET",
            },

            // INTERNAL. Use OperationComment.operation() instead.
            "::get::OperationComment::operation": {
              url: urlBase + "/OperationComments/:id/operation",
              method: "GET",
            },

            // INTERNAL. Use Assignation.operation() instead.
            "::get::Assignation::operation": {
              url: urlBase + "/Assignations/:id/operation",
              method: "GET",
            },

            // INTERNAL. Use Cronology.operation() instead.
            "::get::Cronology::operation": {
              url: urlBase + "/Cronologies/:id/operation",
              method: "GET",
            },

            // INTERNAL. Use Task.operation() instead.
            "::get::Task::operation": {
              url: urlBase + "/Tasks/:id/operation",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Operation#upsert
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Operation#updateOrCreate
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Operation#patchOrCreateWithWhere
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Operation#update
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Operation#destroyById
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Operation#removeById
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Operation#prototype$updateAttributes
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Operation#modelName
        * @propertyOf lbServices.Operation
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Operation`.
        */
        R.modelName = "Operation";


            /**
             * @ngdoc method
             * @name lbServices.Operation#operationType
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Fetches belongsTo relation operationType.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationType` object.)
             * </em>
             */
        R.operationType = function() {
          var TargetResource = $injector.get("OperationType");
          var action = TargetResource["::get::Operation::operationType"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Operation.operationProcedures
     * @header lbServices.Operation.operationProcedures
     * @object
     * @description
     *
     * The object `Operation.operationProcedures` groups methods
     * manipulating `OperationProcedure` instances related to `Operation`.
     *
     * Call {@link lbServices.Operation#operationProcedures Operation.operationProcedures()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Operation#operationProcedures
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Queries operationProcedures of Operation.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
        R.operationProcedures = function() {
          var TargetResource = $injector.get("OperationProcedure");
          var action = TargetResource["::get::Operation::operationProcedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation.operationProcedures#count
             * @methodOf lbServices.Operation.operationProcedures
             *
             * @description
             *
             * Counts operationProcedures of Operation.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.operationProcedures.count = function() {
          var TargetResource = $injector.get("OperationProcedure");
          var action = TargetResource["::count::Operation::operationProcedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation.operationProcedures#create
             * @methodOf lbServices.Operation.operationProcedures
             *
             * @description
             *
             * Creates a new instance in operationProcedures of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
        R.operationProcedures.create = function() {
          var TargetResource = $injector.get("OperationProcedure");
          var action = TargetResource["::create::Operation::operationProcedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation.operationProcedures#createMany
             * @methodOf lbServices.Operation.operationProcedures
             *
             * @description
             *
             * Creates a new instance in operationProcedures of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
        R.operationProcedures.createMany = function() {
          var TargetResource = $injector.get("OperationProcedure");
          var action = TargetResource["::createMany::Operation::operationProcedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation.operationProcedures#destroyAll
             * @methodOf lbServices.Operation.operationProcedures
             *
             * @description
             *
             * Deletes all operationProcedures of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.operationProcedures.destroyAll = function() {
          var TargetResource = $injector.get("OperationProcedure");
          var action = TargetResource["::delete::Operation::operationProcedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation.operationProcedures#destroyById
             * @methodOf lbServices.Operation.operationProcedures
             *
             * @description
             *
             * Delete a related item by id for operationProcedures.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operationProcedures
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.operationProcedures.destroyById = function() {
          var TargetResource = $injector.get("OperationProcedure");
          var action = TargetResource["::destroyById::Operation::operationProcedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation.operationProcedures#findById
             * @methodOf lbServices.Operation.operationProcedures
             *
             * @description
             *
             * Find a related item by id for operationProcedures.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operationProcedures
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
        R.operationProcedures.findById = function() {
          var TargetResource = $injector.get("OperationProcedure");
          var action = TargetResource["::findById::Operation::operationProcedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation.operationProcedures#updateById
             * @methodOf lbServices.Operation.operationProcedures
             *
             * @description
             *
             * Update a related item by id for operationProcedures.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `fk` – `{*}` - Foreign key for operationProcedures
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
        R.operationProcedures.updateById = function() {
          var TargetResource = $injector.get("OperationProcedure");
          var action = TargetResource["::updateById::Operation::operationProcedures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation#client
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Fetches belongsTo relation client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.client = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::Operation::client"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation#holder
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Fetches belongsTo relation holder.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.holder = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::Operation::holder"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation#vehicle
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Fetches belongsTo relation vehicle.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R.vehicle = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::get::Operation::vehicle"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation#agency
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Fetches belongsTo relation agency.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Agency` object.)
             * </em>
             */
        R.agency = function() {
          var TargetResource = $injector.get("Agency");
          var action = TargetResource["::get::Operation::agency"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation#creditor
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Fetches belongsTo relation creditor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Creditor` object.)
             * </em>
             */
        R.creditor = function() {
          var TargetResource = $injector.get("Creditor");
          var action = TargetResource["::get::Operation::creditor"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Operation.createdByUser
     * @header lbServices.Operation.createdByUser
     * @object
     * @description
     *
     * The object `Operation.createdByUser` groups methods
     * manipulating `SegaUser` instances related to `Operation`.
     *
     * Call {@link lbServices.Operation#createdByUser Operation.createdByUser()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Operation#createManydByUser
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createManydByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Operation::createManydByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation#createdByUser
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createdByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Operation::createdByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation#updatedByUser
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Fetches belongsTo relation updatedByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.updatedByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Operation::updatedByUser"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Operation.operationComments
     * @header lbServices.Operation.operationComments
     * @object
     * @description
     *
     * The object `Operation.operationComments` groups methods
     * manipulating `OperationComment` instances related to `Operation`.
     *
     * Call {@link lbServices.Operation#operationComments Operation.operationComments()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Operation#operationComments
             * @methodOf lbServices.Operation
             *
             * @description
             *
             * Queries operationComments of Operation.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
        R.operationComments = function() {
          var TargetResource = $injector.get("OperationComment");
          var action = TargetResource["::get::Operation::operationComments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation.operationComments#count
             * @methodOf lbServices.Operation.operationComments
             *
             * @description
             *
             * Counts operationComments of Operation.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.operationComments.count = function() {
          var TargetResource = $injector.get("OperationComment");
          var action = TargetResource["::count::Operation::operationComments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation.operationComments#create
             * @methodOf lbServices.Operation.operationComments
             *
             * @description
             *
             * Creates a new instance in operationComments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
        R.operationComments.create = function() {
          var TargetResource = $injector.get("OperationComment");
          var action = TargetResource["::create::Operation::operationComments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation.operationComments#createMany
             * @methodOf lbServices.Operation.operationComments
             *
             * @description
             *
             * Creates a new instance in operationComments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
        R.operationComments.createMany = function() {
          var TargetResource = $injector.get("OperationComment");
          var action = TargetResource["::createMany::Operation::operationComments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation.operationComments#destroyAll
             * @methodOf lbServices.Operation.operationComments
             *
             * @description
             *
             * Deletes all operationComments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.operationComments.destroyAll = function() {
          var TargetResource = $injector.get("OperationComment");
          var action = TargetResource["::delete::Operation::operationComments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation.operationComments#destroyById
             * @methodOf lbServices.Operation.operationComments
             *
             * @description
             *
             * Delete a related item by id for operationComments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operationComments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.operationComments.destroyById = function() {
          var TargetResource = $injector.get("OperationComment");
          var action = TargetResource["::destroyById::Operation::operationComments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation.operationComments#findById
             * @methodOf lbServices.Operation.operationComments
             *
             * @description
             *
             * Find a related item by id for operationComments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for operationComments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
        R.operationComments.findById = function() {
          var TargetResource = $injector.get("OperationComment");
          var action = TargetResource["::findById::Operation::operationComments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Operation.operationComments#updateById
             * @methodOf lbServices.Operation.operationComments
             *
             * @description
             *
             * Update a related item by id for operationComments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Operation id
             *
             *  - `fk` – `{*}` - Foreign key for operationComments
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
        R.operationComments.updateById = function() {
          var TargetResource = $injector.get("OperationComment");
          var action = TargetResource["::updateById::Operation::operationComments"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OperationProcedureTask
 * @header lbServices.OperationProcedureTask
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OperationProcedureTask` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OperationProcedureTask",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/OperationProcedureTasks/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OperationProcedureTask.operationProcedure() instead.
            "prototype$__get__operationProcedure": {
              url: urlBase + "/OperationProcedureTasks/:id/operationProcedure",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#create
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/OperationProcedureTasks",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#patchOrCreate
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/OperationProcedureTasks",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#replaceOrCreate
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/OperationProcedureTasks/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#upsertWithWhere
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/OperationProcedureTasks/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#exists
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/OperationProcedureTasks/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#findById
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/OperationProcedureTasks/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#replaceById
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/OperationProcedureTasks/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#find
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/OperationProcedureTasks",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#findOne
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/OperationProcedureTasks/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#updateAll
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/OperationProcedureTasks/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#deleteById
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/OperationProcedureTasks/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#count
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/OperationProcedureTasks/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#prototype$patchAttributes
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedureTask id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/OperationProcedureTasks/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#createChangeStream
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/OperationProcedureTasks/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#createMany
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/OperationProcedureTasks",
              method: "POST",
            },

            // INTERNAL. Use OperationProcedure.currentTask() instead.
            "::get::OperationProcedure::currentTask": {
              url: urlBase + "/OperationProcedures/:id/currentTask",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedure.tasks.findById() instead.
            "::findById::OperationProcedure::tasks": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationProcedures/:id/tasks/:fk",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedure.tasks.destroyById() instead.
            "::destroyById::OperationProcedure::tasks": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationProcedures/:id/tasks/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OperationProcedure.tasks.updateById() instead.
            "::updateById::OperationProcedure::tasks": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/OperationProcedures/:id/tasks/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OperationProcedure.tasks() instead.
            "::get::OperationProcedure::tasks": {
              isArray: true,
              url: urlBase + "/OperationProcedures/:id/tasks",
              method: "GET",
            },

            // INTERNAL. Use OperationProcedure.tasks.create() instead.
            "::create::OperationProcedure::tasks": {
              url: urlBase + "/OperationProcedures/:id/tasks",
              method: "POST",
            },

            // INTERNAL. Use OperationProcedure.tasks.createMany() instead.
            "::createMany::OperationProcedure::tasks": {
              isArray: true,
              url: urlBase + "/OperationProcedures/:id/tasks",
              method: "POST",
            },

            // INTERNAL. Use OperationProcedure.tasks.destroyAll() instead.
            "::delete::OperationProcedure::tasks": {
              url: urlBase + "/OperationProcedures/:id/tasks",
              method: "DELETE",
            },

            // INTERNAL. Use OperationProcedure.tasks.count() instead.
            "::count::OperationProcedure::tasks": {
              url: urlBase + "/OperationProcedures/:id/tasks/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#upsert
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#updateOrCreate
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#patchOrCreateWithWhere
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#update
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#destroyById
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#removeById
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#prototype$updateAttributes
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedureTask id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedureTask` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OperationProcedureTask#modelName
        * @propertyOf lbServices.OperationProcedureTask
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OperationProcedureTask`.
        */
        R.modelName = "OperationProcedureTask";


            /**
             * @ngdoc method
             * @name lbServices.OperationProcedureTask#operationProcedure
             * @methodOf lbServices.OperationProcedureTask
             *
             * @description
             *
             * Fetches belongsTo relation operationProcedure.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationProcedureTask id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
        R.operationProcedure = function() {
          var TargetResource = $injector.get("OperationProcedure");
          var action = TargetResource["::get::OperationProcedureTask::operationProcedure"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.City
 * @header lbServices.City
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `City` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "City",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Cities/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use City.province() instead.
            "prototype$__get__province": {
              url: urlBase + "/Cities/:id/province",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.City#create
             * @methodOf lbServices.City
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Cities",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.City#patchOrCreate
             * @methodOf lbServices.City
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Cities",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.City#replaceOrCreate
             * @methodOf lbServices.City
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Cities/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.City#upsertWithWhere
             * @methodOf lbServices.City
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Cities/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.City#exists
             * @methodOf lbServices.City
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Cities/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.City#findById
             * @methodOf lbServices.City
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Cities/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.City#replaceById
             * @methodOf lbServices.City
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Cities/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.City#find
             * @methodOf lbServices.City
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Cities",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.City#findOne
             * @methodOf lbServices.City
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Cities/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.City#updateAll
             * @methodOf lbServices.City
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Cities/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.City#deleteById
             * @methodOf lbServices.City
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Cities/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.City#count
             * @methodOf lbServices.City
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Cities/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.City#prototype$patchAttributes
             * @methodOf lbServices.City
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - City id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Cities/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.City#createChangeStream
             * @methodOf lbServices.City
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Cities/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.City#createMany
             * @methodOf lbServices.City
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Cities",
              method: "POST",
            },

            // INTERNAL. Use Client.cityModel() instead.
            "::get::Client::cityModel": {
              url: urlBase + "/Clients/:id/cityModel",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.City#upsert
             * @methodOf lbServices.City
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.City#updateOrCreate
             * @methodOf lbServices.City
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.City#patchOrCreateWithWhere
             * @methodOf lbServices.City
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.City#update
             * @methodOf lbServices.City
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.City#destroyById
             * @methodOf lbServices.City
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.City#removeById
             * @methodOf lbServices.City
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.City#prototype$updateAttributes
             * @methodOf lbServices.City
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - City id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `City` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.City#modelName
        * @propertyOf lbServices.City
        * @description
        * The name of the model represented by this $resource,
        * i.e. `City`.
        */
        R.modelName = "City";


            /**
             * @ngdoc method
             * @name lbServices.City#province
             * @methodOf lbServices.City
             *
             * @description
             *
             * Fetches belongsTo relation province.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - City id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R.province = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::get::City::province"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Province
 * @header lbServices.Province
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Province` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Province",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Provinces/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Province#create
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Provinces",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#patchOrCreate
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Provinces",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#replaceOrCreate
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Provinces/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#upsertWithWhere
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Provinces/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#exists
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Provinces/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#findById
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Provinces/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#replaceById
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Provinces/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#find
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Provinces",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#findOne
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Provinces/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#updateAll
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Provinces/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#deleteById
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Provinces/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#count
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Provinces/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#prototype$patchAttributes
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Province id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Provinces/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#createChangeStream
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Provinces/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#createMany
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Provinces",
              method: "POST",
            },

            // INTERNAL. Use Vehicle.province() instead.
            "::get::Vehicle::province": {
              url: urlBase + "/Vehicles/:id/province",
              method: "GET",
            },

            // INTERNAL. Use City.province() instead.
            "::get::City::province": {
              url: urlBase + "/Cities/:id/province",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Province#upsert
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Province#updateOrCreate
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Province#patchOrCreateWithWhere
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Province#update
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Province#destroyById
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Province#removeById
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Province#prototype$updateAttributes
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Province id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Province#modelName
        * @propertyOf lbServices.Province
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Province`.
        */
        R.modelName = "Province";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OperationComment
 * @header lbServices.OperationComment
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OperationComment` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OperationComment",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/OperationComments/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OperationComment.createdByUser() instead.
            "prototype$__get__createdByUser": {
              url: urlBase + "/OperationComments/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use OperationComment.updatedByUser() instead.
            "prototype$__get__updatedByUser": {
              url: urlBase + "/OperationComments/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use OperationComment.operation() instead.
            "prototype$__get__operation": {
              url: urlBase + "/OperationComments/:id/operation",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#create
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/OperationComments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#patchOrCreate
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/OperationComments",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#replaceOrCreate
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/OperationComments/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#upsertWithWhere
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/OperationComments/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#exists
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/OperationComments/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#findById
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/OperationComments/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#replaceById
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/OperationComments/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#find
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/OperationComments",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#findOne
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/OperationComments/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#updateAll
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/OperationComments/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#deleteById
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/OperationComments/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#count
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/OperationComments/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#prototype$patchAttributes
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationComment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/OperationComments/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#createChangeStream
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/OperationComments/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#createMany
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/OperationComments",
              method: "POST",
            },

            // INTERNAL. Use Operation.operationComments.findById() instead.
            "::findById::Operation::operationComments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Operations/:id/operationComments/:fk",
              method: "GET",
            },

            // INTERNAL. Use Operation.operationComments.destroyById() instead.
            "::destroyById::Operation::operationComments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Operations/:id/operationComments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Operation.operationComments.updateById() instead.
            "::updateById::Operation::operationComments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Operations/:id/operationComments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Operation.operationComments() instead.
            "::get::Operation::operationComments": {
              isArray: true,
              url: urlBase + "/Operations/:id/operationComments",
              method: "GET",
            },

            // INTERNAL. Use Operation.operationComments.create() instead.
            "::create::Operation::operationComments": {
              url: urlBase + "/Operations/:id/operationComments",
              method: "POST",
            },

            // INTERNAL. Use Operation.operationComments.createMany() instead.
            "::createMany::Operation::operationComments": {
              isArray: true,
              url: urlBase + "/Operations/:id/operationComments",
              method: "POST",
            },

            // INTERNAL. Use Operation.operationComments.destroyAll() instead.
            "::delete::Operation::operationComments": {
              url: urlBase + "/Operations/:id/operationComments",
              method: "DELETE",
            },

            // INTERNAL. Use Operation.operationComments.count() instead.
            "::count::Operation::operationComments": {
              url: urlBase + "/Operations/:id/operationComments/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OperationComment#upsert
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#updateOrCreate
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#patchOrCreateWithWhere
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#update
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#destroyById
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#removeById
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#prototype$updateAttributes
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationComment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationComment` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OperationComment#modelName
        * @propertyOf lbServices.OperationComment
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OperationComment`.
        */
        R.modelName = "OperationComment";

    /**
     * @ngdoc object
     * @name lbServices.OperationComment.createdByUser
     * @header lbServices.OperationComment.createdByUser
     * @object
     * @description
     *
     * The object `OperationComment.createdByUser` groups methods
     * manipulating `SegaUser` instances related to `OperationComment`.
     *
     * Call {@link lbServices.OperationComment#createdByUser OperationComment.createdByUser()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OperationComment#createManydByUser
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationComment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createManydByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::OperationComment::createManydByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#createdByUser
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationComment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createdByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::OperationComment::createdByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#updatedByUser
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Fetches belongsTo relation updatedByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationComment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.updatedByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::OperationComment::updatedByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OperationComment#operation
             * @methodOf lbServices.OperationComment
             *
             * @description
             *
             * Fetches belongsTo relation operation.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OperationComment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
        R.operation = function() {
          var TargetResource = $injector.get("Operation");
          var action = TargetResource["::get::OperationComment::operation"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Email
 * @header lbServices.Email
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Email` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Email",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Emails/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Email#modelName
        * @propertyOf lbServices.Email
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Email`.
        */
        R.modelName = "Email";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Assignation
 * @header lbServices.Assignation
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Assignation` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Assignation",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Assignations/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Assignation.operation() instead.
            "prototype$__get__operation": {
              url: urlBase + "/Assignations/:id/operation",
              method: "GET",
            },

            // INTERNAL. Use Assignation.operationProcedure() instead.
            "prototype$__get__operationProcedure": {
              url: urlBase + "/Assignations/:id/operationProcedure",
              method: "GET",
            },

            // INTERNAL. Use Assignation.worker() instead.
            "prototype$__get__worker": {
              url: urlBase + "/Assignations/:id/worker",
              method: "GET",
            },

            // INTERNAL. Use Assignation.registry() instead.
            "prototype$__get__registry": {
              url: urlBase + "/Assignations/:id/registry",
              method: "GET",
            },

            // INTERNAL. Use Assignation.createdByUser() instead.
            "prototype$__get__createdByUser": {
              url: urlBase + "/Assignations/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Assignation.updatedByUser() instead.
            "prototype$__get__updatedByUser": {
              url: urlBase + "/Assignations/:id/updatedByUser",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#create
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Assignations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#patchOrCreate
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Assignations",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#replaceOrCreate
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Assignations/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#upsertWithWhere
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Assignations/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#exists
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Assignations/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#findById
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Assignations/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#replaceById
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Assignations/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#find
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Assignations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#findOne
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Assignations/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#updateAll
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Assignations/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#deleteById
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Assignations/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#count
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Assignations/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#prototype$patchAttributes
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Assignation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Assignations/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#createChangeStream
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Assignations/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#updateByIds
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ids` – `{*}` -
             *
             *  - `data` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "updateByIds": {
              url: urlBase + "/Assignations/updateByIds",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#pdf
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * PDF
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `workerId` – `{integer}` -
             *
             *  - `date` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
            "pdf": {
              url: urlBase + "/Assignations/pdf",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assignation#createMany
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Assignations",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Assignation#upsert
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Assignation#updateOrCreate
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Assignation#patchOrCreateWithWhere
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Assignation#update
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Assignation#destroyById
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Assignation#removeById
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Assignation#prototype$updateAttributes
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Assignation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assignation` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Assignation#modelName
        * @propertyOf lbServices.Assignation
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Assignation`.
        */
        R.modelName = "Assignation";


            /**
             * @ngdoc method
             * @name lbServices.Assignation#operation
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Fetches belongsTo relation operation.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Assignation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
        R.operation = function() {
          var TargetResource = $injector.get("Operation");
          var action = TargetResource["::get::Assignation::operation"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Assignation#operationProcedure
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Fetches belongsTo relation operationProcedure.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Assignation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OperationProcedure` object.)
             * </em>
             */
        R.operationProcedure = function() {
          var TargetResource = $injector.get("OperationProcedure");
          var action = TargetResource["::get::Assignation::operationProcedure"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Assignation#worker
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Fetches belongsTo relation worker.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Assignation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Worker` object.)
             * </em>
             */
        R.worker = function() {
          var TargetResource = $injector.get("Worker");
          var action = TargetResource["::get::Assignation::worker"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Assignation#registry
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Fetches belongsTo relation registry.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Assignation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Registry` object.)
             * </em>
             */
        R.registry = function() {
          var TargetResource = $injector.get("Registry");
          var action = TargetResource["::get::Assignation::registry"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Assignation.createdByUser
     * @header lbServices.Assignation.createdByUser
     * @object
     * @description
     *
     * The object `Assignation.createdByUser` groups methods
     * manipulating `SegaUser` instances related to `Assignation`.
     *
     * Call {@link lbServices.Assignation#createdByUser Assignation.createdByUser()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Assignation#createManydByUser
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Assignation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createManydByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Assignation::createManydByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Assignation#createdByUser
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Assignation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createdByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Assignation::createdByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Assignation#updatedByUser
             * @methodOf lbServices.Assignation
             *
             * @description
             *
             * Fetches belongsTo relation updatedByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Assignation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.updatedByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Assignation::updatedByUser"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Fleet
 * @header lbServices.Fleet
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Fleet` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Fleet",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Fleets/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Fleet#create
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Fleets",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fleet#patchOrCreate
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Fleets",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fleet#replaceOrCreate
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Fleets/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fleet#upsertWithWhere
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Fleets/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fleet#exists
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Fleets/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fleet#findById
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Fleets/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fleet#replaceById
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Fleets/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fleet#find
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Fleets",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fleet#findOne
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Fleets/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fleet#updateAll
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Fleets/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fleet#deleteById
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Fleets/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fleet#count
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Fleets/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fleet#prototype$patchAttributes
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Fleet id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Fleets/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fleet#createChangeStream
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Fleets/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fleet#createMany
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Fleets",
              method: "POST",
            },

            // INTERNAL. Use Vehicle.fleet() instead.
            "::get::Vehicle::fleet": {
              url: urlBase + "/Vehicles/:id/fleet",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Fleet#upsert
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Fleet#updateOrCreate
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Fleet#patchOrCreateWithWhere
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Fleet#update
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Fleet#destroyById
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Fleet#removeById
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Fleet#prototype$updateAttributes
             * @methodOf lbServices.Fleet
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Fleet id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fleet` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Fleet#modelName
        * @propertyOf lbServices.Fleet
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Fleet`.
        */
        R.modelName = "Fleet";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Cronology
 * @header lbServices.Cronology
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Cronology` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Cronology",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Cronologies/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Cronology.operation() instead.
            "prototype$__get__operation": {
              url: urlBase + "/Cronologies/:id/operation",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#prototype$__get__source
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Fetches belongsTo relation source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cronology id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
            "prototype$__get__source": {
              url: urlBase + "/Cronologies/:id/source",
              method: "GET",
            },

            // INTERNAL. Use Cronology.createdByUser() instead.
            "prototype$__get__createdByUser": {
              url: urlBase + "/Cronologies/:id/createdByUser",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#create
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Cronologies",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#patchOrCreate
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Cronologies",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#replaceOrCreate
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Cronologies/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#upsertWithWhere
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Cronologies/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#exists
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Cronologies/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#findById
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Cronologies/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#replaceById
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Cronologies/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#find
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Cronologies",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#findOne
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Cronologies/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#updateAll
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Cronologies/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#deleteById
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Cronologies/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#count
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Cronologies/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#prototype$patchAttributes
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cronology id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Cronologies/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#createChangeStream
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Cronologies/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cronology#createMany
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Cronologies",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Cronology#upsert
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Cronology#updateOrCreate
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Cronology#patchOrCreateWithWhere
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Cronology#update
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Cronology#destroyById
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cronology#removeById
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cronology#prototype$updateAttributes
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cronology id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cronology` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Cronology#modelName
        * @propertyOf lbServices.Cronology
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Cronology`.
        */
        R.modelName = "Cronology";


            /**
             * @ngdoc method
             * @name lbServices.Cronology#operation
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Fetches belongsTo relation operation.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cronology id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
        R.operation = function() {
          var TargetResource = $injector.get("Operation");
          var action = TargetResource["::get::Cronology::operation"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Cronology.createdByUser
     * @header lbServices.Cronology.createdByUser
     * @object
     * @description
     *
     * The object `Cronology.createdByUser` groups methods
     * manipulating `SegaUser` instances related to `Cronology`.
     *
     * Call {@link lbServices.Cronology#createdByUser Cronology.createdByUser()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Cronology#createManydByUser
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cronology id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createManydByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Cronology::createManydByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Cronology#createdByUser
             * @methodOf lbServices.Cronology
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cronology id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createdByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Cronology::createdByUser"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Task
 * @header lbServices.Task
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Task` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Task",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Tasks/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Task.employee() instead.
            "prototype$__get__employee": {
              url: urlBase + "/Tasks/:id/employee",
              method: "GET",
            },

            // INTERNAL. Use Task.operation() instead.
            "prototype$__get__operation": {
              url: urlBase + "/Tasks/:id/operation",
              method: "GET",
            },

            // INTERNAL. Use Task.createdByUser() instead.
            "prototype$__get__createdByUser": {
              url: urlBase + "/Tasks/:id/createdByUser",
              method: "GET",
            },

            // INTERNAL. Use Task.updatedByUser() instead.
            "prototype$__get__updatedByUser": {
              url: urlBase + "/Tasks/:id/updatedByUser",
              method: "GET",
            },

            // INTERNAL. Use Task.completedByUser() instead.
            "prototype$__get__completedByUser": {
              url: urlBase + "/Tasks/:id/completedByUser",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#create
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Tasks",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#patchOrCreate
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Tasks",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#replaceOrCreate
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Tasks/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#upsertWithWhere
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Tasks/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#exists
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Tasks/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#findById
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Tasks/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#replaceById
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Tasks/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#find
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Tasks",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#findOne
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Tasks/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#updateAll
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Tasks/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#deleteById
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Tasks/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#count
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Tasks/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#prototype$patchAttributes
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Task id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Tasks/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#createChangeStream
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Tasks/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#changeDueDate
             * @methodOf lbServices.Task
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ids` – `{*}` - Task ids
             *
             *  - `newDueDate` – `{date}` - New due date
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changeDueDate": {
              url: urlBase + "/Tasks/due-date",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#complete
             * @methodOf lbServices.Task
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ids` – `{*}` - Task ids
             *
             *  - `comments` – `{string}` - Comments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "complete": {
              url: urlBase + "/Tasks/complete",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#createMulti
             * @methodOf lbServices.Task
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `employeeIds` – `{*}` -
             *
             *  - `dueDate` – `{date}` -
             *
             *  - `description` – `{string}` -
             *
             *  - `operationId` – `{number=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "createMulti": {
              isArray: true,
              url: urlBase + "/Tasks/create-multi",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#createMany
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Tasks",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Task#upsert
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Task#updateOrCreate
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Task#patchOrCreateWithWhere
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Task#update
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Task#destroyById
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Task#removeById
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Task#prototype$updateAttributes
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Task id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Task#modelName
        * @propertyOf lbServices.Task
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Task`.
        */
        R.modelName = "Task";


            /**
             * @ngdoc method
             * @name lbServices.Task#employee
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Fetches belongsTo relation employee.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Task id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Employee` object.)
             * </em>
             */
        R.employee = function() {
          var TargetResource = $injector.get("Employee");
          var action = TargetResource["::get::Task::employee"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Task#operation
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Fetches belongsTo relation operation.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Task id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Operation` object.)
             * </em>
             */
        R.operation = function() {
          var TargetResource = $injector.get("Operation");
          var action = TargetResource["::get::Task::operation"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Task.createdByUser
     * @header lbServices.Task.createdByUser
     * @object
     * @description
     *
     * The object `Task.createdByUser` groups methods
     * manipulating `SegaUser` instances related to `Task`.
     *
     * Call {@link lbServices.Task#createdByUser Task.createdByUser()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Task#createManydByUser
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Task id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createManydByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Task::createManydByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Task#createdByUser
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Fetches belongsTo relation createdByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Task id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.createdByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Task::createdByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Task#updatedByUser
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Fetches belongsTo relation updatedByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Task id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.updatedByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Task::updatedByUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Task#completedByUser
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Fetches belongsTo relation completedByUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Task id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SegaUser` object.)
             * </em>
             */
        R.completedByUser = function() {
          var TargetResource = $injector.get("SegaUser");
          var action = TargetResource["::get::Task::completedByUser"];
          return action.apply(R, arguments);
        };


        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && config.url.indexOf(urlBaseHost) === -1) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);
